(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7747],{

/***/ 8712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ CheckoutCvvInputInfo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16216);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15861);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44012);
/* harmony import */ var _mui_icons_material_InfoOutlined__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2548);
/* harmony import */ var _theme_typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43795);





var CheckoutCvvInputInfo = function() {
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        direction: "row",
        spacing: "8px",
        sx: {
            alignItems: "center",
            marginTop: {
                mobile: "7px",
                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_1__/* .pxToRem */ .Q)(4)
            }
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_InfoOutlined__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                sx: {
                    color: theme.palette.typography.color.muted,
                    width: "16px",
                    height: "16px"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                component: "span",
                sx: {
                    textAlign: "left",
                    fontSize: "13px",
                    color: theme.palette.typography.color.muted
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    id: "my_credit_cards.supported_cvvs"
                })
            })
        ]
    });
};


/***/ }),

/***/ 55178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Umbrella": function() { return /* binding */ Umbrella; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/logic/state/index.ts + 18 modules
var state = __webpack_require__(42125);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var components_message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/theme/typography.ts
var typography = __webpack_require__(43795);
// EXTERNAL MODULE: ./src/components/shared/image-box-future.tsx
var image_box_future = __webpack_require__(58718);
;// CONCATENATED MODULE: ./src/components/stand-alone/ad-block-dialog.tsx





var AdBlockIcon = "/icons/dialog/ad-block-icon.svg";
var AdBlockDialog = function() {
    var theme = (0,useTheme/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
            textAlign: "center"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                img: AdBlockIcon,
                title: intl.formatMessage({
                    id: "alt.ad.block"
                }),
                objectFit: "contain",
                sx: {
                    marginTop: (0,typography/* pxToRem */.Q)(72),
                    height: (0,typography/* pxToRem */.Q)(108),
                    width: (0,typography/* pxToRem */.Q)(108)
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                sx: {
                    marginTop: (0,typography/* pxToRem */.Q)(24),
                    fontSize: (0,typography/* pxToRem */.Q)(22),
                    fontWeight: "700",
                    lineHeight: "33px",
                    color: theme.palette.grey[90]
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                    id: "dialog.ad.block.title"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                sx: {
                    marginTop: (0,typography/* pxToRem */.Q)(24),
                    fontSize: (0,typography/* pxToRem */.Q)(18),
                    fontWeight: "400",
                    lineHeight: "27px",
                    color: theme.palette.grey[70],
                    maxWidth: "80%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                    id: "dialog.ad.block.description"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "contained",
                sx: {
                    marginTop: {
                        mobile: "40px",
                        tablet: (0,typography/* pxToRem */.Q)(40)
                    }
                },
                onClick: function() {
                    return window.location.reload();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                    id: "dialog.action.button"
                })
            })
        ]
    });
};
/* harmony default export */ var ad_block_dialog = (AdBlockDialog);

// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(16216);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(54799);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(37645);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(6514);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogActions/DialogActions.js + 1 modules
var DialogActions = __webpack_require__(31425);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/logic/services/index.ts + 21 modules
var services = __webpack_require__(10029);
// EXTERNAL MODULE: ./node_modules/@mui/lab/LoadingButton/LoadingButton.js + 1 modules
var LoadingButton = __webpack_require__(31812);
// EXTERNAL MODULE: ./src/logic/helpers/format-price.ts
var format_price = __webpack_require__(34658);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./src/components/shared/close-button.tsx
var close_button = __webpack_require__(4997);
;// CONCATENATED MODULE: ./src/components/checkout/apply-multi-voucher-dialog.tsx















var voucherTicketIcon = "/icons/checkout/voucher-ticket-icon.svg";
var SubTitle = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
        variant: "subtitle1",
        sx: function(theme) {
            return {
                fontSize: {
                    mobile: "12px",
                    tablet: (0,typography/* pxToRem */.Q)(16),
                    color: theme.palette.grey[50]
                }
            };
        },
        children: children
    });
};
var BoldTypo = function(param) {
    var children = param.children, sx = param.sx;
    var theme = (0,useTheme/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
        variant: "h6",
        sx: (0,_object_spread/* default */.Z)({
            fontSize: {
                mobile: "12px",
                tablet: (0,typography/* pxToRem */.Q)(16)
            },
            fontWeight: 700,
            color: theme.palette.grey[80]
        }, sx),
        children: children
    });
};
var QuantityBtnGroup = function(param) {
    var quantity = param.quantity, setQuantity = param.setQuantity, isCalculating = param.isCalculating;
    var handleIncrease = function() {
        setQuantity(quantity + 1);
    };
    var handleDecrease = function() {
        return setQuantity(Math.max(1, quantity - 1));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center",
        sx: function(theme) {
            return {
                borderRadius: "12px",
                backgroundColor: theme.palette.lightGrey.main,
                width: (0,typography/* pxToRem */.Q)(130),
                paddingY: "10px"
            };
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                disabled: isCalculating,
                onClick: handleDecrease,
                sx: function(theme) {
                    return {
                        color: theme.palette.error.main,
                        width: "40px",
                        height: "40px"
                    };
                },
                children: "-"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                children: quantity
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                disabled: isCalculating,
                onClick: handleIncrease,
                sx: function(theme) {
                    return {
                        color: theme.palette.success.main,
                        width: "40px",
                        height: "40px"
                    };
                },
                children: "+"
            })
        ]
    });
};
var ApplyMultiVoucherDialog = function() {
    var ref, ref1, ref2, ref3;
    var theme = (0,useTheme/* default */.Z)();
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,state/* useDialog */.Rh)(function(s) {
        return [
            s.dialog,
            s.setDialog
        ];
    }, shallow/* default */.Z), 2), dialog = ref4[0], setDialog = ref4[1];
    var setSnack = (0,state/* useSnack */.eW)(function(s) {
        return s.setSnack;
    }, shallow/* default */.Z);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,state/* useOrder */.Aj)(function(s) {
        return [
            s.order
        ];
    }, shallow/* default */.Z), 1), order = ref5[0];
    var intl = (0,useIntl/* default */.Z)();
    var ref6 = (0,react.useState)(1), requiredQuantity = ref6[0], setRequiredQuantity = ref6[1];
    var ref7 = (0,react.useState)(1), actualQuantity = ref7[0], setActualQuantity = ref7[1];
    var ref8 = (0,react.useState)(dialog === null || dialog === void 0 ? void 0 : (ref = dialog.applyMultiVoucherDialogPayload) === null || ref === void 0 ? void 0 : ref.initialState), voucherDetails = ref8[0], setVoucherDetails = ref8[1];
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var handleCloseClick = function() {
        return setDialog({});
    };
    var ref9 = (0,services/* useCalculateMultipleVoucher */.m$)({
        query: {
            orderId: order === null || order === void 0 ? void 0 : order.id
        },
        params: {
            barCode: dialog === null || dialog === void 0 ? void 0 : (ref1 = dialog.applyMultiVoucherDialogPayload) === null || ref1 === void 0 ? void 0 : ref1.barCode,
            quantity: requiredQuantity
        }
    }, {
        staleTime: 60 * 1000,
        refetchOnMount: "always",
        onError: function(err) {
            if (requiredQuantity < actualQuantity) {
                setActualQuantity(requiredQuantity);
            } else {
                setRequiredQuantity(actualQuantity);
            }
        }
    }), data = ref9.data, isCalculating = ref9.isFetching, isError = ref9.isError;
    (0,react.useEffect)(function() {
        // clear cache after remount
        queryClient.invalidateQueries({
            predicate: function(query) {
                var ref;
                return ((ref = query.queryKey[0]) === null || ref === void 0 ? void 0 : ref.url) === services/* calculateBaseUrl */.Dy;
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        if ((data === null || data === void 0 ? void 0 : data.availableNumOfUse) && !isError && !isCalculating) {
            setVoucherDetails(data);
            setActualQuantity(requiredQuantity);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        data,
        isCalculating,
        isError
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(close_button/* CloseButton */.P, {
                    handleClick: handleCloseClick
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        margin: "auto"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: theme.palette.grey[90],
                                fontSize: (0,typography/* pxToRem */.Q)(22),
                                fontWeight: 700,
                                lineHeight: "33px",
                                marginBottom: (0,typography/* pxToRem */.Q)(24)
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                id: "voucher.multi.dialog.title"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            spacing: 2,
                            sx: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                        direction: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                                                img: voucherTicketIcon,
                                                title: intl.formatMessage({
                                                    id: "alt.voucher_ticketI_icon"
                                                }),
                                                objectFit: "contain",
                                                sx: {
                                                    width: (0,typography/* pxToRem */.Q)(59),
                                                    height: (0,typography/* pxToRem */.Q)(48)
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BoldTypo, {
                                                sx: {
                                                    marginLeft: (0,typography/* pxToRem */.Q)(16)
                                                },
                                                children: [
                                                    "(",
                                                    order === null || order === void 0 ? void 0 : order.numOfSeats,
                                                    ") ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                        id: "voucher.selected_seats"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    direction: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                id: "voucher.applied"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BoldTypo, {
                                            variant: "subtitle1",
                                            children: (0,format_price/* formatPrice */.T)(voucherDetails === null || voucherDetails === void 0 ? void 0 : voucherDetails.discountAmount, intl)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    direction: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                id: "voucher.uses_left"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BoldTypo, {
                                            variant: "subtitle1",
                                            children: voucherDetails === null || voucherDetails === void 0 ? void 0 : voucherDetails.availableNumOfUse
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    direction: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BoldTypo, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                id: "voucher.usage_count_prompt"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityBtnGroup, {
                                            quantity: actualQuantity,
                                            setQuantity: setRequiredQuantity,
                                            isCalculating: isCalculating
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                    variant: "contained",
                    fullWidth: true,
                    loading: isCalculating || (dialog === null || dialog === void 0 ? void 0 : (ref2 = dialog.applyMultiVoucherDialogPayload) === null || ref2 === void 0 ? void 0 : ref2.isSubmitting),
                    disabled: isCalculating || (dialog === null || dialog === void 0 ? void 0 : (ref3 = dialog.applyMultiVoucherDialogPayload) === null || ref3 === void 0 ? void 0 : ref3.isSubmitting),
                    onClick: function() {
                        var ref;
                        dialog === null || dialog === void 0 ? void 0 : (ref = dialog.applyMultiVoucherDialogPayload) === null || ref === void 0 ? void 0 : ref.handleSubmitVoucher(actualQuantity);
                    },
                    sx: {
                        fontSize: "16px",
                        height: {
                            tablet: (0,typography/* pxToRem */.Q)(56),
                            mobile: "56px"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                        id: "voucher.apply"
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js
var TextField = __webpack_require__(22715);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormHelperText/FormHelperText.js + 1 modules
var FormHelperText = __webpack_require__(56815);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(50480);
// EXTERNAL MODULE: ./node_modules/@mui/material/Checkbox/Checkbox.js + 4 modules
var Checkbox = __webpack_require__(69368);
// EXTERNAL MODULE: ./node_modules/@mui/material/Slide/Slide.js
var Slide = __webpack_require__(54776);
// EXTERNAL MODULE: ./src/logic/state/offers/index.ts
var offers = __webpack_require__(91393);
// EXTERNAL MODULE: ./src/components/offers/offer-badge.tsx + 1 modules
var offer_badge = __webpack_require__(50201);
// EXTERNAL MODULE: ./src/lotties/muvi_offer.json
var muvi_offer = __webpack_require__(45305);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/components/shared/backward-button.tsx
var backward_button = __webpack_require__(7969);
;// CONCATENATED MODULE: ./src/components/offers/offer-terms-and-conditions.tsx






var OfferTermsAndConditions = function(param) {
    var termsConditions = param.termsConditions, handleBackwardClick = param.handleBackwardClick;
    var theme = (0,useTheme/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(backward_button/* BackwardButton */.e, {
                    handleClick: handleBackwardClick
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            width: "90%",
                            margin: "auto"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                sx: {
                                    textAlign: "center",
                                    mt: "26px",
                                    fontWeight: 700,
                                    fontSize: {
                                        mobile: "18px",
                                        tablet: (0,typography/* pxToRem */.Q)(22)
                                    },
                                    lineHeight: "30px",
                                    mb: {
                                        tablet: (0,typography/* pxToRem */.Q)(24),
                                        mobile: "20px"
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                    id: "terms.and.conditions"
                                })
                            }),
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            marginBlockEnd: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            id: "offer-terms-text",
                            component: "p",
                            dangerouslySetInnerHTML: {
                                __html: termsConditions
                            },
                            sx: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("tablet"), {
                                fontSize: "16px !important",
                                "& span,p,a,q,div,b ,strong ,i ,em ,mark ,small,del,ins ,sub,sup": {
                                    fontSize: "16px !important"
                                },
                                "& h1 ,h2": {
                                    fontSize: "18px !important",
                                    "& span": {
                                        fontSize: "18px !important"
                                    }
                                },
                                "& h3 ,h4": {
                                    fontSize: "17px !important",
                                    "& span": {
                                        fontSize: "17px !important"
                                    }
                                }
                            })
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@alpha.apps/react-common/dist/index.js + 6 modules
var dist = __webpack_require__(46080);
// EXTERNAL MODULE: ./src/logic/hooks/index.ts + 27 modules
var hooks = __webpack_require__(7663);
// EXTERNAL MODULE: ./src/logic/state/dialog/index.ts
var state_dialog = __webpack_require__(36343);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/logic/services/offers/index.ts + 1 modules
var services_offers = __webpack_require__(25651);
// EXTERNAL MODULE: ./node_modules/luxon/src/luxon.js + 23 modules
var luxon = __webpack_require__(30120);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./src/logic/shared/index.ts + 4 modules
var shared = __webpack_require__(946);
// EXTERNAL MODULE: ./src/constants/phone-numbers.ts
var phone_numbers = __webpack_require__(22010);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/constants/regular-expressions.ts
var regular_expressions = __webpack_require__(43902);
// EXTERNAL MODULE: ./src/components/shared/add-credit-card/credit-card-expiry-date-input.tsx
var credit_card_expiry_date_input = __webpack_require__(57197);
;// CONCATENATED MODULE: ./src/components/offers/apply-offer-dialog.tsx































var CheckBoxLabel = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
        component: "div",
        sx: function(theme) {
            return {
                color: theme.palette.typography.color.muted,
                fontWeight: 400,
                whiteSpace: "nowrap",
                fontSize: {
                    tablet: (0,typography/* pxToRem */.Q)(13),
                    mobile: "14px"
                }
            };
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "global.i_agree"
        })
    });
};
var MuiPhoneNumber = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3626), __webpack_require__.e(6343)]).then(__webpack_require__.t.bind(__webpack_require__, 61803, 23)).then(function(component) {
        return component.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61803)
            ];
        }
    },
    ssr: false
});
var ApplyOfferDialog = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
    var theme = (0,useTheme/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    var formatMessage = (0,useIntl/* default */.Z)().formatMessage;
    var ref17 = (0,react.useState)(false), AgreeOnTerms = ref17[0], setAgreeOnTerms = ref17[1];
    var push = (0,next_router.useRouter)().push;
    var cityId = (0,hooks/* useBookingFlowCity */.Zx)().cityId;
    var ref18 = (0,react.useState)("KSA"), countryCode_contact = ref18[0], setCountryCode_contact = ref18[1];
    var ref19 = (0,react.useState)(null), selectedCountry = ref19[0], setSelectedCountry = ref19[1];
    var ref20 = (0,_sliced_to_array/* default */.Z)((0,state_dialog/* useDialog */.R)(function(s) {
        return [
            s.dialog,
            s.setDialog
        ];
    }, shallow/* default */.Z), 2), dialog = ref20[0], setDialog = ref20[1];
    var ref21 = (0,react.useState)(false), isShowTC = ref21[0], setIsShowTC = ref21[1];
    var ref22 = dialog === null || dialog === void 0 ? void 0 : dialog.applyOfferDialogPayload, offer = ref22.offer, movieId = ref22.movieId, movieSlug = ref22.movieSlug, sessionId = ref22.sessionId, isAfterMidnight = ref22.isAfterMidnight, isThreeD = ref22.isThreeD;
    var ref23 = (0,_sliced_to_array/* default */.Z)((0,offers/* useVerifiedOffer */.s$)(function(s) {
        return [
            s.verifiedOffer,
            s.setVerifiedOffer
        ];
    }, shallow/* default */.Z), 2), verifiedOffer = ref23[0], setVerifiedOffer = ref23[1];
    var ref24 = (0,_sliced_to_array/* default */.Z)((0,offers/* useVerifiedOfferBin */.mN)(function(s) {
        return [
            s.setVerifiedOfferBin,
            s.setVerifiedOfferLast4Bin,
            s.setVerifiedOfferExpiryMonth,
            s.setVerifiedOfferExpiryYear, 
        ];
    }, shallow/* default */.Z), 4), setVerifiedOfferBin = ref24[0], setVerifiedOfferLast4Bin = ref24[1], setVerifiedOfferExpiryMonth = ref24[2], setVerifiedOfferExpiryYear = ref24[3];
    var ref25 = (0,_sliced_to_array/* default */.Z)((0,offers/* useVerifiedUnipalOffer */.Sz)(function(s) {
        return [
            s.setVerifiedUnipalOffer
        ];
    }, shallow/* default */.Z), 1), setVerifiedUnipalOffer = ref25[0];
    var ref26 = (0,hooks/* useOfferHandler */.P0)(offer), isBankOffer = ref26.isBankOffer, isOfferVerified = ref26.isOfferVerified, offerTitle = ref26.offerTitle, handleDeleteOffer = ref26.handleDeleteOffer, isUnipalOffer = ref26.isUnipalOffer, isNoneOffer = ref26.isNoneOffer, isCardOffer = ref26.isCardOffer;
    var checkPhoneNumber = (0,services/* useCheckVerifyPhoneNumber */.K4)();
    var ref27 = (0,react.useState)(""), binNumber = ref27[0], setBinNumber = ref27[1];
    var ref28 = (0,react.useState)(""), last4BinNumber = ref28[0], setLast4BinNumber = ref28[1];
    var last4BinNumberRef = (0,react.useRef)(null);
    var canSelectSeats = isNoneOffer || (isBankOffer || isUnipalOffer || isCardOffer) && isOfferVerified;
    var schema = es/* object */.Ry({
        expiryDate: es/* date */.hT().when("isBankOffer || isCardOffer", {
            is: function() {
                return isBankOffer || isCardOffer;
            },
            then: es/* date */.hT().required().min(luxon/* DateTime.now */.ou.now().toFormat("yyyy-MM"), intl.formatMessage({
                id: "my_credit_cards.expiry_date.invalid"
            })).max(luxon/* DateTime.now */.ou.now().plus({
                years: 20
            }).toFormat("yyyy-MM"), intl.formatMessage({
                id: "my_credit_cards.expiry_date.invalid"
            })).typeError(intl.formatMessage({
                id: "my_credit_cards.expiry_date.invalid"
            })).nullable()
        }),
        unipalPhoneNumber: es/* string */.Z_().when("isUnipalOffer", {
            is: function() {
                return isUnipalOffer;
            },
            then: es/* string */.Z_().test("test-valid-phone", intl.formatMessage({
                id: "global.phoneNumber.notValid"
            }), function(value) {
                if (!!value) {
                    return (0,shared/* checkIfPhoneNumberIsValid */._5)(value, countryCode_contact);
                }
            })
        }),
        unipalCode: es/* string */.Z_().when("isUnipalOffer", {
            is: function() {
                return isUnipalOffer;
            },
            then: es/* string */.Z_().test("test-unipal-code", intl.formatMessage({
                id: "offers.unipal.errors"
            }), function(value) {
                return regular_expressions/* preventEmptyString.test */.hW.test(value);
            })
        })
    });
    var ref29 = (0,index_esm/* useForm */.cI)({
        resolver: (0,yup/* yupResolver */.X)(schema),
        mode: "onChange",
        reValidateMode: "onChange",
        defaultValues: {
            expiryDate: null,
            unipalPhoneNumber: "",
            unipalCode: ""
        }
    }), getValues = ref29.getValues, setValue = ref29.setValue, register = ref29.register, trigger = ref29.trigger, setError = ref29.setError, errors = ref29.formState.errors;
    var expiryDateArr = (ref = getValues("expiryDate")) === null || ref === void 0 ? void 0 : ref.split("-");
    var expiryMonth = (expiryDateArr === null || expiryDateArr === void 0 ? void 0 : expiryDateArr.length) > 0 ? expiryDateArr[1] : null;
    var expiryYear = (expiryDateArr === null || expiryDateArr === void 0 ? void 0 : expiryDateArr.length) > 0 ? expiryDateArr[0] : null;
    var ref30 = (0,services_offers/* useVerifyOffer */.d5)({}, {
        onError: function() {
            if (verifiedOffer === null || verifiedOffer === void 0 ? void 0 : verifiedOffer.id) {
                setVerifiedOffer(null);
            }
        }
    }), error = ref30.error, isError = ref30.isError, isLoading = ref30.isLoading, mutate = ref30.mutate;
    var handleBackwardClick = (0,react.useCallback)(function() {
        setIsShowTC(false);
    }, []);
    var openTermsAndConditionsDialog = (0,react.useCallback)(function() {
        setIsShowTC(true);
    }, []);
    var handleVerifyBin = function() {
        mutate({
            query: {
                offerId: offer === null || offer === void 0 ? void 0 : offer.id
            },
            params: (0,_object_spread/* default */.Z)({
                bin: binNumber,
                last4: last4BinNumber,
                expiryMonth: expiryMonth,
                expiryYear: expiryYear,
                cityId: cityId
            }, sessionId ? {
                sessionId: sessionId
            } : {})
        }, {
            onSuccess: function() {
                setVerifiedOffer({
                    id: offer === null || offer === void 0 ? void 0 : offer.id
                });
                setVerifiedOfferBin(binNumber);
                setVerifiedOfferLast4Bin(last4BinNumber);
                setVerifiedOfferExpiryMonth(expiryMonth);
                setVerifiedOfferExpiryYear(expiryYear);
            }
        });
    };
    var handleVerifyUnipal = function() {
        var ref, ref1;
        mutate({
            query: {
                offerId: offer === null || offer === void 0 ? void 0 : offer.id
            },
            params: (0,_object_spread/* default */.Z)({
                code: (ref = getValues()) === null || ref === void 0 ? void 0 : ref.unipalCode,
                phoneNumber: (ref1 = getValues()) === null || ref1 === void 0 ? void 0 : ref1.unipalPhoneNumber,
                cityId: cityId
            }, sessionId ? {
                sessionId: sessionId
            } : {})
        }, {
            onSuccess: function(res) {
                var ref, ref1;
                setVerifiedOffer({
                    id: offer === null || offer === void 0 ? void 0 : offer.id
                });
                setVerifiedUnipalOffer({
                    unipalStudentId: res === null || res === void 0 ? void 0 : res.referenceId,
                    unipalSessionId: res === null || res === void 0 ? void 0 : res.unipalSessionId,
                    unipalPhoneNumber: (ref = getValues()) === null || ref === void 0 ? void 0 : ref.unipalPhoneNumber,
                    unipalCode: (ref1 = getValues()) === null || ref1 === void 0 ? void 0 : ref1.unipalCode
                });
            }
        });
    };
    var handleApplyOffer = function() {
        setVerifiedOffer({
            id: offer === null || offer === void 0 ? void 0 : offer.id,
            isBankOfferApplied: isBankOffer,
            isUnipalOfferApplied: isUnipalOffer,
            isCardOfferApplied: isCardOffer
        });
        // accessed from movie details
        if (!sessionId) {
            push("/movies/".concat(movieSlug, "?offerId=").concat(offer === null || offer === void 0 ? void 0 : offer.id, "&cityId=").concat(cityId));
            setDialog({});
            return;
        }
        setDialog({
            wrapper: true,
            isRulesOfEntryDialog: true,
            rulesOfEntryDialogPayload: {
                sessionId: sessionId,
                movieId: movieId,
                movieSlug: movieSlug,
                isAfterMidnight: isAfterMidnight,
                isThreeD: isThreeD,
                offerId: offer === null || offer === void 0 ? void 0 : offer.id
            }
        });
    };
    var regex = /^[0-9]*$/;
    var handleChangeBin = function(e) {
        if (regex.test(e.target.value) && e.target.value.length <= (offer === null || offer === void 0 ? void 0 : offer.binLimit)) {
            setBinNumber(e.target.value);
            if (e.target.value.length === (offer === null || offer === void 0 ? void 0 : offer.binLimit)) {
                var ref;
                (ref = last4BinNumberRef.current) === null || ref === void 0 ? void 0 : ref.focus();
            }
        }
    };
    var handleChangeLast4Bin = function(e) {
        if (e.target.value.length <= 4) {
            setLast4BinNumber(e.target.value);
        }
    };
    var handleCloseDialog = function() {
        setDialog({});
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isShowTC && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(close_button/* CloseButton */.P, {
                            handleClick: handleCloseDialog
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                margin: "auto"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    component: "h4",
                                    sx: {
                                        textAlign: "center",
                                        fontWeight: 700,
                                        fontSize: {
                                            tablet: (0,typography/* pxToRem */.Q)(22),
                                            mobile: "18px"
                                        },
                                        mb: {
                                            tablet: (0,typography/* pxToRem */.Q)(32),
                                            mobile: "24px"
                                        },
                                        mt: {
                                            tablet: (0,typography/* pxToRem */.Q)(30),
                                            mobile: "24px"
                                        },
                                        color: theme.palette.grey[90],
                                        width: "100%"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                        id: "offers.apply_offer"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    component: "div",
                                    sx: {
                                        mb: {
                                            tablet: (0,typography/* pxToRem */.Q)(16),
                                            mobile: "24px"
                                        },
                                        display: "flex",
                                        alignItems: "center"
                                    },
                                    children: [
                                        (offer === null || offer === void 0 ? void 0 : offer.logoUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                                            img: offer === null || offer === void 0 ? void 0 : offer.logoUrl,
                                            title: (offer === null || offer === void 0 ? void 0 : offer.logoUrlAlt) || intl.formatMessage({
                                                id: "alt.offer_logo"
                                            }),
                                            layout: "intrinsic",
                                            objectFit: "contain",
                                            width: "524px",
                                            height: "294px",
                                            sx: {
                                                width: {
                                                    mobile: "92px",
                                                    tablet: (0,typography/* pxToRem */.Q)(100)
                                                },
                                                marginRight: {
                                                    mobile: "16px",
                                                    tablet: (0,typography/* pxToRem */.Q)(16)
                                                },
                                                borderRadius: "5px",
                                                overflow: "hidden"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            component: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    component: "h5",
                                                    sx: {
                                                        fontWeight: 700,
                                                        fontSize: {
                                                            tablet: (0,typography/* pxToRem */.Q)(16),
                                                            mobile: "14px"
                                                        },
                                                        color: theme.palette.grey[80]
                                                    },
                                                    children: isBankOffer || isCardOffer ? offer === null || offer === void 0 ? void 0 : offer.bankName : offer === null || offer === void 0 ? void 0 : offer.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    component: "p",
                                                    sx: {
                                                        fontSize: {
                                                            tablet: (0,typography/* pxToRem */.Q)(14),
                                                            mobile: "13px"
                                                        },
                                                        color: theme.palette.grey[50]
                                                    },
                                                    children: isBankOffer || isCardOffer ? offer === null || offer === void 0 ? void 0 : offer.title : offer === null || offer === void 0 ? void 0 : offer.hint
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                isUnipalOffer && !isOfferVerified && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            component: "p",
                                            sx: {
                                                fontSize: {
                                                    mobile: "14px",
                                                    tablet: (0,typography/* pxToRem */.Q)(16)
                                                },
                                                color: theme.palette.grey[60],
                                                marginBottom: {
                                                    mobile: "16px",
                                                    tablet: (0,typography/* pxToRem */.Q)(20)
                                                }
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                id: "offers.unipal.description"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MuiPhoneNumber, {
                                            excludeCountries: phone_numbers/* excludedCountriesList */.o,
                                            id: "offer-unipal-phone-number",
                                            defaultCountry: "sa",
                                            dir: "ltr",
                                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                id: "global.phone_number"
                                            }),
                                            variant: "outlined",
                                            onChange: function(e, country) {
                                                var ref;
                                                setError("unipalPhoneNumber", {});
                                                setSelectedCountry(country);
                                                var field = "unipalPhoneNumber";
                                                var c = country === null || country === void 0 ? void 0 : (ref = country.countryCode) === null || ref === void 0 ? void 0 : ref.toString().toUpperCase();
                                                if (field.includes("contact")) {
                                                    setCountryCode_contact(c);
                                                }
                                                setValue("unipalPhoneNumber", e);
                                                trigger("unipalPhoneNumber");
                                            },
                                            value: ((ref1 = getValues()) === null || ref1 === void 0 ? void 0 : ref1.unipalPhoneNumber) || "",
                                            error: Boolean(errors === null || errors === void 0 ? void 0 : errors.unipalPhoneNumber),
                                            disabled: checkPhoneNumber === null || checkPhoneNumber === void 0 ? void 0 : checkPhoneNumber.isLoading,
                                            InputProps: {
                                                autoComplete: "off"
                                            },
                                            sx: {
                                                mb: 2.5,
                                                " & .MuiButtonBase-root ": {
                                                    "& svg": {
                                                        height: "1em"
                                                    }
                                                },
                                                legend: {
                                                    width: 0
                                                }
                                            },
                                            InputLabelProps: {
                                                sx: {
                                                    backgroundColor: "white",
                                                    paddingInline: "6px"
                                                }
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                            id: "offer-unipal-code",
                                            type: "text",
                                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                id: "offers.unipal.code"
                                            }),
                                            disabled: isLoading,
                                            variant: "outlined",
                                            onChange: function(e) {
                                                setValue("unipalCode", e.target.value);
                                                trigger("unipalCode");
                                            },
                                            value: (ref2 = getValues()) === null || ref2 === void 0 ? void 0 : ref2.unipalCode,
                                            sx: {
                                                width: "100%",
                                                fontSize: {
                                                    tablet: (0,typography/* pxToRem */.Q)(16),
                                                    mobile: "16px"
                                                },
                                                color: theme.palette.grey[50],
                                                "& input": {
                                                    p: "15px"
                                                }
                                            },
                                            error: !!(errors === null || errors === void 0 ? void 0 : errors.unipalCode)
                                        }),
                                        (isError || (errors === null || errors === void 0 ? void 0 : errors.unipalPhoneNumber) || (errors === null || errors === void 0 ? void 0 : errors.unipalCode)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                                            error: true,
                                            sx: {
                                                fontSize: {
                                                    mobile: "14px",
                                                    tablet: (0,typography/* pxToRem */.Q)(16)
                                                }
                                            },
                                            children: (error === null || error === void 0 ? void 0 : (ref3 = error.response) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.message) || (errors === null || errors === void 0 ? void 0 : (ref5 = errors.unipalPhoneNumber) === null || ref5 === void 0 ? void 0 : ref5.message) || (errors === null || errors === void 0 ? void 0 : (ref6 = errors.unipalCode) === null || ref6 === void 0 ? void 0 : ref6.message)
                                        })
                                    ]
                                }),
                                (isBankOffer || isCardOffer) && !isOfferVerified && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            component: "p",
                                            sx: {
                                                fontSize: {
                                                    mobile: "14px",
                                                    tablet: (0,typography/* pxToRem */.Q)(16)
                                                },
                                                color: theme.palette.grey[60],
                                                marginBottom: {
                                                    mobile: "16px",
                                                    tablet: (0,typography/* pxToRem */.Q)(20)
                                                }
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                    id: "offers.enter_the_first"
                                                }),
                                                "\xa0",
                                                offer === null || offer === void 0 ? void 0 : offer.binLimit,
                                                "\xa0",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                    id: "offers.digits"
                                                }),
                                                "\xa0",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                    id: "offers.enter_the_last"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            container: true,
                                            dir: "ltr",
                                            rowSpacing: {
                                                mobile: "8px",
                                                tablet: (0,typography/* pxToRem */.Q)(8)
                                            },
                                            sx: {
                                                alignItems: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                item: true,
                                                mobile: 12,
                                                tablet: 12,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                        direction: "row",
                                                        sx: {
                                                            alignItems: "center"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                                id: "offer-verified-number",
                                                                type: "number",
                                                                inputMode: "numeric",
                                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                                    id: "my_credit_cards.card_number"
                                                                }),
                                                                placeholder: (offer === null || offer === void 0 ? void 0 : offer.binLimit) === 4 ? "1234" : (offer === null || offer === void 0 ? void 0 : offer.binLimit) === 6 ? "123456" : "12345678",
                                                                disabled: isLoading,
                                                                variant: "outlined",
                                                                value: binNumber,
                                                                onKeyDown: function(e) {
                                                                    (0,dist/* preventInvalidChars */.t4)(e, [
                                                                        "e",
                                                                        "E",
                                                                        "+",
                                                                        "-",
                                                                        "."
                                                                    ]);
                                                                    (0,shared/* acceptOnlyNumberOnSafari */.AN)(e);
                                                                },
                                                                onChange: handleChangeBin,
                                                                sx: {
                                                                    width: "100%",
                                                                    fontSize: {
                                                                        tablet: (0,typography/* pxToRem */.Q)(16),
                                                                        mobile: "16px"
                                                                    },
                                                                    color: theme.palette.grey[50],
                                                                    "& input": {
                                                                        p: "15px"
                                                                    }
                                                                },
                                                                error: isError,
                                                                InputLabelProps: {
                                                                    shrink: true
                                                                },
                                                                inputProps: {
                                                                    inputMode: "numeric"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                component: "span",
                                                                sx: {
                                                                    marginX: {
                                                                        mobile: "8px",
                                                                        tablet: (0,typography/* pxToRem */.Q)(8)
                                                                    },
                                                                    color: theme.palette.typography.color.muted
                                                                },
                                                                children: "******"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                                id: "offer-verified-last4-number",
                                                                type: "number",
                                                                inputMode: "numeric",
                                                                placeholder: "1234",
                                                                inputRef: last4BinNumberRef,
                                                                disabled: isLoading,
                                                                variant: "outlined",
                                                                value: last4BinNumber,
                                                                onKeyDown: function(e) {
                                                                    (0,dist/* preventInvalidChars */.t4)(e, [
                                                                        "e",
                                                                        "E",
                                                                        "+",
                                                                        "-",
                                                                        "."
                                                                    ]);
                                                                    (0,shared/* acceptOnlyNumberOnSafari */.AN)(e);
                                                                },
                                                                onChange: handleChangeLast4Bin,
                                                                sx: {
                                                                    width: "100%",
                                                                    fontSize: {
                                                                        tablet: (0,typography/* pxToRem */.Q)(16),
                                                                        mobile: "16px"
                                                                    },
                                                                    color: theme.palette.grey[50],
                                                                    "& input": {
                                                                        p: "15px"
                                                                    }
                                                                },
                                                                error: isError
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                        item: true,
                                                        mobile: 12,
                                                        tablet: 12,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                            sx: {
                                                                width: "100%",
                                                                marginY: {
                                                                    mobile: "16px",
                                                                    tablet: (0,typography/* pxToRem */.Q)(32)
                                                                }
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(credit_card_expiry_date_input/* CreditCardExpiryDateInput */.T, {
                                                                    isLoading: isLoading,
                                                                    isError: ((ref7 = errors.expiryDate) === null || ref7 === void 0 ? void 0 : ref7.type) && ((ref8 = errors.expiryDate) === null || ref8 === void 0 ? void 0 : ref8.type) !== "required" || isError,
                                                                    helperText: (ref9 = errors.expiryDate) === null || ref9 === void 0 ? void 0 : ref9.message,
                                                                    value: ((ref10 = getValues()) === null || ref10 === void 0 ? void 0 : ref10.expiryDate) || null,
                                                                    registerFunc: function() {
                                                                        return register("expiryDate");
                                                                    },
                                                                    handleChange: function(e) {
                                                                        e && setValue("expiryDate", (0,shared/* aN2eN */.wE)(e === null || e === void 0 ? void 0 : e.toFormat("yyyy-MM")));
                                                                        trigger();
                                                                    }
                                                                }),
                                                                isError && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                                                                    error: true,
                                                                    sx: {
                                                                        fontSize: {
                                                                            mobile: "14px",
                                                                            tablet: (0,typography/* pxToRem */.Q)(16)
                                                                        }
                                                                    },
                                                                    children: error === null || error === void 0 ? void 0 : (ref11 = error.response) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.data) === null || ref12 === void 0 ? void 0 : ref12.message
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                (isBankOffer || isUnipalOffer || isCardOffer) && isOfferVerified && /*#__PURE__*/ (0,jsx_runtime.jsx)(offer_badge/* default */.Z, {
                                    title: formatMessage({
                                        id: "offer.badge.applied"
                                    }),
                                    subTitle: offerTitle,
                                    lottie: muvi_offer,
                                    onDelete: function() {
                                        handleDeleteOffer();
                                        setBinNumber("");
                                        setLast4BinNumber("");
                                        setValue("expiryDate", null);
                                        setValue("unipalPhoneNumber", "");
                                        setValue("unipalCode", "");
                                        setAgreeOnTerms(false);
                                    },
                                    styles: {
                                        subTitle: {
                                            color: theme.palette.grey[60]
                                        }
                                    }
                                }),
                                canSelectSeats && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            component: "p",
                                            sx: {
                                                fontSize: {
                                                    mobile: "14px",
                                                    tablet: (0,typography/* pxToRem */.Q)(16)
                                                },
                                                mt: 3,
                                                color: theme.palette.grey[60]
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                id: "offers.check_terms_and_condition"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            sx: {
                                                width: "100%"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                direction: "row",
                                                sx: {
                                                    alignItems: "center",
                                                    flexWrap: "wrap",
                                                    fontSize: {
                                                        tablet: (0,typography/* pxToRem */.Q)(14),
                                                        mobile: "14px"
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                                        sx: {
                                                            marginRight: "0px"
                                                        },
                                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                            id: "offer-terms-input",
                                                            onChange: function(e) {
                                                                return setAgreeOnTerms(e.target.checked);
                                                            },
                                                            checked: AgreeOnTerms
                                                        }),
                                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxLabel, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        component: "span",
                                                        children: "\xa0"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        id: "view-offer-terms-button",
                                                        sx: {
                                                            fontFamily: theme.palette.typography.font.bold,
                                                            color: theme.palette.link.main,
                                                            fontSize: {
                                                                tablet: (0,typography/* pxToRem */.Q)(13),
                                                                mobile: "14px"
                                                            },
                                                            whiteSpace: "nowrap",
                                                            cursor: "pointer"
                                                        },
                                                        onClick: function() {
                                                            return openTermsAndConditionsDialog();
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                            id: "terms.and.conditions"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                        children: canSelectSeats ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                            id: "apply-offer-and-select-seats",
                            type: "button",
                            fullWidth: true,
                            disabled: !AgreeOnTerms || (isBankOffer || isUnipalOffer || isCardOffer) && !isOfferVerified,
                            variant: "contained",
                            onClick: handleApplyOffer,
                            sx: {
                                fontSize: {
                                    tablet: (0,typography/* pxToRem */.Q)(16),
                                    mobile: "16px",
                                    fontWight: "bold"
                                },
                                height: {
                                    tablet: (0,typography/* pxToRem */.Q)(56),
                                    mobile: "56px"
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                id: "offers.apply_and_select_seats"
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                            type: "button",
                            id: "verify-offer-button",
                            fullWidth: true,
                            disabled: !(offer === null || offer === void 0 ? void 0 : offer.id) || (isBankOffer || isCardOffer) && ((binNumber === null || binNumber === void 0 ? void 0 : binNumber.length) < (offer === null || offer === void 0 ? void 0 : offer.binLimit) || (last4BinNumber === null || last4BinNumber === void 0 ? void 0 : last4BinNumber.length) < 4 || !((ref13 = getValues()) === null || ref13 === void 0 ? void 0 : ref13.expiryDate)) || isUnipalOffer && (!((ref14 = getValues()) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.unipalCode) === null || ref15 === void 0 ? void 0 : ref15.trim()) || !((ref16 = getValues()) === null || ref16 === void 0 ? void 0 : ref16.unipalPhoneNumber) || !!(errors === null || errors === void 0 ? void 0 : errors.unipalPhoneNumber)),
                            variant: "contained",
                            onClick: isBankOffer || isCardOffer ? handleVerifyBin : handleVerifyUnipal,
                            loading: isLoading,
                            sx: {
                                fontSize: {
                                    tablet: (0,typography/* pxToRem */.Q)(16),
                                    mobile: "16px",
                                    fontWight: "bold"
                                },
                                height: {
                                    tablet: (0,typography/* pxToRem */.Q)(56),
                                    mobile: "56px"
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                id: "global.verify"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slide/* default */.Z, {
                appear: false,
                direction: "left",
                in: isShowTC,
                unmountOnExit: true,
                mountOnEnter: true,
                exit: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferTermsAndConditions, {
                        termsConditions: offer === null || offer === void 0 ? void 0 : offer.termsConditions,
                        handleBackwardClick: handleBackwardClick
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/movie-finder/show-times/change-show-times-dialog.tsx












var EmptyFilterIcon = "/icons/movie-finder/empty-filter-icon.svg";
var ChangeShowTimesDialog = function() {
    var theme = (0,useTheme/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,state/* useDialog */.Rh)(function(s) {
        return [
            s.dialog,
            s.setDialog
        ];
    }, shallow/* default */.Z), 2), dialog = ref[0], setDialog = ref[1];
    var ref1 = (0,react.useState)(null), dialogMessage = ref1[0], setDialogMessage = ref1[1];
    var handle = (0,react.useCallback)(function(allow) {
        setDialog(function(prevState) {
            return {
                wrapper: false,
                isAllowedToChangeShowTimesDialogPayload: (0,_object_spread/* default */.Z)({}, prevState === null || prevState === void 0 ? void 0 : prevState.isAllowedToChangeShowTimesDialogPayload)
            };
        });
        setDialog(function(prevState) {
            return {
                wrapper: false,
                isAllowedToChangeShowTimesDialog: true,
                isAllowedToChangeShowTimesDialogPayload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState === null || prevState === void 0 ? void 0 : prevState.isAllowedToChangeShowTimesDialogPayload), {
                    isAllowed: allow
                })
            };
        });
    }, [
        setDialog
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if (dialog === null || dialog === void 0 ? void 0 : (ref = dialog.isAllowedToChangeShowTimesDialogPayload) === null || ref === void 0 ? void 0 : ref.date) {
            setDialogMessage({
                title: "movie.finder.filters.change_date",
                description: "movie.finder.filters.change_date_desc"
            });
        } else {
            setDialogMessage({
                title: "movie.finder.filters.change.showtime",
                description: "movie.finder.filters.change_showtime_desc"
            });
        }
    }, [
        dialog === null || dialog === void 0 ? void 0 : dialog.isAllowedToChangeShowTimesDialogPayload
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(close_button/* CloseButton */.P, {
                    handleClick: function() {
                        return handle(false);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                sx: {
                    display: "flex"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        flexGrow: 1
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                marginBlock: 4
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                                img: EmptyFilterIcon,
                                title: intl.formatMessage({
                                    id: "alt.empty_filters"
                                }),
                                objectFit: "contain",
                                sx: {
                                    width: (0,typography/* pxToRem */.Q)(64),
                                    height: (0,typography/* pxToRem */.Q)(72)
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: theme.palette.grey[90],
                                fontSize: (0,typography/* pxToRem */.Q)(22),
                                fontWeight: 700,
                                lineHeight: "33px",
                                marginBottom: (0,typography/* pxToRem */.Q)(24)
                            },
                            children: (dialogMessage === null || dialogMessage === void 0 ? void 0 : dialogMessage.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                id: dialogMessage.title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: theme.palette.grey[70],
                                fontSize: (0,typography/* pxToRem */.Q)(18),
                                fontWeight: 400,
                                lineHeight: "27px",
                                textAlign: "center"
                            },
                            children: (dialogMessage === null || dialogMessage === void 0 ? void 0 : dialogMessage.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                id: dialogMessage.description
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        id: "filter-change-cancel",
                        fullWidth: true,
                        sx: {
                            fontFamily: theme.palette.typography.font.bold
                        },
                        onClick: function() {
                            return handle(false);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                            id: "global.cancel"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        id: "filter-change-okay",
                        variant: "contained",
                        fullWidth: true,
                        onClick: function() {
                            return handle(true);
                        },
                        sx: {
                            height: {
                                tablet: (0,typography/* pxToRem */.Q)(56),
                                mobile: "56px"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                            id: "global.yes"
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/movie-finder/filters/clear-all-filters-dialog.tsx









var clear_all_filters_dialog_EmptyFilterIcon = "/icons/movie-finder/empty-filter-icon.svg";
var ClearAllFiltersDialog = function() {
    var theme = (0,useTheme/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    var setDialog = (0,state/* useDialog */.Rh)(function(s) {
        return s.setDialog;
    }, shallow/* default */.Z);
    var handle = (0,react.useCallback)(function(allow) {
        setDialog({});
        setDialog({
            wrapper: false,
            isAllowedToClearAllFiltersDialog: true,
            isAllowedToClearAllFiltersDialogPayload: {
                isAllowed: allow
            }
        });
        setTimeout(function() {
            setDialog({});
        }, 1000);
    }, [
        setDialog
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(close_button/* CloseButton */.P, {
                    handleClick: function() {
                        return handle(false);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                sx: {
                    display: "flex"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        flexGrow: 1
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                marginBlock: 4
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                                img: clear_all_filters_dialog_EmptyFilterIcon,
                                title: intl.formatMessage({
                                    id: "alt.empty_filters"
                                }),
                                objectFit: "contain",
                                sx: {
                                    width: (0,typography/* pxToRem */.Q)(64),
                                    height: (0,typography/* pxToRem */.Q)(72)
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: theme.palette.grey[90],
                                fontSize: (0,typography/* pxToRem */.Q)(22),
                                fontWeight: 700,
                                lineHeight: "33px",
                                marginBottom: (0,typography/* pxToRem */.Q)(24)
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                id: "movie_details.clear.all"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: theme.palette.grey[70],
                                fontSize: (0,typography/* pxToRem */.Q)(18),
                                fontWeight: 400,
                                lineHeight: "27px",
                                textAlign: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                id: "movie_details.if_you_say_yes_filters_will_be_cleared"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        id: "filter-change-cancel",
                        fullWidth: true,
                        sx: {
                            fontFamily: theme.palette.typography.font.bold
                        },
                        onClick: function() {
                            return handle(false);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                            id: "global.cancel"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        id: "filter-change-okay",
                        variant: "contained",
                        fullWidth: true,
                        onClick: function() {
                            return handle(true);
                        },
                        sx: {
                            height: {
                                tablet: (0,typography/* pxToRem */.Q)(56),
                                mobile: "56px"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                            id: "global.yes"
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/shared/confirm-dialog.tsx
var confirm_dialog = __webpack_require__(1046);
;// CONCATENATED MODULE: ./src/components/movie-finder/clear-history-confirm-dialog.tsx







var ClearHistoryFindingIcon = "/icons//movie-finder/clear-history-finding-icon.svg";
var ClearHistoryConfirmDialog = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,state/* useDialog */.Rh)(function(s) {
        return [
            s.setDialog
        ];
    }, shallow/* default */.Z), 1), setDialog = ref[0];
    var setSnack = (0,state/* useSnack */.eW)(function(s) {
        return s.setSnack;
    }, shallow/* default */.Z);
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var ref1 = (0,services/* useClearSearchHistory */.cR)({}, {
        onSuccess: function() {
            setSnack({
                isOpen: true,
                message: "movie_finder.search.clear.success",
                type: "success"
            });
            queryClient.invalidateQueries({
                predicate: function(query) {
                    var ref;
                    return ((ref = query.queryKey[0]) === null || ref === void 0 ? void 0 : ref.url) === services/* recentSearchUrl */.fv;
                }
            });
            setDialog({});
        },
        onError: function() {
            setSnack({
                isOpen: true,
                message: "global.error",
                type: "error"
            });
        }
    }), clearHistory = ref1.mutate, isClearingHistory = ref1.isLoading;
    var handleClearHistory = function() {
        clearHistory({});
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(confirm_dialog/* ConfirmDialog */.Q, {
        buttonId: "clear_history.delete",
        img: ClearHistoryFindingIcon,
        widthImage: "99px",
        heightImage: "106px",
        altImage: "alt.delete_voucher_icon",
        title: "movie_finder.search.clear.confirm.title",
        description: "movie_finder.search.clear.confirm.description",
        handleOkayClick: handleClearHistory,
        handleCloseClick: function() {
            return setDialog({});
        },
        isLoading: isClearingHistory
    });
};

;// CONCATENATED MODULE: ./src/components/offers/delete-offer-confirm-dialog.tsx





var DeleteOfferConfirmDialog = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,state/* useDialog */.Rh)(function(s) {
        return [
            s.dialog,
            s.setDialog
        ];
    }, shallow/* default */.Z), 2), dialog = ref[0], setDialog = ref[1];
    var handleDelete = (dialog === null || dialog === void 0 ? void 0 : dialog.deleteOfferConfirmDialogPayload).handleDelete;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(confirm_dialog/* ConfirmDialog */.Q, {
        buttonId: "offer.delete",
        img: "/icons/profile/deletePopup.svg",
        widthImage: "99px",
        heightImage: "106px",
        altImage: "alt.trash_icon",
        title: "offer.delete.confirm.title",
        description: "offer.delete.confirm.description",
        handleOkayClick: handleDelete,
        handleCloseClick: function() {
            return setDialog({});
        }
    });
};

;// CONCATENATED MODULE: ./src/components/checkout/delete-voucher-confirm-dialog.tsx






var deleteVoucherImg = "/icons/profile/deletePopup.svg";
var DeleteVoucherConfirmDialog = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,state/* useDialog */.Rh)(function(s) {
        return [
            s.dialog,
            s.setDialog
        ];
    }, shallow/* default */.Z), 2), dialog = ref[0], setDialog = ref[1];
    var setSnack = (0,state/* useSnack */.eW)(function(s) {
        return s.setSnack;
    }, shallow/* default */.Z);
    var ref1 = (0,services/* useDeleteVoucher */.bg)({}, {
        onSuccess: function(res) {
            var ref;
            setSnack({
                isOpen: true,
                message: "voucher.delete.success",
                type: "success"
            });
            dialog === null || dialog === void 0 ? void 0 : (ref = dialog.deleteVoucherConfirmDialogPayload) === null || ref === void 0 ? void 0 : ref.handleSuccess(res);
            setDialog({});
        },
        onError: function() {
            setSnack({
                isOpen: true,
                message: "global.error",
                type: "error"
            });
        }
    }), deleteVoucher = ref1.mutate, isDeletingVoucher = ref1.isLoading;
    var handleDeleteVoucher = function() {
        var ref, ref1;
        deleteVoucher({
            query: {
                orderId: dialog === null || dialog === void 0 ? void 0 : (ref = dialog.deleteVoucherConfirmDialogPayload) === null || ref === void 0 ? void 0 : ref.orderId
            },
            params: {
                barCode: dialog === null || dialog === void 0 ? void 0 : (ref1 = dialog.deleteVoucherConfirmDialogPayload) === null || ref1 === void 0 ? void 0 : ref1.barCode
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(confirm_dialog/* ConfirmDialog */.Q, {
        buttonId: "voucher.delete",
        img: deleteVoucherImg,
        widthImage: "99px",
        heightImage: "106px",
        altImage: "alt.delete_voucher_icon",
        title: "voucher.delete.confirm.title",
        description: "voucher.delete.confirm.description",
        handleOkayClick: handleDeleteVoucher,
        handleCloseClick: function() {
            return setDialog({});
        },
        isLoading: isDeletingVoucher
    });
};

// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(88116);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
;// CONCATENATED MODULE: ./src/components/experience/experience-images-slider.tsx






var ExperienceImagesSlider = function(param) {
    var experience = param.experience;
    var ref;
    var theme = (0,useTheme/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            ".swiper": {
                width: {
                    mobile: "175%",
                    tablet: "125%"
                },
                transform: {
                    mobile: "translateX(-20%)",
                    tablet: "translateX(-10%)"
                }
            },
            "& .swiper-slide": {
                paddingBottom: "40px"
            },
            "& .swiper-pagination-bullet": {
                width: {
                    tablet: (0,typography/* pxToRem */.Q)(12),
                    mobile: "6px"
                },
                height: {
                    tablet: (0,typography/* pxToRem */.Q)(12),
                    mobile: "6px"
                },
                background: theme.palette.grey[10],
                backdropFilter: "blur(5px)",
                opacity: 1
            },
            "& .swiper-pagination-bullet-active": {
                background: theme.palette.primary.main,
                border: "1px solid ".concat(theme.palette.primary.main),
                width: {
                    tablet: (0,typography/* pxToRem */.Q)(14),
                    mobile: "8px"
                },
                height: {
                    tablet: (0,typography/* pxToRem */.Q)(14),
                    mobile: "8px"
                }
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
            speed: 600,
            loop: true,
            slidesPerView: 3,
            centeredSlides: true,
            slideToClickedSlide: true,
            pagination: {
                clickable: true
            },
            modules: [
                swiper_esm/* EffectCoverflow */.lI,
                swiper_esm/* Pagination */.tl
            ],
            effect: "coverflow",
            coverflowEffect: {
                depth: 0,
                rotate: 0,
                scale: 0.8,
                slideShadows: false
            },
            children: experience === null || experience === void 0 ? void 0 : (ref = experience.imagesList) === null || ref === void 0 ? void 0 : ref.map(function(image) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                        img: image,
                        title: experience === null || experience === void 0 ? void 0 : experience.name,
                        layout: "intrinsic",
                        objectFit: "cover",
                        width: "1920px",
                        height: "1080px",
                        sx: {
                            borderRadius: (0,typography/* pxToRem */.Q)(20),
                            overflow: "hidden",
                            cursor: {
                                laptop: "pointer"
                            }
                        }
                    })
                }, image);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/experience/experience-info-dialog.tsx












var ExperienceInfoDialog = function() {
    var theme = (0,useTheme/* default */.Z)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,state_dialog/* useDialog */.R)(function(s) {
        return [
            s.dialog,
            s.setDialog
        ];
    }, shallow/* default */.Z), 2), dialog = ref[0], setDialog = ref[1];
    var ref1 = (0,react.useState)(dialog === null || dialog === void 0 ? void 0 : dialog.experienceInfoDialogPayload), experience = ref1[0];
    var handleCloseClick = function() {
        return setDialog({
            wrapper: false,
            isExperienceInfoDialog: false,
            experienceInfoDialogPayload: null
        });
    };
    (0,react.useEffect)(function() {
        setDialog(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                minWidth: {
                    minWidth: {
                        mobile: "100%",
                        tablet: "80%"
                    }
                }
            });
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(close_button/* CloseButton */.P, {
                        handleClick: function() {
                            return handleCloseClick();
                        }
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                    sx: {
                        padding: "0px !important"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            overflow: "hidden"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: "h4",
                                sx: {
                                    textAlign: "center",
                                    fontWeight: 700,
                                    fontSize: {
                                        tablet: (0,typography/* pxToRem */.Q)(22),
                                        mobile: "18px"
                                    },
                                    mb: {
                                        tablet: (0,typography/* pxToRem */.Q)(32),
                                        mobile: "24px"
                                    },
                                    mt: {
                                        tablet: (0,typography/* pxToRem */.Q)(30),
                                        mobile: "24px"
                                    },
                                    color: theme.palette.grey[90],
                                    width: "100%"
                                },
                                children: experience.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExperienceImagesSlider, {
                                experience: experience
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    flexDirection: "column",
                                    paddingInline: (0,typography/* pxToRem */.Q)(48)
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        sx: {
                                            textAlign: "start",
                                            fontWeight: 700,
                                            fontSize: {
                                                tablet: (0,typography/* pxToRem */.Q)(22),
                                                mobile: "18px"
                                            },
                                            mb: {
                                                tablet: (0,typography/* pxToRem */.Q)(32),
                                                mobile: "16px"
                                            },
                                            mt: {
                                                tablet: (0,typography/* pxToRem */.Q)(20),
                                                mobile: "24px"
                                            },
                                            color: theme.palette.grey[90],
                                            width: "100%"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                            id: "experience_details.about"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        sx: {
                                            textAlign: "start",
                                            fontWeight: 400,
                                            fontSize: (0,typography/* pxToRem */.Q)(24),
                                            mb: {
                                                tablet: (0,typography/* pxToRem */.Q)(70),
                                                mobile: "40px"
                                            },
                                            mt: {
                                                tablet: (0,typography/* pxToRem */.Q)(26),
                                                mobile: "0px"
                                            },
                                            color: theme.palette.grey[50],
                                            width: {
                                                mobile: "100%",
                                                tablet: "70%"
                                            }
                                        },
                                        children: experience.description
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/navbar/notifications/notifications-popover-content.tsx + 7 modules
var notifications_popover_content = __webpack_require__(21790);
;// CONCATENATED MODULE: ./src/components/stand-alone/offline-dialog.tsx





var OfflineIcon = "/icons/general/offline.svg";
var OfflineDialog = function() {
    var theme = (0,useTheme/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
            textAlign: "center"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                img: OfflineIcon,
                title: intl.formatMessage({
                    id: "alt.offline_icon"
                }),
                objectFit: "contain",
                sx: {
                    marginTop: (0,typography/* pxToRem */.Q)(72),
                    height: (0,typography/* pxToRem */.Q)(154),
                    width: (0,typography/* pxToRem */.Q)(190)
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                sx: {
                    marginTop: (0,typography/* pxToRem */.Q)(24),
                    fontSize: (0,typography/* pxToRem */.Q)(22),
                    fontWeight: "700",
                    lineHeight: "33px",
                    color: theme.palette.grey[90]
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                    id: "you.are.offline"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                sx: {
                    marginTop: (0,typography/* pxToRem */.Q)(24),
                    fontSize: (0,typography/* pxToRem */.Q)(18),
                    fontWeight: "400",
                    lineHeight: "27px",
                    color: theme.palette.grey[70],
                    maxWidth: "80%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                    id: "you.are.offline.desc"
                })
            })
        ]
    });
};
/* harmony default export */ var offline_dialog = (OfflineDialog);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(94054);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputLabel/InputLabel.js + 3 modules
var InputLabel = __webpack_require__(33841);
// EXTERNAL MODULE: ./node_modules/@mui/material/Select/Select.js + 2 modules
var Select = __webpack_require__(62482);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(63931);
// EXTERNAL MODULE: ./node_modules/@mui/material/Radio/Radio.js + 5 modules
var Radio = __webpack_require__(36872);
// EXTERNAL MODULE: ./src/constants/contact-us.ts
var contact_us = __webpack_require__(6825);
// EXTERNAL MODULE: ./src/components/shared/Input-adornment-component.tsx
var Input_adornment_component = __webpack_require__(54087);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(34853);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./src/logic/state/contact-us/index.ts
var state_contact_us = __webpack_require__(12264);
// EXTERNAL MODULE: ./src/logic/services/contact-us/index.ts + 1 modules
var services_contact_us = __webpack_require__(49351);
;// CONCATENATED MODULE: ./src/features/login-and-signup/modals/contact-us-dialog.tsx




























var contact_us_dialog_MuiPhoneNumber = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3626), __webpack_require__.e(6343)]).then(__webpack_require__.t.bind(__webpack_require__, 61803, 23)).then(function(component) {
        return component.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61803)
            ];
        }
    },
    ssr: false
});
var ReportMuviTeamDialog = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var theme = (0,useTheme/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    var locale = (0,next_router.useRouter)().locale;
    var setSnack = (0,state/* useSnack */.eW)(function(s) {
        return s.setSnack;
    }, shallow/* default */.Z);
    var ref16 = (0,react.useState)("KSA"), countryCode_contact = ref16[0], setCountryCode_contact = ref16[1];
    var ref17 = (0,react.useState)(null), selectedCountry = ref17[0], setSelectedCountry = ref17[1];
    var ref18 = (0,_sliced_to_array/* default */.Z)((0,state/* useDialog */.Rh)(function(s) {
        return [
            s.dialog,
            s.setDialog
        ];
    }, shallow/* default */.Z), 2), dialog = ref18[0], setDialog = ref18[1];
    var recaptchaRef = (0,react.useRef)(null);
    var publicRuntimeConfig = config_default()().publicRuntimeConfig;
    var ref19 = (0,react.useState)(""), recaptchaValue = ref19[0], setRecaptchaValue = ref19[1];
    var createContactUs = (0,services_contact_us/* useCreateContactUs */.I)();
    var reportMuviDialogPayload = dialog.reportMuviDialogPayload;
    var contactUs = (0,state_contact_us/* useContactUs */.$)(function(s) {
        return s.contactUs;
    }, shallow/* default */.Z);
    var user = (0,state/* useAuth */.aC)(function(s) {
        return s.user;
    }, shallow/* default */.Z);
    var REQUIRED_VALIDATION_MESSAGE = intl.formatMessage({
        id: "global.required"
    });
    var schema = es/* object */.Ry({
        phoneNumber: es/* string */.Z_().test("test-valid-phone", intl.formatMessage({
            id: "global.phoneNumber.notValid"
        }), function(value) {
            if (value) {
                return (0,shared/* checkIfPhoneNumberIsValid */._5)(value, countryCode_contact);
            }
        }),
        customerName: es/* string */.Z_().trim().required(),
        email: es/* string */.Z_().required(REQUIRED_VALIDATION_MESSAGE).email(intl.formatMessage({
            id: "global.validation.email"
        })),
        category: es/* string */.Z_().required(REQUIRED_VALIDATION_MESSAGE),
        subject: es/* string */.Z_().required(REQUIRED_VALIDATION_MESSAGE),
        description: es/* string */.Z_().required(REQUIRED_VALIDATION_MESSAGE)
    });
    var ref20, ref21, ref22;
    var ref23 = (0,index_esm/* useForm */.cI)({
        resolver: (0,yup/* yupResolver */.X)(schema),
        mode: "all",
        defaultValues: {
            phoneNumber: (ref20 = dialog === null || dialog === void 0 ? void 0 : (ref = dialog.reportMuviDialogPayload) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.phoneNumber) !== null && ref20 !== void 0 ? ref20 : user.phoneNumber,
            customerName: (user === null || user === void 0 ? void 0 : user.firstName) ? (user === null || user === void 0 ? void 0 : user.firstName) + " " + (user === null || user === void 0 ? void 0 : user.lastName) : "",
            email: (ref21 = dialog === null || dialog === void 0 ? void 0 : (ref2 = dialog.reportMuviDialogPayload) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.email) !== null && ref21 !== void 0 ? ref21 : user.email,
            category: contact_us/* ONLINE_BOOKING */.ac,
            subject: (ref22 = dialog === null || dialog === void 0 ? void 0 : (ref4 = dialog.reportMuviDialogPayload) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.subject) !== null && ref22 !== void 0 ? ref22 : "",
            description: contactUs === null || contactUs === void 0 ? void 0 : contactUs.reportDescriptionMessage
        }
    }), register = ref23.register, setValue = ref23.setValue, handleSubmit = ref23.handleSubmit, trigger = ref23.trigger, getValues = ref23.getValues, _formState = ref23.formState, errors = _formState.errors, touchedFields = _formState.touchedFields, isValid = _formState.isValid;
    (0,react.useEffect)(function() {
        setSelectedCountry(function(prev) {
            var ref, ref1;
            if ((dialog === null || dialog === void 0 ? void 0 : (ref = dialog.reportMuviDialogPayload) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.phoneNumber) || (user === null || user === void 0 ? void 0 : user.phoneNumber)) {
                var ref2, ref3;
                var ref4;
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                    dialCode: (0,shared/* getDialCodeFromPhoneNumber */.CA)((ref4 = dialog === null || dialog === void 0 ? void 0 : (ref2 = dialog.reportMuviDialogPayload) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.phoneNumber) !== null && ref4 !== void 0 ? ref4 : user === null || user === void 0 ? void 0 : user.phoneNumber)
                });
            }
        });
    }, [
        dialog === null || dialog === void 0 ? void 0 : (ref6 = dialog.reportMuviDialogPayload) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : ref7.phoneNumber,
        user === null || user === void 0 ? void 0 : user.phoneNumber
    ]);
    var onChangeCaptcha = (0,react.useCallback)(function(value) {
        setRecaptchaValue(value);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        setValue
    ]);
    var onSubmit = handleSubmit(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var email, phoneNumber, category, subject, description, customerName, recaptchaResponse, contactUsData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        email = param.email, phoneNumber = param.phoneNumber, category = param.category, subject = param.subject, description = param.description, customerName = param.customerName, recaptchaResponse = param.recaptchaResponse;
                        contactUsData = {
                            phoneNumber: (0,shared/* muviPhoneNumberTrimmer */.wO)(phoneNumber, selectedCountry.dialCode),
                            email: email,
                            category: category,
                            subject: subject,
                            description: description,
                            customerName: customerName,
                            recaptchaResponse: recaptchaResponse
                        };
                        return [
                            4,
                            createContactUs.safeMutateAsync({
                                data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, contactUsData), {
                                    subcategory: contact_us/* I_CAN_NOT_BOOK_A_TICKET */.ap,
                                    recaptchaResponse: recaptchaValue || ""
                                })
                            }, {
                                onSuccess: function() {
                                    setRecaptchaValue("");
                                    setSnack({
                                        isOpen: true,
                                        message: "report.muvi.dialog.success.message",
                                        type: "success"
                                    });
                                    setDialog({});
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }());
    var ref24 = (0,services/* useGetSettings */.Y4)(), allCmsSetting = ref24.data;
    var ref25, ref26, ref27, ref28, ref29;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(backward_button/* BackwardButton */.e, {
                    handleClick: function() {
                        return reportMuviDialogPayload.handleBackwardClick();
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        margin: "auto"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                fontSize: {
                                    mobile: "22px",
                                    tablet: (0,typography/* pxToRem */.Q)(22)
                                },
                                color: theme.palette.grey[90],
                                fontWeight: "bold"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                id: "footer.link.contact.us"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        fontSize: {
                                            mobile: "18px",
                                            tablet: (0,typography/* pxToRem */.Q)(18)
                                        },
                                        color: theme.palette.primary.main,
                                        marginTop: "32px",
                                        fontWeight: "bold"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                        id: "contact_us.stay_connect"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    sx: {
                                        fontSize: {
                                            mobile: "18px",
                                            tablet: (0,typography/* pxToRem */.Q)(18)
                                        },
                                        color: theme.palette.grey[60],
                                        marginTop: "16px"
                                    },
                                    children: allCmsSetting === null || allCmsSetting === void 0 ? void 0 : allCmsSetting.contactUsDescription
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    spacing: 3,
                                    sx: {
                                        width: "100%",
                                        marginTop: "40px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                    id: "contact-us-customerName",
                                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                        id: "global.full_name"
                                                    }),
                                                    variant: "outlined"
                                                }, register("customerName")), {
                                                    error: (ref25 = errors.customerName && touchedFields.customerName) !== null && ref25 !== void 0 ? ref25 : false,
                                                    InputProps: {
                                                        endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_adornment_component/* default */.Z, {
                                                            errorCondition: errors.customerName && touchedFields.customerName
                                                        })
                                                    },
                                                    sx: {
                                                        "& fieldset span": {
                                                            opacity: (user === null || user === void 0 ? void 0 : user.firstName) ? "1!important" : "0",
                                                            transform: (user === null || user === void 0 ? void 0 : user.firstName) ? "translateY(-5px)" : "translateY(0)"
                                                        },
                                                        "&  label": {
                                                            opacity: !(user === null || user === void 0 ? void 0 : user.firstName) ? "1!important" : "0"
                                                        }
                                                    }
                                                })),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormHelperText/* default */.Z, {
                                                    error: true,
                                                    children: touchedFields.customerName && ((errors === null || errors === void 0 ? void 0 : (ref8 = errors.customerName) === null || ref8 === void 0 ? void 0 : ref8.type) === "required" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                        id: "global.required"
                                                    }) : (errors === null || errors === void 0 ? void 0 : (ref9 = errors.customerName) === null || ref9 === void 0 ? void 0 : ref9.type) === "min" || (errors === null || errors === void 0 ? void 0 : (ref10 = errors.customerName) === null || ref10 === void 0 ? void 0 : ref10.type) === "max" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                                id: "global.please.enter.valid"
                                                            }),
                                                            "\xa0",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                                id: "global.full_name"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                                id: "global.min.two.max.fifty"
                                                            })
                                                        ]
                                                    }) : (errors === null || errors === void 0 ? void 0 : (ref11 = errors.customerName) === null || ref11 === void 0 ? void 0 : ref11.type) === "matches" && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                        id: "global.only.chars.allowed"
                                                    }))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                id: "report-muvi-email"
                                            }, register("email")), {
                                                error: Boolean(errors.email),
                                                helperText: (ref12 = errors.email) === null || ref12 === void 0 ? void 0 : ref12.message,
                                                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                            id: "global.email"
                                                        }),
                                                        "\xa0",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                            id: "global.required()"
                                                        })
                                                    ]
                                                }),
                                                variant: "outlined",
                                                InputProps: {
                                                    endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_adornment_component/* default */.Z, {
                                                        errorCondition: errors.email && touchedFields.email
                                                    })
                                                }
                                            }))
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                                            variant: "standard",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_us_dialog_MuiPhoneNumber, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                excludeCountries: phone_numbers/* excludedCountriesList */.o,
                                                value: getValues().phoneNumber || "",
                                                error: (ref26 = ((ref13 = errors.phoneNumber) === null || ref13 === void 0 ? void 0 : ref13.type) === "test-valid-phone" && touchedFields.phoneNumber) !== null && ref26 !== void 0 ? ref26 : false,
                                                helperText: (ref14 = errors.phoneNumber) === null || ref14 === void 0 ? void 0 : ref14.message,
                                                id: "phone",
                                                InputLabelProps: {
                                                    sx: {
                                                        backgroundColor: "white",
                                                        paddingInline: "6px"
                                                    }
                                                },
                                                sx: {
                                                    "& svg": {
                                                        height: "1em"
                                                    },
                                                    legend: {
                                                        width: 0
                                                    }
                                                },
                                                defaultCountry: "sa",
                                                dir: "ltr",
                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                    id: "global.phone_number"
                                                }),
                                                variant: "outlined"
                                            }, register("phoneNumber")), {
                                                onChange: function(e, country) {
                                                    setSelectedCountry(country);
                                                    setValue("phoneNumber", e);
                                                    var field = "phoneNumber";
                                                    var c = country === null || country === void 0 ? void 0 : country.countryCode.toString().toUpperCase();
                                                    if (field.includes("contact")) {
                                                        setCountryCode_contact(c);
                                                    }
                                                    trigger(); // only special handle for this mui phoneNumber field
                                                },
                                                InputProps: {
                                                    endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_adornment_component/* default */.Z, {
                                                        errorCondition: ((ref15 = errors.phoneNumber) === null || ref15 === void 0 ? void 0 : ref15.type) === "test-valid-phone" && touchedFields.phoneNumber
                                                    })
                                                }
                                            }))
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                                                    id: "report-muvi-category-label",
                                                    error: (ref27 = errors.category && touchedFields.category) !== null && ref27 !== void 0 ? ref27 : false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                        id: "contact_us.category"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                    disabled: true,
                                                    labelId: "category-label",
                                                    id: "report-muvi-category-select",
                                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                        id: "contact_us.category"
                                                    }),
                                                    value: getValues("category")
                                                }, register("category")), {
                                                    error: Boolean(errors.category) && touchedFields.category,
                                                    onChange: function(e) {
                                                        setValue("category", e.target.value);
                                                        trigger();
                                                    },
                                                    MenuProps: {
                                                        BackdropProps: {
                                                            sx: {
                                                                backgroundColor: "transparent",
                                                                backdropFilter: "none"
                                                            }
                                                        }
                                                    },
                                                    displayEmpty: true,
                                                    renderValue: function() {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            component: "span",
                                                            children: getValues("category") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                                id: "contact_us.".concat(contact_us/* categoryList.find */.wA.find(function(category) {
                                                                    return category === getValues("category");
                                                                }))
                                                            }) : ""
                                                        });
                                                    },
                                                    children: contact_us/* categoryList.map */.wA.map(function(item, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                                                            value: item,
                                                            id: "report-muvi-".concat(item),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                                                    checked: item === getValues("category")
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                                    id: "contact_us.".concat(item)
                                                                })
                                                            ]
                                                        }, index);
                                                    })
                                                }))
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                disabled: true,
                                                id: "report-muvi-subject",
                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                        id: "contact_us.subject"
                                                    })
                                                }),
                                                variant: "outlined"
                                            }, register("subject")), {
                                                error: (ref28 = errors.subject && touchedFields.subject) !== null && ref28 !== void 0 ? ref28 : false,
                                                InputProps: {
                                                    endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_adornment_component/* default */.Z, {
                                                        errorCondition: errors.subject && touchedFields.subject
                                                    })
                                                }
                                            }))
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                disabled: true,
                                                id: "contact-us-description",
                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                        id: "contact_us.description"
                                                    })
                                                }),
                                                variant: "outlined"
                                            }, register("description")), {
                                                error: (ref29 = errors.description && touchedFields.description) !== null && ref29 !== void 0 ? ref29 : false,
                                                InputProps: {
                                                    endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_adornment_component/* default */.Z, {
                                                        errorCondition: errors.description && touchedFields.description
                                                    })
                                                },
                                                multiline: true
                                            }))
                                        }),
                                        !(user === null || user === void 0 ? void 0 : user.phoneNumber) && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                                            sx: {
                                                display: "flex",
                                                alignItems: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                                                ref: recaptchaRef,
                                                sitekey: publicRuntimeConfig.recaptchaClientKey,
                                                onChange: onChangeCaptcha,
                                                hl: locale
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                    id: "report-muvi-submit",
                    variant: "contained",
                    loading: createContactUs.isLoading,
                    sx: {
                        width: "100%",
                        height: {
                            tablet: (0,typography/* pxToRem */.Q)(56),
                            mobile: "56px"
                        },
                        borderRadius: "16px"
                    },
                    onClick: function() {
                        return onSubmit();
                    },
                    disabled: !isValid || !Boolean(recaptchaValue) && !Boolean(user === null || user === void 0 ? void 0 : user.phoneNumber) && !user,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        component: "p",
                        sx: {
                            fontSize: (0,typography/* pxToRem */.Q)(16),
                            fontWeight: "700",
                            lineHeight: "24px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                            id: "global.submit"
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var contact_us_dialog = (ReportMuviTeamDialog);

;// CONCATENATED MODULE: ./src/components/checkout/card-not-same-applied-confirm-dialog.tsx







var CardNotSameAppliedConfirmDialog = function() {
    var theme = (0,useTheme/* default */.Z)();
    var dialog = (0,state/* useDialog */.Rh)(function(s) {
        return s.dialog;
    }, shallow/* default */.Z);
    var ref = dialog === null || dialog === void 0 ? void 0 : dialog.cardNotSameAppliedConfirmDialogPayload, handleOkayClick = ref.handleOkayClick, handleContinueClick = ref.handleContinueClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(close_button/* CloseButton */.P, {
                    handleClick: handleOkayClick
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    sx: {
                        alignItems: "center",
                        margin: "auto",
                        textAlign: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            color: theme.palette.grey[70],
                            fontSize: (0,typography/* pxToRem */.Q)(18),
                            fontWeight: 400,
                            lineHeight: "27px",
                            textAlign: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                            id: "offer.card_not_same_applied"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
                disableSpacing: true,
                sx: {
                    flexDirection: "column"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        id: "card-not-same-applied-info-dialog-okay",
                        variant: "contained",
                        fullWidth: true,
                        onClick: handleOkayClick,
                        sx: {
                            marginBottom: "8px",
                            height: {
                                mobile: "56px",
                                tablet: (0,typography/* pxToRem */.Q)(56)
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                            id: "global.okay"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        id: "card-not-same-applied-info-dialog-continue",
                        variant: "outlined",
                        fullWidth: true,
                        onClick: handleContinueClick,
                        sx: {
                            height: {
                                mobile: "56px",
                                tablet: (0,typography/* pxToRem */.Q)(56)
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                            id: "offer.continue_without_offer"
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/checkout/card-not-same-verified-confirm-dialog.tsx







var CardNotSameVerifiedConfirmDialog = function() {
    var theme = (0,useTheme/* default */.Z)();
    var dialog = (0,state/* useDialog */.Rh)(function(s) {
        return s.dialog;
    }, shallow/* default */.Z);
    var ref = dialog === null || dialog === void 0 ? void 0 : dialog.cardNotSameVerifiedConfirmDialogPayload, handleOkayClick = ref.handleOkayClick, handleContinueClick = ref.handleContinueClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(close_button/* CloseButton */.P, {
                    handleClick: handleOkayClick
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    sx: {
                        alignItems: "center",
                        margin: "auto",
                        textAlign: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            color: theme.palette.grey[70],
                            fontSize: (0,typography/* pxToRem */.Q)(18),
                            fontWeight: 400,
                            lineHeight: "27px",
                            textAlign: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                            id: "offer.card_not_same_verified"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
                disableSpacing: true,
                sx: {
                    flexDirection: "column"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        id: "card-not-same-verified-info-dialog-okay",
                        variant: "contained",
                        fullWidth: true,
                        onClick: handleOkayClick,
                        sx: {
                            marginBottom: "8px",
                            height: {
                                mobile: "56px",
                                tablet: (0,typography/* pxToRem */.Q)(56)
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                            id: "global.okay"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        id: "card-not-same-verified-info-dialog-continue",
                        variant: "outlined",
                        fullWidth: true,
                        onClick: handleContinueClick,
                        sx: {
                            height: {
                                mobile: "56px",
                                tablet: (0,typography/* pxToRem */.Q)(56)
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                            id: "offer.continue_without_offer"
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/checkout/card-not-supported-confirm-dialog.tsx







var CardNotSupportedConfirmDialog = function() {
    var theme = (0,useTheme/* default */.Z)();
    var dialog = (0,state/* useDialog */.Rh)(function(s) {
        return s.dialog;
    }, shallow/* default */.Z);
    var ref = dialog === null || dialog === void 0 ? void 0 : dialog.cardNotSupportedConfirmDialogPayload, handleOkayClick = ref.handleOkayClick, handleContinueClick = ref.handleContinueClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(close_button/* CloseButton */.P, {
                    handleClick: handleOkayClick
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    sx: {
                        alignItems: "center",
                        margin: "auto",
                        textAlign: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            color: theme.palette.grey[70],
                            fontSize: (0,typography/* pxToRem */.Q)(18),
                            fontWeight: 400,
                            lineHeight: "27px",
                            textAlign: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                            id: "offer.card_not_supported"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
                disableSpacing: true,
                sx: {
                    flexDirection: "column"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        id: "card-not-supported-info-dialog-okay",
                        variant: "contained",
                        fullWidth: true,
                        onClick: handleOkayClick,
                        sx: {
                            marginBottom: "8px",
                            height: {
                                mobile: "56px",
                                tablet: (0,typography/* pxToRem */.Q)(56)
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                            id: "global.okay"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        id: "card-not-supported-info-dialog-continue",
                        variant: "outlined",
                        fullWidth: true,
                        onClick: handleContinueClick,
                        sx: {
                            height: {
                                mobile: "56px",
                                tablet: (0,typography/* pxToRem */.Q)(56)
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                            id: "offer.continue_without_offer"
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/logic/services/otp/index.ts + 1 modules
var otp = __webpack_require__(72947);
// EXTERNAL MODULE: ./src/logic/state/snackbar/index.ts
var snackbar = __webpack_require__(11224);
// EXTERNAL MODULE: ./src/components/shared/verification-code-form.tsx
var verification_code_form = __webpack_require__(32468);
;// CONCATENATED MODULE: ./src/components/checkout/guest-booking/guest-otp-form.tsx
















var emailIcon = "/icons/shared/emailIcon.svg";
var GuestOtpForm = function() {
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), error = ref3[0], setError = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,state_dialog/* useDialog */.R)(function(s) {
        return [
            s.dialog,
            s.setDialog
        ];
    }, shallow/* default */.Z), 2), dialog = ref4[0], setDialog = ref4[1];
    var setSnack = (0,snackbar/* useSnack */.e)(function(s) {
        return s.setSnack;
    }, shallow/* default */.Z);
    var setGuestBookingInfo = (0,state/* useOrder */.Aj)(function(s) {
        return s.setGuestBookingInfo;
    }, shallow/* default */.Z);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,state/* useOtpTimer */.lT)(function(s) {
        return [
            s.otpTimer,
            s.setOtpTimer
        ];
    }, shallow/* default */.Z), 2), otpTimer = ref5[0], setOtpTimer = ref5[1];
    var isTimerRunning = otpTimer === null || otpTimer === void 0 ? void 0 : otpTimer.isRunning;
    var reSendOtp = (0,otp/* useSendOtp */.p)();
    var verifyGuestOtp = (0,services/* useVerifyGuestOtp */.Sy)();
    var onCloseDialog = (0,react.useCallback)(function() {
        setDialog({});
        setOtpTimer({
            timerVal: 0,
            isRunning: true
        });
    }, [
        setDialog,
        setOtpTimer
    ]);
    var handleFormSubmit = (0,react.useCallback)(function(data) {
        var ref;
        setError(false);
        verifyGuestOtp.safeMutateAsync({
            data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                phoneNumber: dialog === null || dialog === void 0 ? void 0 : (ref = dialog.phoneNumberFormPayload) === null || ref === void 0 ? void 0 : ref.phoneNumber
            })
        }, {
            onSuccess: function(res) {
                onCloseDialog();
                setGuestBookingInfo(function(prevState) {
                    var ref, ref1;
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                        guestUserId: res === null || res === void 0 ? void 0 : (ref = res.guestUser) === null || ref === void 0 ? void 0 : ref.id,
                        isGuestVerified: res === null || res === void 0 ? void 0 : (ref1 = res.guestUser) === null || ref1 === void 0 ? void 0 : ref1.isVerified
                    });
                });
            },
            onError: function(error) {
                if (axios_default().isAxiosError(error)) {
                    setSnack({
                        isOpen: true,
                        message: "checkout.guest.otp.error",
                        type: "error"
                    });
                    setError(true);
                }
            }
        });
    }, [
        dialog === null || dialog === void 0 ? void 0 : (ref = dialog.phoneNumberFormPayload) === null || ref === void 0 ? void 0 : ref.phoneNumber,
        onCloseDialog,
        setGuestBookingInfo,
        setSnack,
        verifyGuestOtp, 
    ]);
    var handleCodeResend = (0,react.useCallback)(function() {
        var ref;
        setError(false);
        setOtpTimer(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                timerVal: 0
            });
        });
        reSendOtp.safeMutateAsync({
            data: {
                phoneNumber: dialog === null || dialog === void 0 ? void 0 : (ref = dialog.phoneNumberFormPayload) === null || ref === void 0 ? void 0 : ref.phoneNumber
            }
        }, {
            onSuccess: function(res) {
                setOtpTimer({
                    timerVal: res === null || res === void 0 ? void 0 : res.retryAfter,
                    isRunning: true
                });
                setSnack({
                    isOpen: true,
                    message: "otp.resent.successfully",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                        img: emailIcon,
                        objectFit: "contain",
                        sx: {
                            width: "16px",
                            height: "16px"
                        }
                    }),
                    type: "info"
                });
            },
            onError: function(error) {
                if (axios_default().isAxiosError(error)) {
                    setOtpTimer({
                        timerVal: 0,
                        isRunning: true
                    });
                }
            }
        });
    }, [
        dialog === null || dialog === void 0 ? void 0 : (ref1 = dialog.phoneNumberFormPayload) === null || ref1 === void 0 ? void 0 : ref1.phoneNumber,
        reSendOtp,
        setOtpTimer,
        setSnack
    ]);
    (0,react.useEffect)(function() {
        if (!isTimerRunning && !error) {
            setSnack({
                isOpen: true,
                message: "checkout.guest.otp.warning",
                type: "warning",
                colorOfText: "common.white"
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isTimerRunning
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(verification_code_form/* VerificationCodeForm */.O, {
        subtitle: "verify.phone.number",
        description: "global.description.code.phone_number",
        value: dialog === null || dialog === void 0 ? void 0 : (ref2 = dialog.phoneNumberFormPayload) === null || ref2 === void 0 ? void 0 : ref2.phoneNumber,
        isVerifyCodeLoading: verifyGuestOtp.isLoading,
        error: error,
        handleFormClose: onCloseDialog,
        handleFormSubmit: handleFormSubmit,
        handleCodeResend: handleCodeResend,
        isSendOtpLoading: reSendOtp === null || reSendOtp === void 0 ? void 0 : reSendOtp.isLoading,
        actionComponent: error || !isTimerRunning && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            variant: "contained",
            fullWidth: true,
            onClick: onCloseDialog,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                component: "span",
                sx: {
                    fontWeight: "bold"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                    id: "checkout.guest.otp.continue_without_verify"
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/checkout/offer-limit-confirm-dialog.tsx







var OfferLimitConfirmDialog = function() {
    var theme = (0,useTheme/* default */.Z)();
    var dialog = (0,state/* useDialog */.Rh)(function(s) {
        return s.dialog;
    }, shallow/* default */.Z);
    var ref = dialog === null || dialog === void 0 ? void 0 : dialog.offerLimitConfirmDialogPayload, mainTitle = ref.mainTitle, handleExitClick = ref.handleExitClick, handleCloseClick = ref.handleCloseClick, handleOkayClick = ref.handleOkayClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(close_button/* CloseButton */.P, {
                    handleClick: handleExitClick
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    sx: {
                        alignItems: "center",
                        margin: "auto",
                        textAlign: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: theme.palette.grey[90],
                                fontSize: (0,typography/* pxToRem */.Q)(22),
                                fontWeight: 700,
                                lineHeight: "33px",
                                marginBottom: (0,typography/* pxToRem */.Q)(24)
                            },
                            children: mainTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: theme.palette.grey[70],
                                fontSize: (0,typography/* pxToRem */.Q)(18),
                                fontWeight: 400,
                                lineHeight: "27px",
                                textAlign: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                id: "offer.limit.confirm.description"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        id: "offer-limit-confirm-dialog-update",
                        type: "button",
                        fullWidth: true,
                        sx: {
                            fontFamily: theme.palette.typography.font.bold,
                            color: theme.palette.grey[70]
                        },
                        onClick: handleCloseClick,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                            id: "offer.update_seats"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        id: "offer-limit-confirm-dialog-proceed",
                        type: "button",
                        variant: "contained",
                        fullWidth: true,
                        onClick: handleOkayClick,
                        sx: {
                            height: {
                                mobile: "56px",
                                tablet: (0,typography/* pxToRem */.Q)(56)
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                            id: "global.proceed"
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/checkout/offer-limit-info-dialog.tsx







var OfferLimitInfoDialog = function() {
    var theme = (0,useTheme/* default */.Z)();
    var dialog = (0,state/* useDialog */.Rh)(function(s) {
        return s.dialog;
    }, shallow/* default */.Z);
    var ref = dialog === null || dialog === void 0 ? void 0 : dialog.offerLimitInfoDialogPayload, mainTitle = ref.mainTitle, handleClick = ref.handleClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(close_button/* CloseButton */.P, {
                    handleClick: handleClick
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    sx: {
                        alignItems: "center",
                        margin: "auto",
                        textAlign: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: theme.palette.grey[90],
                                fontSize: (0,typography/* pxToRem */.Q)(22),
                                fontWeight: 700,
                                lineHeight: "33px",
                                marginBottom: (0,typography/* pxToRem */.Q)(24)
                            },
                            children: mainTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: theme.palette.grey[70],
                                fontSize: (0,typography/* pxToRem */.Q)(18),
                                fontWeight: 400,
                                lineHeight: "27px",
                                textAlign: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                id: "offer.limit.info.description"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    id: "offer-limit-info-dialog-okay",
                    variant: "contained",
                    fullWidth: true,
                    onClick: handleClick,
                    sx: {
                        height: {
                            mobile: "56px",
                            tablet: (0,typography/* pxToRem */.Q)(56)
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                        id: "global.okay"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/home/change-city-confirm-dialog.tsx






var ChangeCityImage = "/icons/dialog/change-city-image.svg";
var defaultDescription = "change_city_confirm_dialog.description";
var ChangeCityConfirmDialog = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,state/* useDialog */.Rh)(function(s) {
        return [
            s.dialog,
            s.setDialog
        ];
    }, shallow/* default */.Z), 2), dialog = ref[0], setDialog = ref[1];
    var setSideMenu = (0,state/* useSideMenu */.W0)(function(s) {
        return s.setSideMenu;
    }, shallow/* default */.Z);
    var ref1 = (0,react.useState)(defaultDescription), description = ref1[0], setDescription = ref1[1];
    var handleOkayClick = (0,react.useCallback)(function() {
        var ref;
        setSideMenu(false);
        dialog === null || dialog === void 0 ? void 0 : (ref = dialog.changeCityConfirmDialogPayload) === null || ref === void 0 ? void 0 : ref.handleOkayClick();
    }, [
        dialog === null || dialog === void 0 ? void 0 : dialog.changeCityConfirmDialogPayload,
        setSideMenu
    ]);
    (0,react.useEffect)(function() {
        var ref;
        setDescription((dialog === null || dialog === void 0 ? void 0 : (ref = dialog.changeCityConfirmDialogPayload) === null || ref === void 0 ? void 0 : ref.description) || defaultDescription);
    }, [
        dialog === null || dialog === void 0 ? void 0 : dialog.changeCityConfirmDialogPayload
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(confirm_dialog/* ConfirmDialog */.Q, {
        buttonId: "change-city-confirm-dialog",
        img: ChangeCityImage,
        widthImage: "66px",
        heightImage: "74px",
        altImage: "alt.change_city_image",
        title: "change_city_confirm_dialog.title",
        description: description,
        handleOkayClick: handleOkayClick,
        handleCloseClick: function() {
            return setDialog({});
        }
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@mui/material/RadioGroup/RadioGroup.js
var RadioGroup = __webpack_require__(68061);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
;// CONCATENATED MODULE: ./src/components/home/location-card.tsx






var LocationCard = function(param) {
    var title = param.title, subtitle = param.subtitle, cinemasCount = param.cinemasCount, img = param.img;
    var theme = (0,useTheme/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        direction: "row",
        spacing: 2,
        sx: {
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                img: img,
                title: intl.formatMessage({
                    id: "images.title.location"
                }),
                objectFit: "contain",
                sx: {
                    alignSelf: "center",
                    width: "48px",
                    height: "48px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        component: "div",
                        sx: {
                            fontFamily: "co-head-line-corp-bold",
                            color: theme.palette.common.black
                        },
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        component: "div",
                        sx: {
                            marginTop: (0,typography/* pxToRem */.Q)(4),
                            fontSize: (0,typography/* pxToRem */.Q)(14),
                            lineHeight: (0,typography/* pxToRem */.Q)(24),
                            color: theme.palette.typography.color.muted
                        },
                        children: [
                            cinemasCount !== null && cinemasCount !== void 0 ? cinemasCount : null,
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                id: subtitle
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var location_card = (LocationCard);

;// CONCATENATED MODULE: ./src/components/home/cities-form.tsx














var CityLocationImg = "/icons/dialog/city-location.svg";
var MyLocationImg = "/icons/dialog/my-location.svg";
var enableLocationSelection = false;
var CitiesForm = function() {
    var ref;
    var theme = (0,useTheme/* default */.Z)();
    var ref1 = (0,react.useState)(null), selectedCityId = ref1[0], setSelectedCityId = ref1[1];
    var setSnack = (0,state/* useSnack */.eW)(function(s) {
        return s.setSnack;
    }, shallow/* default */.Z);
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,state/* useDialog */.Rh)(function(s) {
        return [
            s.dialog,
            s.setDialog
        ];
    }, shallow/* default */.Z), 2), dialog = ref2[0], setDialog = ref2[1];
    var cities = (0,state/* useCities */.M1)(function(s) {
        return s.cities;
    }, shallow/* default */.Z);
    var setGuest = (0,state/* useGuest */.Js)(function(s) {
        return s.setGuest;
    }, shallow/* default */.Z);
    var setUser = (0,state/* useAuth */.aC)(function(s) {
        return s.setUser;
    }, shallow/* default */.Z);
    var getNearestCity = (0,services/* useGetNearestCity */.GG)();
    var updateAuthUserCity = (0,services/* useUpdateAuthUserCity */.Ri)();
    var loading = getNearestCity.isLoading || updateAuthUserCity.isLoading;
    var submitSelectedCity = (0,react.useCallback)(function(selectedCityId) {
        updateAuthUserCity.safeMutateAsync({
            data: {
                cityId: selectedCityId
            }
        }, {
            onSuccess: function(data) {
                var _user = data.user, _ = _user.language, restUserData = (0,_object_without_properties/* default */.Z)(_user, [
                    "language"
                ]);
                setUser(function(prevState) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState, restUserData), {
                        preferredCityId: data.user.preferredCityId
                    });
                });
                setSnack({
                    isOpen: true,
                    message: "cities_form.location.success",
                    type: "success"
                });
                setDialog({});
            }
        });
    }, [
        setDialog,
        setSnack,
        setUser,
        updateAuthUserCity
    ]);
    var handleSelectedCity = (0,react.useCallback)(function(selectedCityId) {
        var ref;
        if (dialog === null || dialog === void 0 ? void 0 : (ref = dialog.citiesFormPayload) === null || ref === void 0 ? void 0 : ref.isUser) {
            submitSelectedCity(selectedCityId);
        } else {
            setGuest(function(prevState) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                    preferredCityId: selectedCityId
                });
            });
            setSnack({
                isOpen: true,
                message: "cities_form.location.success",
                type: "success"
            });
            setDialog({});
        }
    }, [
        dialog === null || dialog === void 0 ? void 0 : (ref = dialog.citiesFormPayload) === null || ref === void 0 ? void 0 : ref.isUser,
        setDialog,
        setGuest,
        setSnack,
        submitSelectedCity
    ]);
    var onSubmit = (0,react.useCallback)(function() {
        if (selectedCityId === "current-location") {
            navigator.geolocation.getCurrentPosition(function(clientCurrentLocation) {
                var coords = clientCurrentLocation.coords;
                getNearestCity.safeMutateAsync({
                    params: {
                        lat: coords === null || coords === void 0 ? void 0 : coords.latitude,
                        long: coords === null || coords === void 0 ? void 0 : coords.longitude
                    }
                }, {
                    onSuccess: function(data) {
                        return handleSelectedCity(data.cityId);
                    }
                });
            }, function(e) {
                setSnack({
                    isOpen: true,
                    message: e.code === 1 ? "cities_form.location.error.permission" : e.code === 2 ? "cities_form.location.error.unavailable" : e.message,
                    type: "error"
                });
            });
        } else {
            handleSelectedCity(Number(selectedCityId));
        }
    }, [
        getNearestCity,
        handleSelectedCity,
        selectedCityId,
        setSnack
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        id: "cities-title",
                        component: "div",
                        sx: {
                            marginTop: (0,typography/* pxToRem */.Q)(52),
                            fontSize: (0,typography/* pxToRem */.Q)(20),
                            fontFamily: "co-head-line-corp-bold",
                            color: theme.palette.common.black,
                            textAlign: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                            id: "cities_form.title"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioGroup/* default */.Z, {
                        value: selectedCityId,
                        onChange: function(e) {
                            return setSelectedCityId(e.target.value);
                        },
                        sx: {
                            marginTop: (0,typography/* pxToRem */.Q)(52),
                            marginBottom: (0,typography/* pxToRem */.Q)(20)
                        },
                        children: [
                            enableLocationSelection && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                        value: "current-location",
                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {}),
                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(location_card, {
                                            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                                id: "location_card.title"
                                            }),
                                            subtitle: "location_card.subtitle",
                                            img: MyLocationImg
                                        }),
                                        sx: {
                                            margin: "0px",
                                            marginBottom: (0,typography/* pxToRem */.Q)(16),
                                            "& .MuiRadio-root": {
                                                padding: "0px",
                                                marginRight: (0,typography/* pxToRem */.Q)(16)
                                            }
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                        sx: {
                                            marginBottom: (0,typography/* pxToRem */.Q)(16),
                                            border: "none",
                                            borderTop: "".concat((0,typography/* pxToRem */.Q)(1), " solid ").concat(theme.palette.grey[20])
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    maxHeight: {
                                        mobile: "calc(100vh - ".concat(enableLocationSelection ? "328.375px" : "257.875px", " )"),
                                        tablet: enableLocationSelection ? "176px" : "246.5px"
                                    },
                                    overflow: "auto"
                                },
                                children: cities.citiesList.map(function(param) {
                                    var id = param.id, name = param.name, cinemaCount = param.cinemaCount;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                        id: "city-".concat(name),
                                        value: id,
                                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                            id: "city-".concat(name)
                                        }),
                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(location_card, {
                                            title: name,
                                            subtitle: cinemaCount > 1 ? "location_card.cinemas" : "location_card.cinema",
                                            cinemasCount: cinemaCount,
                                            img: CityLocationImg
                                        }),
                                        sx: {
                                            display: "flex",
                                            margin: "0px",
                                            marginBottom: (0,typography/* pxToRem */.Q)(16),
                                            "& .MuiRadio-root": {
                                                padding: "0px",
                                                marginRight: (0,typography/* pxToRem */.Q)(16)
                                            },
                                            "&:last-of-type": {
                                                marginBottom: "0px"
                                            }
                                        }
                                    }, id);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                    id: "city-submit",
                    variant: "contained",
                    fullWidth: true,
                    disabled: !selectedCityId,
                    loading: loading,
                    onClick: onSubmit,
                    sx: {
                        height: {
                            tablet: (0,typography/* pxToRem */.Q)(56),
                            mobile: "56px"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                        id: "global.select"
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/constants/offers.ts
var constants_offers = __webpack_require__(68146);
;// CONCATENATED MODULE: ./src/components/offers/dialogs/info-dialogs/not-available-offer-info-dialog.tsx












var NotAvailableOfferInfoDialog = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var theme = (0,useTheme/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,state/* useDialog */.Rh)(function(s) {
        return [
            s.dialog,
            s.setDialog
        ];
    }, shallow/* default */.Z), 2), dialog = ref6[0], setDialog = ref6[1];
    var handleOkayClick = (0,react.useCallback)(function() {
        setDialog({});
        router.push("/");
    }, [
        router,
        setDialog
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(close_button/* CloseButton */.P, {
                    handleClick: handleOkayClick
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    sx: {
                        alignItems: "center",
                        margin: "auto",
                        textAlign: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            sx: {
                                alignItems: "center",
                                marginBlock: 4
                            },
                            spacing: "4px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                                    img: dialog === null || dialog === void 0 ? void 0 : (ref = dialog.notAvailableOfferInfoDialogPayload) === null || ref === void 0 ? void 0 : ref.img,
                                    title: (dialog === null || dialog === void 0 ? void 0 : (ref1 = dialog.notAvailableOfferInfoDialogPayload) === null || ref1 === void 0 ? void 0 : ref1.logoUrlAlt) || intl.formatMessage({
                                        id: "alt.not_available_offer"
                                    }),
                                    objectFit: "cover",
                                    sx: {
                                        borderRadius: "5px",
                                        overflow: "hidden",
                                        width: "87px",
                                        height: "44px"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    component: "span",
                                    sx: {
                                        fontSize: {
                                            mobile: "14px",
                                            tablet: (0,typography/* pxToRem */.Q)(16)
                                        },
                                        fontFamily: theme.palette.typography.font.bold,
                                        lineHeight: "24px",
                                        color: theme.palette.grey[80]
                                    },
                                    children: (dialog === null || dialog === void 0 ? void 0 : (ref2 = dialog.notAvailableOfferInfoDialogPayload) === null || ref2 === void 0 ? void 0 : ref2.validationType) === constants_offers/* ValidationTypes.BIN */.PA.BIN ? dialog === null || dialog === void 0 ? void 0 : (ref3 = dialog.notAvailableOfferInfoDialogPayload) === null || ref3 === void 0 ? void 0 : ref3.bankName : dialog === null || dialog === void 0 ? void 0 : (ref4 = dialog.notAvailableOfferInfoDialogPayload) === null || ref4 === void 0 ? void 0 : ref4.hint
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    component: "span",
                                    sx: {
                                        fontSize: {
                                            mobile: "13px",
                                            tablet: (0,typography/* pxToRem */.Q)(14)
                                        },
                                        lineHeight: {
                                            tablet: (0,typography/* pxToRem */.Q)(24)
                                        },
                                        color: theme.palette.grey[50]
                                    },
                                    children: dialog === null || dialog === void 0 ? void 0 : (ref5 = dialog.notAvailableOfferInfoDialogPayload) === null || ref5 === void 0 ? void 0 : ref5.title
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: theme.palette.grey[90],
                                fontSize: (0,typography/* pxToRem */.Q)(22),
                                fontWeight: 700,
                                lineHeight: "33px",
                                marginBottom: (0,typography/* pxToRem */.Q)(24)
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                id: "offers.not_available_offer_info_dialog.title"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: theme.palette.grey[70],
                                fontSize: (0,typography/* pxToRem */.Q)(18),
                                fontWeight: 400,
                                lineHeight: "27px",
                                textAlign: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                id: "offers.not_available_offer_info_dialog.description"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    id: "not-available-offer-info-dialog-okay",
                    variant: "contained",
                    fullWidth: true,
                    onClick: handleOkayClick,
                    sx: {
                        height: {
                            tablet: (0,typography/* pxToRem */.Q)(56),
                            mobile: "56px"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                        id: "global.okay"
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/constants/payment.ts
var payment = __webpack_require__(49135);
;// CONCATENATED MODULE: ./src/components/profile/add-credit-card-form/bank-offer-hint.tsx



var BankOfferHint = function() {
    var theme = (0,useTheme/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
        component: "span",
        sx: {
            display: "inline-block",
            marginTop: "16px",
            fontSize: "16px",
            textAlign: "left",
            color: theme.palette.primary.main
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
            id: "my_credit_cards.bank_offer_hint"
        })
    });
};

// EXTERNAL MODULE: ./src/components/shared/dialog-form/dialog-form-title.tsx
var dialog_form_title = __webpack_require__(49742);
// EXTERNAL MODULE: ./src/components/shared/add-credit-card/supported-credit-cards.tsx
var supported_credit_cards = __webpack_require__(58614);
// EXTERNAL MODULE: ./src/components/shared/add-credit-card/credit-card-name-input.tsx
var credit_card_name_input = __webpack_require__(45593);
// EXTERNAL MODULE: ./src/components/shared/add-credit-card/credit-card-number-input.tsx
var credit_card_number_input = __webpack_require__(32353);
// EXTERNAL MODULE: ./src/components/shared/add-credit-card/credit-card-holder-input.tsx
var credit_card_holder_input = __webpack_require__(24837);
// EXTERNAL MODULE: ./src/components/shared/add-credit-card/credit-card-cvv-input.tsx
var credit_card_cvv_input = __webpack_require__(20569);
// EXTERNAL MODULE: ./src/components/shared/add-credit-card/credit-card-switch-input.tsx
var credit_card_switch_input = __webpack_require__(97313);
// EXTERNAL MODULE: ./src/components/shared/dialog-form/dialog-form-button.tsx
var dialog_form_button = __webpack_require__(27708);
;// CONCATENATED MODULE: ./src/components/profile/add-credit-card-form/add-credit-card-form.tsx





































// TODO: check this card number validation 3777 7777 7777 7777 (it should return amex card type)
var publicRuntimeConfig = config_default()().publicRuntimeConfig;
var AddCreditCardForm = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var intl = (0,useIntl/* default */.Z)();
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var ref14 = (0,react.useState)(true), isCardDefault = ref14[0], setIsCardDefault = ref14[1];
    var user = (0,state/* useAuth */.aC)(function(s) {
        return s.user;
    }, shallow/* default */.Z);
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,state/* useDialog */.Rh)(function(s) {
        return [
            s.dialog,
            s.setDialog
        ];
    }, shallow/* default */.Z), 2), dialog = ref15[0], setDialog = ref15[1];
    var setSnack = (0,state/* useSnack */.eW)(function(s) {
        return s.setSnack;
    }, shallow/* default */.Z);
    var ref16 = (0,_sliced_to_array/* default */.Z)((0,state/* useOrder */.Aj)(function(s) {
        return [
            s.order,
            s.setOrder,
            s.guestBookingInfo,
            s.setGuestBookingInfo
        ];
    }, shallow/* default */.Z), 4), order = ref16[0], setOrder = ref16[1], guestBookingInfo = ref16[2], setGuestBookingInfo = ref16[3];
    var verifiedOffer = (0,state/* useVerifiedOffer */.s$)(function(s) {
        return s.verifiedOffer;
    }, shallow/* default */.Z);
    var verifiedOfferBin = (0,state/* useVerifiedOfferBin */.mN)(function(s) {
        return s.verifiedOfferBin;
    }, shallow/* default */.Z);
    var ref17 = (0,hooks/* useCreditCardValidation */.uk)(), creditCardNumber = ref17.creditCardNumber, creditCardCvv = ref17.creditCardCvv, isCreditCardNumberValid = ref17.isCreditCardNumberValid, isCreditCardCvvValid = ref17.isCreditCardCvvValid, creditCardType = ref17.creditCardType, handleCreditCardNumberChange = ref17.handleCreditCardNumberChange, handleCreditCardCvvChange = ref17.handleCreditCardCvvChange;
    var ref18 = (0,hooks/* useCheckoutTokenization */.sV)(), isCheckoutLoading = ref18.isCheckoutLoading, checkoutTokenizationController = ref18.checkoutTokenizationController, checkoutTokenization = ref18.checkoutTokenization;
    var ref19 = (0,hooks/* useHyperPayTokenization */.Ci)(), isHyperPayLoading = ref19.isHyperPayLoading, hyperPayTokenizationController = ref19.hyperPayTokenizationController, hyperPayTokenization = ref19.hyperPayTokenization;
    var ref20 = (0,hooks/* usePayFortTokenization */.lz)(), isPayFortLoading = ref20.isPayFortLoading, PayFortTokenizationController = ref20.PayFortTokenizationController, PayFortTokenization = ref20.PayFortTokenization;
    var hashedCardBin = (0,react.useMemo)(function() {
        return {
            bh6: (0,shared/* hashString */.Wu)((0,shared/* sliceStringWithoutSpaces */.HV)(creditCardNumber, 6)),
            bh8: (0,shared/* hashString */.Wu)((0,shared/* sliceStringWithoutSpaces */.HV)(creditCardNumber))
        };
    }, [
        creditCardNumber
    ]);
    var initAddCard = (0,services/* useInitializeAddCard */.eX)({}, {
        enabled: false
    });
    var initHyperPayAddCard = (0,services/* useInitHyperPayAddCard */.sY)({}, {
        enabled: false
    });
    var initPayFortAddCard = (0,services/* useInitPayFortPayAddCard */.ql)({}, {
        enabled: false
    });
    var addCard = (0,services/* useAddCard */.fX)();
    var checkCard = (0,services/* useCheckCard */.xP)();
    var guestBookingHyperPayInitAddCard = (0,services/* useGuestBookingHyperPayInitializeAddCard */.Jb)();
    var guestBookingPayFortInitAddCard = (0,services/* useGuestBookingPayFortInitializeAddCard */.UO)();
    var schema = es/* object */.Ry({
        isCardSavedForFuturePayments: es/* boolean */.O7(),
        cardName: es/* string */.Z_().when("isCardSavedForFuturePayments", {
            is: true,
            then: function(schema) {
                return schema.required().max(40, intl.formatMessage({
                    id: "my_credit_cards.card_name.validation.fail"
                }));
            },
            otherwise: function(schema) {
                return schema.optional();
            }
        }),
        cardHolder: es/* string */.Z_().required().min(3, intl.formatMessage({
            id: "my_credit_cards.card_holder.validation.fail"
        })).max(50, intl.formatMessage({
            id: "my_credit_cards.card_holder.validation.fail"
        })).test("onlyLettersSpaces", intl.formatMessage({
            id: "my_credit_cards.card_holder.validation.fail"
        }), function(value) {
            return regular_expressions/* onlyEnglishLettersAndSpaces.test */.mj.test(value);
        }),
        expiryDate: es/* date */.hT().required().min(luxon/* DateTime.now */.ou.now().toFormat("yyyy-MM"), intl.formatMessage({
            id: "my_credit_cards.expiry_date.invalid"
        })).max(luxon/* DateTime.now */.ou.now().plus({
            years: 20
        }).toFormat("yyyy-MM"), intl.formatMessage({
            id: "my_credit_cards.expiry_date.invalid"
        })).typeError(intl.formatMessage({
            id: "my_credit_cards.expiry_date.invalid"
        })).nullable()
    });
    var ref21 = dialog === null || dialog === void 0 ? void 0 : dialog.addCreditCardFormPayload, isBookingFlow = ref21.isBookingFlow, paymentGateway = ref21.paymentGateway, title = ref21.title;
    var ref22 = (0,index_esm/* useForm */.cI)({
        resolver: (0,yup/* yupResolver */.X)(schema),
        mode: "onChange",
        reValidateMode: "onChange",
        defaultValues: {
            isCardSavedForFuturePayments: !isBookingFlow,
            cardName: "",
            cardHolder: "",
            expiryDate: null
        }
    }), getValues = ref22.getValues, setValue = ref22.setValue, register = ref22.register, trigger = ref22.trigger, _formState = ref22.formState, isValid = _formState.isValid, errors = _formState.errors;
    (0,react.useEffect)(function() {
        !(order === null || order === void 0 ? void 0 : order.isApplePaySelected) && setOrder(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                isApplePaySelected: false
            });
        });
    }, [
        order === null || order === void 0 ? void 0 : order.isApplePaySelected
    ]);
    var isFormValid = isValid && isCreditCardNumberValid && isCreditCardCvvValid;
    var isLoading = isCheckoutLoading || isHyperPayLoading || isPayFortLoading || addCard.isLoading || checkCard.isLoading || guestBookingHyperPayInitAddCard.isLoading || guestBookingPayFortInitAddCard.isLoading || initAddCard.isFetching || initHyperPayAddCard.isFetching || initPayFortAddCard.isFetching;
    var formTitle = isBookingFlow && (order === null || order === void 0 ? void 0 : order.isGuestBookingEnabled) && !(user === null || user === void 0 ? void 0 : user.isCompleteProfile) ? "checkout.pay_with_card" : title ? title : "my_credit_cards.new_credit_card";
    var handleCloseClick = function() {
        setDialog({});
    };
    var handleFormSwitchChange = function(e) {
        if (isBookingFlow) {
            setValue("isCardSavedForFuturePayments", e.target.checked, {
                shouldValidate: true
            });
        } else {
            setIsCardDefault(e.target.checked);
        }
    };
    var handleCheckoutTokenization = function() {
        var abortParallelTokenization = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var expiryDateArr = getValues("expiryDate").split("-");
        var expiryMonth = Number(expiryDateArr[1]);
        var expiryYear = Number(expiryDateArr[0]);
        return checkoutTokenization({
            checkoutUrl: publicRuntimeConfig.checkoutTokenUrl,
            checkoutKey: publicRuntimeConfig.checkoutPublicKey,
            creditCardNumber: creditCardNumber,
            creditCardCvv: creditCardCvv,
            creditCardHolder: getValues("cardHolder"),
            expiryMonth: expiryMonth,
            expiryYear: expiryYear,
            errorCallback: function() {
                if (abortParallelTokenization) {
                    queryClient.cancelQueries([
                        {
                            method: "get",
                            url: "cards/hyper-pay/initialize-add-card"
                        }, 
                    ]);
                    queryClient.cancelQueries([
                        {
                            method: "get",
                            url: "cards/payfort/initialize-add-card"
                        }, 
                    ]);
                    hyperPayTokenizationController.abort();
                    PayFortTokenizationController.abort();
                }
                throw new Error("my_credit_cards.payment_gateway.fail");
            }
        });
    };
    var handlePayFortTokenization = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var abortParallelTokenization, initializedCardsData, payFortData, data, data1, expiryDateArr, expiryMonth, expiryYear, error;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        abortParallelTokenization = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : false, initializedCardsData = _arguments.length > 1 ? _arguments[1] : void 0;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        if (!((order === null || order === void 0 ? void 0 : order.isGuestBookingEnabled) && isBookingFlow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            guestBookingPayFortInitAddCard.safeMutateAsync({
                                data: {
                                    firstName: guestBookingInfo === null || guestBookingInfo === void 0 ? void 0 : guestBookingInfo.firstName,
                                    lastName: guestBookingInfo === null || guestBookingInfo === void 0 ? void 0 : guestBookingInfo.lastName,
                                    phonenumber: guestBookingInfo === null || guestBookingInfo === void 0 ? void 0 : guestBookingInfo.phoneNumber,
                                    email: guestBookingInfo === null || guestBookingInfo === void 0 ? void 0 : guestBookingInfo.email
                                },
                                headers: {
                                    "x-session-id": order === null || order === void 0 ? void 0 : order.userSessionId
                                }
                            }, {
                                onError: function() {
                                    throw new Error();
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent();
                        payFortData = data.payfort;
                        return [
                            3,
                            6
                        ];
                    case 3:
                        if (!initializedCardsData) return [
                            3,
                            4
                        ];
                        if (initializedCardsData.status === "error") {
                            throw new Error();
                        }
                        payFortData = initializedCardsData.data.payfort;
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            initPayFortAddCard.refetch()
                        ];
                    case 5:
                        data1 = _state.sent();
                        if (data1.status === "error") {
                            throw new Error();
                        }
                        payFortData = data1.data.payfort;
                        _state.label = 6;
                    case 6:
                        expiryDateArr = getValues("expiryDate").split("-");
                        expiryMonth = Number(expiryDateArr[1]);
                        expiryYear = Number(expiryDateArr[0]);
                        return [
                            2,
                            PayFortTokenization((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                PayFortUrl: publicRuntimeConfig.PayFortTokenUrl,
                                creditCardNumber: creditCardNumber,
                                creditCardHolder: getValues("cardHolder"),
                                expiryMonth: expiryMonth,
                                expiryYear: expiryYear
                            }, payFortData), {
                                errorCallback: function(errorMessage) {
                                    setSnack({
                                        isOpen: true,
                                        message: errorMessage,
                                        type: "error"
                                    });
                                    throw new Error();
                                }
                            }))
                        ];
                    case 7:
                        error = _state.sent();
                        if (abortParallelTokenization) {
                            queryClient.cancelQueries([
                                {
                                    method: "get",
                                    url: "cards/hyper-pay/initialize-add-card"
                                }
                            ]);
                            checkoutTokenizationController.abort();
                            hyperPayTokenizationController.abort();
                        }
                        throw new Error("my_credit_cards.payment_gateway.fail");
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function handlePayFortTokenization() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleHyperPayTokenization = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var abortParallelTokenization, initializedCardsData, hyperPayCheckId, data, data1, expiryDateArr, expiryMonth, expiryYear, error;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        abortParallelTokenization = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : false, initializedCardsData = _arguments.length > 1 ? _arguments[1] : void 0;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            7,
                            ,
                            8
                        ]);
                        hyperPayCheckId = "";
                        if (!((order === null || order === void 0 ? void 0 : order.isGuestBookingEnabled) && isBookingFlow)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            guestBookingHyperPayInitAddCard.safeMutateAsync({
                                data: (0,_object_spread/* default */.Z)({
                                    firstName: guestBookingInfo === null || guestBookingInfo === void 0 ? void 0 : guestBookingInfo.firstName,
                                    lastName: guestBookingInfo === null || guestBookingInfo === void 0 ? void 0 : guestBookingInfo.lastName,
                                    phonenumber: guestBookingInfo === null || guestBookingInfo === void 0 ? void 0 : guestBookingInfo.phoneNumber,
                                    email: guestBookingInfo === null || guestBookingInfo === void 0 ? void 0 : guestBookingInfo.email
                                }, hashedCardBin),
                                headers: {
                                    "x-session-id": order === null || order === void 0 ? void 0 : order.userSessionId
                                }
                            }, {
                                onError: function() {
                                    throw new Error();
                                }
                            })
                        ];
                    case 2:
                        data = _state.sent();
                        hyperPayCheckId = data.checkId;
                        return [
                            3,
                            6
                        ];
                    case 3:
                        if (!initializedCardsData) return [
                            3,
                            4
                        ];
                        if (initializedCardsData.status === "error") {
                            throw new Error();
                        }
                        hyperPayCheckId = initializedCardsData.data.checkId;
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            initHyperPayAddCard.refetch()
                        ];
                    case 5:
                        data1 = _state.sent();
                        if (data1.status === "error") {
                            throw new Error();
                        }
                        hyperPayCheckId = data1.data.checkId;
                        _state.label = 6;
                    case 6:
                        expiryDateArr = getValues("expiryDate").split("-");
                        expiryMonth = expiryDateArr[1];
                        expiryYear = expiryDateArr[0];
                        return [
                            2,
                            hyperPayTokenization({
                                hyperPayUrl: publicRuntimeConfig.hyperPayTokenUrl,
                                hyperPayCheckId: hyperPayCheckId,
                                creditCardNumber: creditCardNumber,
                                creditCardCvv: creditCardCvv,
                                creditCardHolder: getValues("cardHolder"),
                                creditCardType: creditCardType,
                                expiryMonth: expiryMonth,
                                expiryYear: expiryYear,
                                errorCallback: function() {
                                    throw new Error();
                                }
                            })
                        ];
                    case 7:
                        error = _state.sent();
                        if (abortParallelTokenization) {
                            queryClient.cancelQueries([
                                {
                                    method: "get",
                                    url: "cards/payfort/initialize-add-card"
                                }
                            ]);
                            checkoutTokenizationController.abort();
                            PayFortTokenizationController.abort();
                        }
                        throw new Error("my_credit_cards.payment_gateway.fail");
                    case 8:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleHyperPayTokenization() {
            return _ref.apply(this, arguments);
        };
    }();
    var selectCard = function(isCardValidToSelect, newCard, manualPay) {
        if (!getValues("isCardSavedForFuturePayments")) {
            var ref;
            setOrder(function(prevState) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                    newCardId: isCardValidToSelect ? newCard.id : null,
                    temporaryAddedCreditCards: isCardValidToSelect ? (0,_to_consumable_array/* default */.Z)(prevState === null || prevState === void 0 ? void 0 : prevState.temporaryAddedCreditCards).concat([
                        newCard
                    ]) : (0,_to_consumable_array/* default */.Z)(prevState === null || prevState === void 0 ? void 0 : prevState.temporaryAddedCreditCards)
                });
            });
            order === null || order === void 0 ? void 0 : (ref = order.handleCreditCardsCvvListChange) === null || ref === void 0 ? void 0 : ref.call(order, {
                id: newCard.id,
                cvv: creditCardCvv
            });
            if (!manualPay && isCardValidToSelect) {
                var ref1;
                order === null || order === void 0 ? void 0 : (ref1 = order.handlePayOrder) === null || ref1 === void 0 ? void 0 : ref1.call(order, newCard.id, creditCardCvv, false); // here
            }
        } else if (isBookingFlow) {
            setOrder(function(prevState) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                    newCardId: isCardValidToSelect ? newCard.id : null
                });
            });
        }
        setDialog({});
        if (getValues("isCardSavedForFuturePayments")) {
            setSnack({
                isOpen: true,
                message: "my_credit_cards.add.success",
                type: "success",
                id: "card-added-successfully"
            });
            queryClient.invalidateQueries([
                {
                    method: "get",
                    url: "cards",
                    params: {
                        limit: 50,
                        page: 1
                    }
                }, 
            ]);
        }
    };
    var submitData = function(checkoutToken, hyperPayCheckId, payfortToken) {
        var cardDetails = !getValues("isCardSavedForFuturePayments") ? (0,_object_spread/* default */.Z)({
            save: false,
            orderId: order === null || order === void 0 ? void 0 : order.id
        }, checkoutToken ? {
            token: checkoutToken
        } : hyperPayCheckId ? {
            checkId: hyperPayCheckId
        } : payfortToken ? {
            payfortToken: payfortToken
        } : {}) : {
            save: true,
            name: getValues("cardName"),
            isDefault: isBookingFlow ? false : isCardDefault,
            token: checkoutToken,
            checkId: hyperPayCheckId,
            payfortToken: payfortToken
        };
        addCard.safeMutateAsync({
            data: (0,_object_spread/* default */.Z)({}, cardDetails, hashedCardBin)
        }, {
            onSuccess: function(data) {
                var ref;
                if ((order === null || order === void 0 ? void 0 : order.offer) && (order === null || order === void 0 ? void 0 : (ref = order.offer) === null || ref === void 0 ? void 0 : ref.validationType) === constants_offers/* ValidationTypes.BIN */.PA.BIN && isBookingFlow) {
                    checkCard.safeMutateAsync({
                        query: {
                            id: order === null || order === void 0 ? void 0 : order.id
                        },
                        params: {
                            cardId: data.card.id.toString(),
                            bin: verifiedOfferBin
                        }
                    }, {
                        onSuccess: function() {
                            return selectCard(true, data.card);
                        },
                        onError: function(error) {
                            if (axios_default().isAxiosError(error)) {
                                var ref, ref1, ref2, ref3, ref4;
                                var errorCode = error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.code;
                                var cardConfirmDialogPayload = {
                                    img: order === null || order === void 0 ? void 0 : (ref2 = order.offer) === null || ref2 === void 0 ? void 0 : ref2.logoUrl,
                                    info: (order === null || order === void 0 ? void 0 : (ref3 = order.offer) === null || ref3 === void 0 ? void 0 : ref3.validationType) === constants_offers/* ValidationTypes.BIN */.PA.BIN ? order.offer.bankName : order.offer.hint,
                                    title: order === null || order === void 0 ? void 0 : (ref4 = order.offer) === null || ref4 === void 0 ? void 0 : ref4.title
                                };
                                // The card not the same one you verified
                                if (errorCode === 103) {
                                    setDialog({
                                        wrapper: true,
                                        tabletMinHeight: "auto",
                                        isCardNotSameVerifiedConfirmDialog: true,
                                        cardNotSameVerifiedConfirmDialogPayload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cardConfirmDialogPayload), {
                                            handleOkayClick: function() {
                                                return selectCard(false, data.card);
                                            },
                                            handleContinueClick: function() {
                                                var ref;
                                                order === null || order === void 0 ? void 0 : (ref = order.handleOfferRemove) === null || ref === void 0 ? void 0 : ref.call(order, {
                                                    successCallback: function() {
                                                        selectCard(true, data.card, true);
                                                    },
                                                    errorCallback: function() {
                                                        selectCard(false, data.card);
                                                    }
                                                });
                                                setDialog({});
                                            }
                                        })
                                    });
                                } else if (errorCode === 104) {
                                    setDialog({
                                        wrapper: true,
                                        tabletMinHeight: "auto",
                                        isCardNotSupportedConfirmDialog: true,
                                        cardNotSupportedConfirmDialogPayload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cardConfirmDialogPayload), {
                                            handleOkayClick: function() {
                                                return selectCard(false, data.card);
                                            },
                                            handleContinueClick: function() {
                                                var ref;
                                                order === null || order === void 0 ? void 0 : (ref = order.handleOfferRemove) === null || ref === void 0 ? void 0 : ref.call(order, {
                                                    successCallback: function() {
                                                        selectCard(true, data.card, true);
                                                    },
                                                    errorCallback: function() {
                                                        selectCard(false, data.card);
                                                    }
                                                });
                                                setDialog({});
                                            }
                                        })
                                    });
                                } else if (errorCode === 107) {
                                    setDialog({
                                        wrapper: true,
                                        tabletMinHeight: "auto",
                                        isCardNotSameAppliedConfirmDialog: true,
                                        cardNotSameAppliedConfirmDialogPayload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cardConfirmDialogPayload), {
                                            handleOkayClick: function() {
                                                return selectCard(false, data.card);
                                            },
                                            handleContinueClick: function() {
                                                var ref;
                                                order === null || order === void 0 ? void 0 : (ref = order.handleOfferRemove) === null || ref === void 0 ? void 0 : ref.call(order, {
                                                    successCallback: function() {
                                                        selectCard(true, data.card, true);
                                                    },
                                                    errorCallback: function() {
                                                        selectCard(false, data.card);
                                                    }
                                                });
                                                setDialog({});
                                            }
                                        })
                                    });
                                } else {
                                    selectCard(false, data.card);
                                }
                            }
                        }
                    });
                } else {
                    selectCard(true, data.card);
                }
            },
            onError: function(error) {
                queryClient.invalidateQueries([
                    {
                        method: "get",
                        url: "cards",
                        params: {
                            limit: 50,
                            page: 1
                        }
                    }, 
                ]);
            }
        });
    };
    var handleGuestBookingSubmitData = function(token, cardBin, cardLast4, expiryMonth, expiryYear) {
        var ref;
        var guestBookingCreditCard = {
            scheme: creditCardType === "visa" ? services/* CreditCardType.Visa */.Oo.Visa : creditCardType === "mastercard" ? services/* CreditCardType.MasterCard */.Oo.MasterCard : creditCardType === "american-express" ? services/* CreditCardType.Amex */.Oo.Amex : null,
            last4: creditCardNumber.slice(-4)
        };
        var payInfo = {
            payToken: token,
            payCardCvv: creditCardCvv,
            payCardBin: cardBin,
            payCardLast4: cardLast4,
            payExpiryMonth: expiryMonth,
            payExpiryYear: expiryYear
        };
        setGuestBookingInfo(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                guestBookingCreditCard: guestBookingCreditCard,
                payInfo: payInfo
            });
        });
        order === null || order === void 0 ? void 0 : (ref = order.handleGuestBookingPayOrder) === null || ref === void 0 ? void 0 : ref.call(order, true, false, payInfo);
        setDialog({});
    };
    var handleSave = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var hyperPayCheckId, expiryDateArr, expiryMonth, expiryYear, payFortToken, ref, ref1, ref2, binIndex, bin, last4, expiryDateArr1, expiryMonth1, expiryYear1, checkoutTokenizationData, initializedCardsData, hyperPayPromise, checkoutPromise, payFortPromise, ref3, hyperPayCheckId1, checkoutTokenizationData1, payFortToken1, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            12,
                            ,
                            13
                        ]);
                        if (!!creditCardType) return [
                            3,
                            1
                        ];
                        setSnack({
                            isOpen: true,
                            message: "my_credit_cards.unsupported_card",
                            type: "error"
                        });
                        return [
                            3,
                            11
                        ];
                    case 1:
                        if (!!getValues("isCardSavedForFuturePayments")) return [
                            3,
                            8
                        ];
                        if (!(paymentGateway === payment/* HYPER_PAY */.gE)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleHyperPayTokenization(false, undefined)
                        ];
                    case 2:
                        hyperPayCheckId = _state.sent();
                        if (order === null || order === void 0 ? void 0 : order.isGuestBookingEnabled) {
                            expiryDateArr = getValues("expiryDate").split("-");
                            expiryMonth = expiryDateArr[1];
                            expiryYear = expiryDateArr[0];
                            handleGuestBookingSubmitData(hyperPayCheckId, undefined, undefined, expiryMonth, expiryYear);
                        } else {
                            submitData(undefined, hyperPayCheckId, undefined);
                        }
                        return [
                            3,
                            7
                        ];
                    case 3:
                        if (!(paymentGateway === payment/* PAYFORT */._O)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            handlePayFortTokenization(false, undefined)
                        ];
                    case 4:
                        payFortToken = _state.sent();
                        if (order === null || order === void 0 ? void 0 : order.isGuestBookingEnabled) {
                            ;
                            binIndex = payFortToken === null || payFortToken === void 0 ? void 0 : (ref = payFortToken.card_number) === null || ref === void 0 ? void 0 : ref.indexOf("*");
                            bin = payFortToken === null || payFortToken === void 0 ? void 0 : (ref1 = payFortToken.card_number) === null || ref1 === void 0 ? void 0 : ref1.substring(0, binIndex);
                            last4 = payFortToken === null || payFortToken === void 0 ? void 0 : (ref2 = payFortToken.card_number) === null || ref2 === void 0 ? void 0 : ref2.slice(-4);
                            expiryDateArr1 = getValues("expiryDate").split("-");
                            expiryMonth1 = expiryDateArr1[1];
                            expiryYear1 = expiryDateArr1[0];
                            handleGuestBookingSubmitData(payFortToken === null || payFortToken === void 0 ? void 0 : payFortToken.token_name, bin, last4, expiryMonth1, expiryYear1);
                        } else {
                            submitData(undefined, undefined, payFortToken === null || payFortToken === void 0 ? void 0 : payFortToken.token_name);
                        }
                        return [
                            3,
                            7
                        ];
                    case 5:
                        if (!(paymentGateway === payment/* CHECKOUT */.iK)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            handleCheckoutTokenization(false)
                        ];
                    case 6:
                        checkoutTokenizationData = _state.sent();
                        if (order === null || order === void 0 ? void 0 : order.isGuestBookingEnabled) {
                            handleGuestBookingSubmitData(checkoutTokenizationData.token, checkoutTokenizationData.bin, checkoutTokenizationData.last4, checkoutTokenizationData.expiry_month, checkoutTokenizationData.expiry_year);
                        } else {
                            submitData(checkoutTokenizationData.token);
                        }
                        _state.label = 7;
                    case 7:
                        return [
                            3,
                            11
                        ];
                    case 8:
                        return [
                            4,
                            initAddCard.refetch()
                        ];
                    case 9:
                        initializedCardsData = _state.sent();
                        hyperPayPromise = handleHyperPayTokenization(true, initializedCardsData);
                        checkoutPromise = handleCheckoutTokenization(true);
                        payFortPromise = handlePayFortTokenization(true, initializedCardsData);
                        return [
                            4,
                            Promise.all([
                                hyperPayPromise,
                                checkoutPromise,
                                payFortPromise
                            ])
                        ];
                    case 10:
                        ref3 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            3
                        ]), hyperPayCheckId1 = ref3[0], checkoutTokenizationData1 = ref3[1], payFortToken1 = ref3[2];
                        submitData(checkoutTokenizationData1.token, hyperPayCheckId1, payFortToken1 === null || payFortToken1 === void 0 ? void 0 : payFortToken1.token_name);
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            13
                        ];
                    case 12:
                        error = _state.sent();
                        return [
                            3,
                            13
                        ];
                    case 13:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSave() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(close_button/* CloseButton */.P, {
                    disabled: isLoading,
                    handleClick: handleCloseClick
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                sx: {
                    textAlign: "center"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_form_title/* DialogFormTitle */.J, {
                        message: formTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            marginBottom: "calc(24px + ".concat((0,typography/* pxToRem */.Q)(23), ")")
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(supported_credit_cards/* SupportedCreditCards */.e, {}),
                            isBookingFlow && (verifiedOffer === null || verifiedOffer === void 0 ? void 0 : verifiedOffer.isBankOfferApplied) && /*#__PURE__*/ (0,jsx_runtime.jsx)(BankOfferHint, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        spacing: "24px",
                        children: [
                            getValues("isCardSavedForFuturePayments") && /*#__PURE__*/ (0,jsx_runtime.jsx)(credit_card_name_input/* CreditCardNameInput */.d, {
                                isLoading: isLoading,
                                isAutoFocus: isBookingFlow,
                                isError: ((ref = errors.cardName) === null || ref === void 0 ? void 0 : ref.type) && ((ref1 = errors.cardName) === null || ref1 === void 0 ? void 0 : ref1.type) !== "required",
                                helperText: ((ref2 = errors.cardName) === null || ref2 === void 0 ? void 0 : ref2.type) && ((ref3 = errors.cardName) === null || ref3 === void 0 ? void 0 : ref3.type) !== "required" ? (ref4 = errors.cardName) === null || ref4 === void 0 ? void 0 : ref4.message : "",
                                registerFunc: function() {
                                    return register("cardName");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(credit_card_number_input/* CreditCardNumberInput */.G, {
                                creditCardType: creditCardType,
                                creditCardNumber: creditCardNumber,
                                isCreditCardNumberValid: isCreditCardNumberValid,
                                isLoading: isLoading,
                                handleChange: handleCreditCardNumberChange
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(credit_card_holder_input/* CreditCardHolderInput */.k, {
                                isLoading: isLoading,
                                isError: ((ref5 = errors.cardHolder) === null || ref5 === void 0 ? void 0 : ref5.type) && ((ref6 = errors.cardHolder) === null || ref6 === void 0 ? void 0 : ref6.type) !== "required",
                                helperText: ((ref7 = errors.cardHolder) === null || ref7 === void 0 ? void 0 : ref7.type) && ((ref8 = errors.cardHolder) === null || ref8 === void 0 ? void 0 : ref8.type) !== "required" ? (ref9 = errors.cardHolder) === null || ref9 === void 0 ? void 0 : ref9.message : "",
                                registerFunc: function() {
                                    return register("cardHolder");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(credit_card_expiry_date_input/* CreditCardExpiryDateInput */.T, {
                                isLoading: isLoading,
                                isError: ((ref10 = errors.expiryDate) === null || ref10 === void 0 ? void 0 : ref10.type) && ((ref11 = errors.expiryDate) === null || ref11 === void 0 ? void 0 : ref11.type) !== "required",
                                helperText: (ref12 = errors.expiryDate) === null || ref12 === void 0 ? void 0 : ref12.message,
                                value: ((ref13 = getValues()) === null || ref13 === void 0 ? void 0 : ref13.expiryDate) || null,
                                registerFunc: function() {
                                    return register("expiryDate");
                                },
                                handleChange: function(e) {
                                    e && setValue("expiryDate", (0,shared/* aN2eN */.wE)(e === null || e === void 0 ? void 0 : e.toFormat("yyyy-MM")));
                                    trigger();
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(credit_card_cvv_input/* CreditCardCvvInput */.A, {
                                creditCardType: creditCardType,
                                creditCardCvv: creditCardCvv,
                                isCreditCardCvvValid: isCreditCardCvvValid,
                                isLoading: isLoading,
                                handleChange: handleCreditCardCvvChange
                            })
                        ]
                    }),
                    !(isBookingFlow && (order === null || order === void 0 ? void 0 : order.isGuestBookingEnabled)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(credit_card_switch_input/* CreditCardSwitchInput */.w, {
                        isLoading: isLoading,
                        isChecked: isBookingFlow ? getValues("isCardSavedForFuturePayments") : isCardDefault,
                        label: isBookingFlow ? "checkout.set_card_future_payments" : "my_credit_cards.set_card_default",
                        handleChange: handleFormSwitchChange
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_form_button/* DialogFormButton */.J, {
                    isLoading: isLoading,
                    isDisabled: !isFormValid,
                    label: isBookingFlow ? (order === null || order === void 0 ? void 0 : order.isGuestBookingEnabled) ? "global.pay" : "my_credit_cards.use_this_card" : "global.save",
                    handleSave: handleSave
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/profile/delete-card-confirmation-dialog.tsx





var TrashIcon = "/icons/profile/deletePopup.svg";
var DeleteCardConfirmationDialog = function() {
    var ref, ref1;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,state/* useDialog */.Rh)(function(s) {
        return [
            s.dialog,
            s.setDialog
        ];
    }, shallow/* default */.Z), 2), dialog = ref2[0], setDialog = ref2[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(confirm_dialog/* ConfirmDialog */.Q, {
        buttonId: "delete-credit-card-confirm-dialog",
        img: TrashIcon,
        widthImage: "99px",
        heightImage: "106px",
        altImage: "alt.delete_offer",
        title: "my_credit_cards.delete_card",
        description: "my_credit_cards.delete_card.description",
        isLoading: dialog === null || dialog === void 0 ? void 0 : (ref = dialog.deleteCardConfirmationDialogPayload) === null || ref === void 0 ? void 0 : ref.isLoading,
        handleOkayClick: dialog === null || dialog === void 0 ? void 0 : (ref1 = dialog.deleteCardConfirmationDialogPayload) === null || ref1 === void 0 ? void 0 : ref1.handleOkayClick,
        handleCloseClick: function() {
            return setDialog({});
        }
    });
};

;// CONCATENATED MODULE: ./src/components/profile/edit-credit-card-from.tsx





















var EditCreditCardForm = function() {
    var ref, ref1, ref2, ref3, ref4;
    var theme = (0,useTheme/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,state/* useDialog */.Rh)(function(s) {
        return [
            s.dialog,
            s.setDialog
        ];
    }, shallow/* default */.Z), 2), dialog = ref5[0], setDialog = ref5[1];
    var setSnack = (0,state/* useSnack */.eW)(function(s) {
        return s.setSnack;
    }, shallow/* default */.Z);
    var updateCard = (0,services/* useUpdateCard */.Ow)();
    var router = (0,next_router.useRouter)();
    var schema = es/* object */.Ry({
        cardName: es/* string */.Z_().required().max(40, intl.formatMessage({
            id: "my_credit_cards.card_name.validation.fail"
        })),
        cardHolder: es/* string */.Z_().required(),
        cardNumber: es/* string */.Z_().required(),
        expiryDate: es/* string */.Z_().required(),
        cvv: es/* string */.Z_().required()
    });
    var _ref = dialog === null || dialog === void 0 ? void 0 : dialog.editCreditCardFormPayload, id = _ref.id, isDefault = _ref.isDefault, cardType = _ref.cardType, defaultValues = (0,_object_without_properties/* default */.Z)(_ref, [
        "id",
        "isDefault",
        "cardType"
    ]);
    var ref6 = (0,react.useState)(isDefault), isCardDefault = ref6[0], setIsCardDefault = ref6[1];
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var ref7 = (0,index_esm/* useForm */.cI)({
        resolver: (0,yup/* yupResolver */.X)(schema),
        mode: "onChange",
        reValidateMode: "onChange",
        defaultValues: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultValues), {
            cardNumber: "**** ".concat(defaultValues.cardNumber),
            cvv: cardType === services/* CreditCardType.Amex */.Oo.Amex ? "****" : "***"
        })
    }), register = ref7.register, getValues = ref7.getValues, _formState = ref7.formState, errors = _formState.errors, isValid = _formState.isValid;
    var handleCloseClick = (0,react.useCallback)(function() {
        setDialog({});
    }, [
        setDialog
    ]);
    var handleFormSwitchChange = function(e) {
        setIsCardDefault(e.target.checked);
    };
    var handleSubmit = (0,react.useCallback)(function() {
        updateCard.safeMutateAsync({
            data: {
                name: getValues("cardName"),
                isDefault: isCardDefault
            },
            query: {
                id: id
            }
        }, {
            onSuccess: function() {
                setSnack({
                    isOpen: true,
                    message: "my_credit_cards.update.success",
                    type: "success",
                    id: "credit-card-updated-success"
                });
                setDialog({});
            },
            onSettled: function() {
                return queryClient.invalidateQueries([
                    {
                        method: "get",
                        url: "cards",
                        params: {
                            limit: 50,
                            page: 1
                        }
                    }, 
                ]);
            }
        });
    }, [
        getValues,
        id,
        isCardDefault,
        queryClient,
        setDialog,
        setSnack,
        updateCard
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(close_button/* CloseButton */.P, {
                    handleClick: handleCloseClick
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                sx: {
                    textAlign: "center"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_form_title/* DialogFormTitle */.J, {
                        message: "my_credit_cards.edit_credit_card"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        spacing: "24px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(credit_card_name_input/* CreditCardNameInput */.d, {
                                isLoading: updateCard.isLoading,
                                isAutoFocus: false,
                                isError: ((ref = errors.cardName) === null || ref === void 0 ? void 0 : ref.type) && ((ref1 = errors.cardName) === null || ref1 === void 0 ? void 0 : ref1.type) !== "required",
                                helperText: ((ref2 = errors.cardName) === null || ref2 === void 0 ? void 0 : ref2.type) && ((ref3 = errors.cardName) === null || ref3 === void 0 ? void 0 : ref3.type) !== "required" ? (ref4 = errors.cardName) === null || ref4 === void 0 ? void 0 : ref4.message : "",
                                registerFunc: function() {
                                    return register("cardName");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                id: "credit-card-number",
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                    id: "my_credit_cards.card_number"
                                }),
                                disabled: true,
                                InputProps: {
                                    sx: {
                                        color: theme.palette.grey[80],
                                        "& input": {
                                            textAlign: router.locale === "en" ? "start" : "end"
                                        }
                                    }
                                }
                            }, register("cardNumber")), {
                                dir: "ltr"
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread/* default */.Z)({
                                id: "credit-card-holder",
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                    id: "my_credit_cards.card_holder"
                                }),
                                disabled: true,
                                InputProps: {
                                    sx: {
                                        color: theme.palette.grey[80]
                                    }
                                }
                            }, register("cardHolder"))),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread/* default */.Z)({
                                id: "credit-card-expiry-date",
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                    id: "my_credit_cards.expiry_date"
                                }),
                                disabled: true,
                                InputProps: {
                                    sx: {
                                        color: theme.palette.grey[80]
                                    }
                                }
                            }, register("expiryDate"))),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread/* default */.Z)({
                                id: "credit-card-cvv",
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                    id: "my_credit_cards.cvv"
                                }),
                                disabled: true,
                                InputProps: {
                                    sx: {
                                        color: theme.palette.grey[80]
                                    }
                                }
                            }, register("cvv")))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(credit_card_switch_input/* CreditCardSwitchInput */.w, {
                        isLoading: updateCard.isLoading,
                        isChecked: isCardDefault,
                        label: "my_credit_cards.set_card_default",
                        handleChange: handleFormSwitchChange
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_form_button/* DialogFormButton */.J, {
                    isLoading: updateCard.isLoading,
                    isDisabled: !isValid,
                    label: "global.save",
                    handleSave: handleSubmit
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/constants/routes.ts
var routes = __webpack_require__(46648);
// EXTERNAL MODULE: ./src/logic/types/data-layer-models.ts
var data_layer_models = __webpack_require__(58022);
// EXTERNAL MODULE: ./src/logic/shared/data-layer-events.ts
var data_layer_events = __webpack_require__(60986);
// EXTERNAL MODULE: ./src/constants/auth.ts
var auth = __webpack_require__(28216);
;// CONCATENATED MODULE: ./src/components/register-and-login/otp-form.tsx























var otp_form_emailIcon = "/icons/shared/emailIcon.svg";
var OtpForm = function() {
    var ref, ref1;
    var ref2 = (0,next_router.useRouter)(), locale = ref2.locale, pathname = ref2.pathname, asPath = ref2.asPath;
    var ref3 = (0,react.useState)(false), showDelayedButton = ref3[0], setShowDelayedButton = ref3[1];
    var theme = (0,useTheme/* default */.Z)();
    var ref4 = (0,react.useState)(false), error = ref4[0], setError = ref4[1];
    var ref5 = (0,react.useState)(""), errorMessage = ref5[0], setErrorMessage = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,state_dialog/* useDialog */.R)(function(s) {
        return [
            s.dialog,
            s.setDialog
        ];
    }, shallow/* default */.Z), 2), dialog = ref6[0], setDialog = ref6[1];
    var setSnack = (0,snackbar/* useSnack */.e)(function(s) {
        return s.setSnack;
    }, shallow/* default */.Z);
    var setUser = (0,state/* useAuth */.aC)(function(s) {
        return s.setUser;
    }, shallow/* default */.Z);
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,state/* useOrder */.Aj)(function(s) {
        return [
            s.setOrder,
            s.setGuestBookingInfo,
            s.order
        ];
    }, shallow/* default */.Z), 3), setOrder = ref7[0], setGuestBookingInfo = ref7[1], order = ref7[2];
    var setOtpTimer = (0,state/* useOtpTimer */.lT)(function(s) {
        return s.setOtpTimer;
    }, shallow/* default */.Z);
    var checkUserCity = (0,hooks/* useCheckClientCity */.$R)().checkUserCity;
    var updateLoginPath = (0,hooks/* useUpdatePath */.Hj)().updateLoginPath;
    var reSendOtp = (0,otp/* useSendOtp */.p)();
    var verifyOtp = (0,otp/* useVerifyOtp */.G)();
    var handleFormSubmit = function(data) {
        var ref;
        setError(false);
        setErrorMessage("");
        verifyOtp.safeMutateAsync({
            data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                phoneNumber: dialog === null || dialog === void 0 ? void 0 : (ref = dialog.phoneNumberFormPayload) === null || ref === void 0 ? void 0 : ref.phoneNumber
            })
        }, {
            onSuccess: function(response) {
                if (response.next !== auth/* AUTH_FLOW.OLD */.W.OLD) {
                    var _user = response.user, _ = _user.language, restUserData = (0,_object_without_properties/* default */.Z)(_user, [
                        "language"
                    ]);
                    setUser((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restUserData), {
                        language: locale,
                        token: response.token,
                        refreshToken: response.refreshToken
                    }));
                    updateLoginPath();
                    setOrder(function(prevState) {
                        return prevState ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                            isGuestBookingEnabled: pathname === routes/* PATHS.BOOKINGS_ID_YOUR_TICKET */.yy.BOOKINGS_ID_YOUR_TICKET ? prevState === null || prevState === void 0 ? void 0 : prevState.isGuestBookingEnabled : false
                        }) : null;
                    });
                    setGuestBookingInfo(null);
                }
                successFlow(response.next, response.token, response.user, response === null || response === void 0 ? void 0 : response.email);
                var _$data = {
                    event: data_layer_models/* EventTypes.LOGIN_SUCCESS */.G.LOGIN_SUCCESS,
                    page_title: document.title,
                    page_url: document.URL,
                    page_section: asPath
                };
                (0,data_layer_events/* triggerGAEvent */.S)(_$data);
            },
            onError: function(error) {
                if (axios_default().isAxiosError(error)) {
                    var ref, ref1;
                    setError(true);
                    setErrorMessage(error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message);
                }
            }
        });
    };
    var successFlow = (0,react.useCallback)(function(next, token, user, email) {
        if (next === auth/* AUTH_FLOW.HOME */.W.HOME) {
            checkUserCity(user);
        }
        if (next === auth/* AUTH_FLOW.COMPLETE_PROFILE */.W.COMPLETE_PROFILE) {
            setDialog({});
            setTimeout(function() {
                setDialog({
                    wrapper: true,
                    isCompleteProfileForm: true,
                    completeProfileFormPayload: {
                        hideMaybeLaterButton: true
                    }
                });
            }, 500);
        }
        if (next === auth/* AUTH_FLOW.OLD */.W.OLD) {
            setDialog({});
            setTimeout(function() {
                setDialog({
                    wrapper: true,
                    isOldUserForm: true,
                    oldUserFormPayload: {
                        token: token,
                        email: email,
                        phoneNumber: dialog.phoneNumberFormPayload.phoneNumber
                    }
                });
            }, 500);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        checkUserCity,
        setDialog
    ]);
    var handleCodeResend = (0,react.useCallback)(function() {
        var ref;
        setOtpTimer(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                timerVal: 0
            });
        });
        reSendOtp.safeMutateAsync({
            data: {
                phoneNumber: dialog === null || dialog === void 0 ? void 0 : (ref = dialog.phoneNumberFormPayload) === null || ref === void 0 ? void 0 : ref.phoneNumber
            }
        }, {
            onSuccess: function(res) {
                setOtpTimer(function(prevState) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                        timerVal: res === null || res === void 0 ? void 0 : res.retryAfter
                    });
                });
                setSnack({
                    isOpen: true,
                    message: "otp.resent.successfully",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                        img: otp_form_emailIcon,
                        objectFit: "contain",
                        sx: {
                            width: "16px",
                            height: "16px"
                        }
                    }),
                    type: "info"
                });
            },
            onError: function(error) {
                if (axios_default().isAxiosError(error)) {
                    setOtpTimer({
                        timerVal: 0,
                        isRunning: true
                    });
                }
            }
        });
    }, [
        dialog === null || dialog === void 0 ? void 0 : (ref = dialog.phoneNumberFormPayload) === null || ref === void 0 ? void 0 : ref.phoneNumber,
        reSendOtp,
        setOtpTimer,
        setSnack
    ]);
    (0,react.useEffect)(function() {
        var timer = setTimeout(function() {
            setShowDelayedButton(true);
        }, 5000);
        // Cleanup function to clear the timeout if the component unmounts
        return function() {
            return clearTimeout(timer);
        };
    }, []);
    var continueAsGuest = function() {
        setDialog({});
        setGuestBookingInfo(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                isPhoneNumberVisibleOnly: false
            });
        });
        setOrder(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                isGuestBookingEnabled: true
            });
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(verification_code_form/* VerificationCodeForm */.O, {
        subtitle: "verify.phone.number",
        description: "global.description.code.phone_number",
        value: dialog === null || dialog === void 0 ? void 0 : (ref1 = dialog.phoneNumberFormPayload) === null || ref1 === void 0 ? void 0 : ref1.phoneNumber,
        isVerifyCodeLoading: verifyOtp.isLoading,
        error: error,
        errorMessage: errorMessage,
        isSendOtpLoading: reSendOtp === null || reSendOtp === void 0 ? void 0 : reSendOtp.isLoading,
        handleFormClose: function() {
            return setDialog({});
        },
        handleFormSubmit: handleFormSubmit,
        handleCodeResend: handleCodeResend,
        actionComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: showDelayedButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "text",
                onClick: continueAsGuest,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    sx: {
                        fontWeight: "700",
                        fontSize: (0,typography/* pxToRem */.Q)(16),
                        color: theme.palette.primary.main
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                        id: "global.continue.as.guest"
                    })
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/shared/customized-circular-progress.tsx
var customized_circular_progress = __webpack_require__(75491);
// EXTERNAL MODULE: ./src/logic/services/dynamic-pages/index.ts + 1 modules
var dynamic_pages = __webpack_require__(37248);
;// CONCATENATED MODULE: ./src/components/register-and-login/terms-and-conditions.tsx










var TermsAndConditionsForm = function() {
    var ref;
    var dialog = (0,state_dialog/* useDialog */.R)(function(s) {
        return s.dialog;
    }, shallow/* default */.Z);
    var intl = (0,useIntl/* default */.Z)();
    var ref1 = (0,dynamic_pages/* useGetDynamicPage */.D)({
        query: {
            type: "TERMS_AND_CONDITIONS"
        }
    }), data = ref1.data, isLoading = ref1.isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(backward_button/* BackwardButton */.e, {
                    handleClick: dialog === null || dialog === void 0 ? void 0 : (ref = dialog.termsAndConditionsFormPayload) === null || ref === void 0 ? void 0 : ref.handleBackwardClick
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                id: "terms-conditions-form",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            width: "90%",
                            margin: "auto"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                sx: {
                                    textAlign: "center",
                                    mt: "26px",
                                    fontWeight: 700,
                                    fontSize: {
                                        mobile: "18px",
                                        tablet: (0,typography/* pxToRem */.Q)(20)
                                    },
                                    lineHeight: "30px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                    id: "terms.and.conditions"
                                })
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    width: 96,
                                    height: 96,
                                    marginBlock: 4,
                                    position: "relative"
                                },
                                children: (data === null || data === void 0 ? void 0 : data.photoUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                                    img: data === null || data === void 0 ? void 0 : data.photoUrl,
                                    title: intl.formatMessage({
                                        id: "alt.terms_and_conditions"
                                    }),
                                    objectFit: "contain",
                                    sx: {
                                        width: "96px",
                                        height: "96px"
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            marginBlockEnd: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            component: "div",
                            dangerouslySetInnerHTML: {
                                __html: data === null || data === void 0 ? void 0 : data.content
                            }
                        })
                    }),
                    isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "auto",
                            marginBlock: 3
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(customized_circular_progress/* default */.Z, {})
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/Alert/Alert.js + 5 modules
var Alert = __webpack_require__(46901);
// EXTERNAL MODULE: ./node_modules/@mui/material/Snackbar/Snackbar.js + 4 modules
var Snackbar = __webpack_require__(57820);
;// CONCATENATED MODULE: ./src/components/shared/snackbar-popup.tsx








var TransitionDown = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Slide/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        direction: "down"
    }));
};
var SnackbarPopup = function(param) {
    var isOpen = param.isOpen, message = param.message, type = param.type, icon = param.icon, variant = param.variant, colorOfText = param.colorOfText, closeSnack = param.closeSnack, hideDuration = param.hideDuration, id = param.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Snackbar/* default */.Z, {
        open: isOpen,
        TransitionComponent: TransitionDown,
        onClose: closeSnack,
        autoHideDuration: hideDuration ? hideDuration : type !== "error" ? 4000 : 8000,
        sx: {
            width: "fit-content"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
            variant: variant !== null && variant !== void 0 ? variant : "filled",
            severity: type,
            color: type,
            icon: icon || "",
            sx: {
                alignItems: "center",
                color: colorOfText
            },
            id: id || "toast-message",
            children: isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                id: message || "Error",
                defaultMessage: message || "Error"
            })
        })
    }, TransitionDown ? TransitionDown.name : "");
};

// EXTERNAL MODULE: ./src/features/wallet/hooks/use-invalidate-wallet.ts
var use_invalidate_wallet = __webpack_require__(90867);
;// CONCATENATED MODULE: ./src/components/side-menu/logout-confirm-dialog.tsx









var LogoutConfirmDialogIcon = "/icons/side-menu/logout-confirm-dialog-icon.svg";
var LogoutConfirmDialog = function() {
    var setDialog = (0,state/* useDialog */.Rh)(function(s) {
        return s.setDialog;
    }, shallow/* default */.Z);
    var setSideMenu = (0,state/* useSideMenu */.W0)(function(s) {
        return s.setSideMenu;
    }, shallow/* default */.Z);
    var setUser = (0,state/* useAuth */.aC)(function(s) {
        return s.setUser;
    }, shallow/* default */.Z);
    var checkGuestCity = (0,hooks/* useCheckClientCity */.$R)().checkGuestCity;
    var updateLogoutPath = (0,hooks/* useUpdatePath */.Hj)().updateLogoutPath;
    var logout = (0,services/* useLogout */.aU)();
    var invalidateAllWallet = (0,use_invalidate_wallet/* useInvalidateWallet */.J)().invalidateAllWallet;
    var ref = (0,_sliced_to_array/* default */.Z)((0,state/* useOneSignalCustomState */.EC)(function(s) {
        return [
            s.muviDeviceId
        ];
    }, shallow/* default */.Z), 1), deviceId = ref[0];
    var handleOkayClick = (0,react.useCallback)(function() {
        logout.safeMutateAsync({
            headers: {
                "X-Device-Id": deviceId
            }
        }, {
            onSuccess: function() {
                setUser(null);
                checkGuestCity();
                setSideMenu(false);
                updateLogoutPath();
                setTimeout(function() {
                    invalidateAllWallet();
                }, 1000);
            }
        });
    }, [
        checkGuestCity,
        deviceId,
        invalidateAllWallet,
        logout,
        setSideMenu,
        setUser,
        updateLogoutPath, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(confirm_dialog/* ConfirmDialog */.Q, {
        buttonId: "logout-confirm-dialog",
        img: LogoutConfirmDialogIcon,
        widthImage: "82px",
        heightImage: "84px",
        altImage: "alt.logout_icon",
        title: "logout_confirm_dialog.title",
        description: "logout_confirm_dialog.description",
        handleOkayClick: handleOkayClick,
        handleCloseClick: function() {
            return setDialog({});
        },
        isLoading: logout.isLoading
    });
};

// EXTERNAL MODULE: ./src/logic/hooks/use-clear-booking.ts
var use_clear_booking = __webpack_require__(34680);
;// CONCATENATED MODULE: ./src/components/booking/dialogs/confirm-dialogs/cancel-seats-selection-confirm-dialog.tsx









var CancelSeatsSelectionConfirmDialog = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,state/* useDialog */.Rh)(function(s) {
        return [
            s.dialog,
            s.setDialog
        ];
    }, shallow/* default */.Z), 2), dialog = ref[0], setDialog = ref[1];
    var clearBooking = (0,use_clear_booking/* useClearBooking */.C)().clearBooking;
    var handleCloseClick = (0,react.useCallback)(function() {
        setDialog({});
    }, [
        setDialog
    ]);
    var handleOkayClick = (0,react.useCallback)(function() {
        var ref;
        if (dialog === null || dialog === void 0 ? void 0 : (ref = dialog.cancelSeatsSelectionConfirmDialogPayload) === null || ref === void 0 ? void 0 : ref.redirect) {
            var ref1, ref2;
            dialog === null || dialog === void 0 ? void 0 : (ref1 = dialog.cancelSeatsSelectionConfirmDialogPayload) === null || ref1 === void 0 ? void 0 : ref1.removeOnRouteChangeStartListener();
            setDialog({});
            router.push(dialog === null || dialog === void 0 ? void 0 : (ref2 = dialog.cancelSeatsSelectionConfirmDialogPayload) === null || ref2 === void 0 ? void 0 : ref2.nextPath);
        } else {
            clearBooking();
            setDialog(function(prevState) {
                return {
                    wrapper: false,
                    rulesOfEntryDialogPayload: prevState === null || prevState === void 0 ? void 0 : prevState.rulesOfEntryDialogPayload
                };
            });
            setTimeout(function() {
                setDialog(function(prevState) {
                    return {
                        wrapper: true,
                        isRulesOfEntryDialog: true,
                        rulesOfEntryDialogPayload: prevState === null || prevState === void 0 ? void 0 : prevState.rulesOfEntryDialogPayload
                    };
                });
            }, 500);
        }
    }, [
        clearBooking,
        dialog === null || dialog === void 0 ? void 0 : dialog.cancelSeatsSelectionConfirmDialogPayload,
        router,
        setDialog
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(confirm_dialog/* ConfirmDialog */.Q, {
        buttonId: "change-page-confirm-dialog",
        img: "/icons/booking/cancel-seats-selection-icon.svg",
        widthImage: "149px",
        heightImage: "103px",
        altImage: "alt.cancel_selection_seats_icon",
        title: router.pathname === routes/* PATHS.MOVIES_SLUG_BOOKING */.yy.MOVIES_SLUG_BOOKING ? "booking.cancel_seats_selection" : "booking.cancel_checkout",
        description: router.pathname === routes/* PATHS.MOVIES_SLUG_BOOKING */.yy.MOVIES_SLUG_BOOKING ? "booking.cancel_seats_selection_confirm_dialog.seats_page.description" : "booking.cancel_seats_selection_confirm_dialog.checkout_page.description",
        handleOkayClick: handleOkayClick,
        handleCloseClick: handleCloseClick
    });
};

;// CONCATENATED MODULE: ./src/components/booking/dialogs/confirm-dialogs/change-experience-confirm-dialog.tsx





var ChangeExperienceConfirmDialog = function() {
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,state/* useDialog */.Rh)(function(s) {
        return [
            s.dialog,
            s.setDialog
        ];
    }, shallow/* default */.Z), 2), dialog = ref1[0], setDialog = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(confirm_dialog/* ConfirmDialog */.Q, {
        buttonId: "change-experience-confirm-dialog",
        img: "/icons/booking/cancel-seats-selection-icon.svg",
        widthImage: "149px",
        heightImage: "103px",
        altImage: "alt.cancel_selection_seats_icon",
        title: "booking.cancel_seats_selection",
        description: "booking.change_experience_confirm_dialog.description",
        handleOkayClick: dialog === null || dialog === void 0 ? void 0 : (ref = dialog.changeExperienceConfirmDialogPayload) === null || ref === void 0 ? void 0 : ref.handleOkayClick,
        handleCloseClick: function() {
            return setDialog({});
        }
    });
};

;// CONCATENATED MODULE: ./src/components/booking/dialogs/confirm-dialogs/change-showtime-confirm-dialog.tsx





var ChangeShowtimeConfirmDialog = function() {
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,state/* useDialog */.Rh)(function(s) {
        return [
            s.dialog,
            s.setDialog
        ];
    }, shallow/* default */.Z), 2), dialog = ref1[0], setDialog = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(confirm_dialog/* ConfirmDialog */.Q, {
        buttonId: "change-showtime-confirm-dialog",
        img: "/icons/booking/cancel-seats-selection-icon.svg",
        widthImage: "149px",
        heightImage: "103px",
        altImage: "alt.cancel_selection_seats_icon",
        title: "booking.cancel_seats_selection",
        description: "booking.change_showtime_confirm_dialog.description",
        handleOkayClick: dialog === null || dialog === void 0 ? void 0 : (ref = dialog.changeShowtimeConfirmDialogPayload) === null || ref === void 0 ? void 0 : ref.handleOkayClick,
        handleCloseClick: function() {
            return setDialog({});
        }
    });
};

;// CONCATENATED MODULE: ./src/components/booking/dialogs/confirm-dialogs/companion-confirm-dialog.tsx









var CompanionConfirmDialog = function() {
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,state/* useDialog */.Rh)(function(s) {
        return [
            s.dialog,
            s.setDialog
        ];
    }, shallow/* default */.Z), 2), dialog = ref1[0], setDialog = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,state/* useBooking */.v4)(function(s) {
        return [
            s.booking,
            s.setBooking
        ];
    }, shallow/* default */.Z), 2), booking = ref2[0], setBooking = ref2[1];
    var handleOkayClick = (0,react.useCallback)(function(seat) {
        var ref;
        var newSelectedTickets = (ref = booking.selectedTickets) === null || ref === void 0 ? void 0 : ref.map(function(selectedTicket, index) {
            var ref;
            if (index === (dialog === null || dialog === void 0 ? void 0 : (ref = dialog.companionConfirmDialogPayload) === null || ref === void 0 ? void 0 : ref.areaIndex)) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedTicket), {
                    seats: (0,_to_consumable_array/* default */.Z)(selectedTicket.seats).concat([
                        (0,_object_spread/* default */.Z)({}, seat)
                    ])
                });
            } else {
                return selectedTicket;
            }
        });
        setDialog({});
        setBooking(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                selectedTickets: newSelectedTickets
            });
        });
    }, [
        booking,
        dialog === null || dialog === void 0 ? void 0 : (ref = dialog.companionConfirmDialogPayload) === null || ref === void 0 ? void 0 : ref.areaIndex,
        setBooking,
        setDialog
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(confirm_dialog/* ConfirmDialog */.Q, {
        buttonId: "companion-confirm-dialog",
        img: "/icons/booking/companion-icon.svg",
        widthImage: "120px",
        heightImage: "130px",
        altImage: "alt.companion_icon",
        title: "booking.companion",
        description: "booking.companion_confirm_dialog.description",
        handleOkayClick: function() {
            var ref;
            return handleOkayClick(dialog === null || dialog === void 0 ? void 0 : (ref = dialog.companionConfirmDialogPayload) === null || ref === void 0 ? void 0 : ref.seat);
        },
        handleCloseClick: function() {
            return setDialog({});
        }
    });
};

;// CONCATENATED MODULE: ./src/components/booking/dialogs/confirm-dialogs/wheel-chair-confirm-dialog.tsx









var WheelChairConfirmDialog = function() {
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,state/* useDialog */.Rh)(function(s) {
        return [
            s.dialog,
            s.setDialog
        ];
    }, shallow/* default */.Z), 2), dialog = ref1[0], setDialog = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,state/* useBooking */.v4)(function(s) {
        return [
            s.booking,
            s.setBooking
        ];
    }, shallow/* default */.Z), 2), booking = ref2[0], setBooking = ref2[1];
    var handleOkayClick = (0,react.useCallback)(function(seat) {
        var ref;
        var newSelectedTickets = (ref = booking.selectedTickets) === null || ref === void 0 ? void 0 : ref.map(function(selectedTicket, index) {
            var ref;
            if (index === (dialog === null || dialog === void 0 ? void 0 : (ref = dialog.wheelChairConfirmDialogPayload) === null || ref === void 0 ? void 0 : ref.areaIndex)) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedTicket), {
                    seats: (0,_to_consumable_array/* default */.Z)(selectedTicket.seats).concat([
                        (0,_object_spread/* default */.Z)({}, seat)
                    ])
                });
            } else {
                return selectedTicket;
            }
        });
        setDialog({});
        setBooking(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                selectedTickets: newSelectedTickets
            });
        });
    }, [
        booking,
        dialog === null || dialog === void 0 ? void 0 : (ref = dialog.wheelChairConfirmDialogPayload) === null || ref === void 0 ? void 0 : ref.areaIndex,
        setBooking,
        setDialog
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(confirm_dialog/* ConfirmDialog */.Q, {
        buttonId: "wheel-chair-confirm-dialog",
        img: "/icons/booking/wheel-chair-icon.svg",
        widthImage: "120px",
        heightImage: "130px",
        altImage: "alt.wheel_chair_icon",
        title: "booking.wheel_chair",
        description: "booking.wheel_chair_confirm_dialog.description",
        handleOkayClick: function() {
            var ref;
            return handleOkayClick(dialog === null || dialog === void 0 ? void 0 : (ref = dialog.wheelChairConfirmDialogPayload) === null || ref === void 0 ? void 0 : ref.seat);
        },
        handleCloseClick: function() {
            return setDialog({});
        }
    });
};

;// CONCATENATED MODULE: ./src/components/booking/dialogs/house-rules.tsx










var HouseRules = function() {
    var setDialog = (0,state_dialog/* useDialog */.R)(function(s) {
        return s.setDialog;
    }, shallow/* default */.Z);
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,dynamic_pages/* useGetDynamicPage */.D)({
        query: {
            type: "HOUSE_RULE"
        }
    }), data = ref.data, isLoading = ref.isLoading;
    var handleBackwardClick = (0,react.useCallback)(function() {
        setDialog(function(prevState) {
            return {
                wrapper: false,
                rulesOfEntryDialogPayload: prevState === null || prevState === void 0 ? void 0 : prevState.rulesOfEntryDialogPayload
            };
        });
        setTimeout(function() {
            setDialog(function(prevState) {
                return {
                    wrapper: true,
                    isRulesOfEntryDialog: true,
                    rulesOfEntryDialogPayload: prevState === null || prevState === void 0 ? void 0 : prevState.rulesOfEntryDialogPayload
                };
            });
        }, 500);
    }, [
        setDialog
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(backward_button/* BackwardButton */.e, {
                    handleClick: handleBackwardClick
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            width: "90%",
                            margin: "auto"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: "div",
                                variant: "h4",
                                sx: {
                                    textAlign: "center",
                                    mt: "26px",
                                    fontWeight: 700
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                    id: "booking.house_rules"
                                })
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    width: 96,
                                    height: 96,
                                    marginBlock: 4,
                                    position: "relative"
                                },
                                children: (data === null || data === void 0 ? void 0 : data.photoUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                                    img: data === null || data === void 0 ? void 0 : data.photoUrl,
                                    title: intl.formatMessage({
                                        id: "booking.house_rules"
                                    }),
                                    objectFit: "cover",
                                    sx: {
                                        width: "96px",
                                        height: "96px"
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            marginBlockEnd: 5
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            component: "div",
                            dangerouslySetInnerHTML: {
                                __html: data === null || data === void 0 ? void 0 : data.content
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        children: isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin: "auto",
                                marginBlock: 3
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(customized_circular_progress/* default */.Z, {
                                size: 40,
                                thickness: 4
                            })
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/shared/info-dialog.tsx






var InfoDialog = function(param) {
    var buttonId = param.buttonId, img = param.img, title = param.title, description = param.description, handleOkayClick = param.handleOkayClick;
    var theme = (0,useTheme/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(close_button/* CloseButton */.P, {
                    handleClick: handleOkayClick
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    sx: {
                        alignItems: "center",
                        margin: "auto"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                marginBlock: 4
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                                img: img,
                                title: title,
                                objectFit: "contain",
                                sx: {
                                    width: "108px",
                                    height: "102px"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: theme.palette.grey[90],
                                fontSize: (0,typography/* pxToRem */.Q)(22),
                                fontWeight: 700,
                                lineHeight: "33px",
                                marginBottom: (0,typography/* pxToRem */.Q)(24)
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                id: title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: theme.palette.grey[70],
                                fontSize: (0,typography/* pxToRem */.Q)(18),
                                fontWeight: 400,
                                lineHeight: "27px",
                                textAlign: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                id: description
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    id: "".concat(buttonId, "-okay"),
                    variant: "contained",
                    fullWidth: true,
                    onClick: handleOkayClick,
                    sx: {
                        height: {
                            tablet: (0,typography/* pxToRem */.Q)(56),
                            mobile: "56px"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                        id: "global.okay"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/booking/dialogs/info-dialogs/reserved-seats-info-dialog.tsx









var ReservedSeatsInfoDialog = function() {
    var setDialog = (0,state/* useDialog */.Rh)(function(s) {
        return s.setDialog;
    }, shallow/* default */.Z);
    var ref = (0,_sliced_to_array/* default */.Z)((0,state/* useBooking */.v4)(function(s) {
        return [
            s.booking,
            s.setBooking
        ];
    }, shallow/* default */.Z), 2), booking = ref[0], setBooking = ref[1];
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var handleOkayClick = (0,react.useCallback)(function() {
        setDialog({});
        setBooking(function(prevState) {
            var ref;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                selectedTickets: prevState === null || prevState === void 0 ? void 0 : (ref = prevState.selectedTickets) === null || ref === void 0 ? void 0 : ref.map(function(selectedTicket) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedTicket), {
                        seats: []
                    });
                })
            });
        });
        queryClient.invalidateQueries([
            {
                method: "get",
                url: "showtimes/:sessionId/seats",
                query: {
                    sessionId: booking === null || booking === void 0 ? void 0 : booking.sessionId
                },
                params: {
                    orderId: booking === null || booking === void 0 ? void 0 : booking.orderId
                }
            }, 
        ]);
    }, [
        booking,
        queryClient,
        setBooking,
        setDialog
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoDialog, {
        buttonId: "reserved-seats-info-dialog",
        img: "/icons/booking/reserved-seats-icon.svg",
        title: "booking.reserved_seats_info_dialog.title",
        description: "booking.reserved_seats_info_dialog.description",
        handleOkayClick: handleOkayClick
    });
};

;// CONCATENATED MODULE: ./src/components/booking/dialogs/info-dialogs/session-expired-info-dialog.tsx







var SessionExpiredInfoDialog = function() {
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,state/* useDialog */.Rh)(function(s) {
        return [
            s.dialog,
            s.setDialog
        ];
    }, shallow/* default */.Z), 2), dialog = ref1[0], setDialog = ref1[1];
    var booking = (0,state/* useBooking */.v4)(function(s) {
        return s.booking;
    }, shallow/* default */.Z);
    var routeHandler = (0,state/* useRouteHandler */.r8)(function(s) {
        return s.routeHandler;
    }, shallow/* default */.Z);
    var handleOkayClick = (0,react.useCallback)(function() {
        var ref, ref1;
        routeHandler === null || routeHandler === void 0 ? void 0 : (ref = routeHandler.removeOnRouteChangeStartListener) === null || ref === void 0 ? void 0 : ref.call(routeHandler);
        setDialog({});
        router.push("/movies/".concat(dialog === null || dialog === void 0 ? void 0 : (ref1 = dialog.sessionExpiredInfoDialogPayload) === null || ref1 === void 0 ? void 0 : ref1.slug, "/?cityId=").concat(booking === null || booking === void 0 ? void 0 : booking.cityId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        booking === null || booking === void 0 ? void 0 : booking.cityId,
        dialog === null || dialog === void 0 ? void 0 : (ref = dialog.sessionExpiredInfoDialogPayload) === null || ref === void 0 ? void 0 : ref.slug,
        routeHandler === null || routeHandler === void 0 ? void 0 : routeHandler.removeOnRouteChangeStartListener,
        router,
        setDialog, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoDialog, {
        buttonId: "session-expired-info-dialog",
        img: "/icons/booking/session-expired-icon.svg",
        title: "booking.session_expired_info_dialog.title",
        description: "booking.session_expired_info_dialog.description",
        handleOkayClick: handleOkayClick
    });
};

// EXTERNAL MODULE: ./src/logic/hooks/use-unipal-offer-params.ts
var use_unipal_offer_params = __webpack_require__(69854);
// EXTERNAL MODULE: ./src/logic/libs/index.ts
var libs = __webpack_require__(81900);
;// CONCATENATED MODULE: ./src/components/booking/dialogs/rules-of-entry-dialog.tsx





















var Film_HAS_BEEN_STARTED_CODE = 20;
// TODO: check all id comparison in muvi website to use type of id === 'number'
// TODO: refactor typeof conditions to reduce code
// TODO: make sure to set booking and order to null before display rules of entry dialog in offers flow
var RulesOfEntryDialog = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var theme = (0,useTheme/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var isShowTimesDrawerOpen = (0,state/* useShowTimesDrawer */.j0)(function(s) {
        return s.isShowTimesDrawerOpen;
    }, shallow/* default */.Z);
    var movie = (0,state/* useMovieDetailsState */.DQ)(function(s) {
        return s.movie;
    }, shallow/* default */.Z);
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,state/* useDialog */.Rh)(function(s) {
        return [
            s.dialog,
            s.setDialog
        ];
    }, shallow/* default */.Z), 2), dialog = ref6[0], setDialog = ref6[1];
    var setSnack = (0,state/* useSnack */.eW)(function(s) {
        return s.setSnack;
    }, shallow/* default */.Z);
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,state/* useBooking */.v4)(function(s) {
        return [
            s.setBooking,
            s.setIsLegalBookingFlow
        ];
    }, shallow/* default */.Z), 2), setBooking = ref7[0], setIsLegalBookingFlow = ref7[1];
    var getBankOfferParams = (0,hooks/* useBankOfferParams */.vc)().getBankOfferParams;
    var getUnipalOfferParams = (0,use_unipal_offer_params/* useUnipalOfferParams */._)().getUnipalOfferParams;
    var cityId = (0,hooks/* useBookingFlowCity */.Zx)().cityId;
    var isFilmRateAvailable = Boolean((dialog === null || dialog === void 0 ? void 0 : (ref = dialog.rulesOfEntryDialogPayload) === null || ref === void 0 ? void 0 : ref.movieId) === (movie === null || movie === void 0 ? void 0 : (ref1 = movie.film) === null || ref1 === void 0 ? void 0 : ref1.id) && router.pathname === routes/* PATHS.MOVIES_SLUG */.yy.MOVIES_SLUG);
    var ref8 = (0,services/* useGetMovieDetails */.TA)({
        query: {
            id: dialog === null || dialog === void 0 ? void 0 : (ref2 = dialog.rulesOfEntryDialogPayload) === null || ref2 === void 0 ? void 0 : ref2.movieId
        },
        params: (0,_object_spread/* default */.Z)({
            cityId: cityId
        }, getBankOfferParams(), getUnipalOfferParams())
    }, {
        enabled: !isFilmRateAvailable,
        onError: function(error) {
            if (axios_default().isAxiosError(error)) {
                setDialog({});
            }
        }
    }), movieDetails = ref8.data, isMovieFetching = ref8.isFetching, isMovieSuccess = ref8.isSuccess;
    var initOrder = (0,services/* useInitOrder */.gd)();
    var rate = isFilmRateAvailable ? movie === null || movie === void 0 ? void 0 : (ref3 = movie.film) === null || ref3 === void 0 ? void 0 : ref3.rate : movieDetails === null || movieDetails === void 0 ? void 0 : (ref4 = movieDetails.film) === null || ref4 === void 0 ? void 0 : ref4.rate;
    // TODO: change main dialog width and height to be responsive
    // TODO: fix lists dots left margin
    // TODO: check the following function placement
    var handleBackwardClick = (0,react.useCallback)(function() {
        setDialog(function(prevState) {
            return {
                wrapper: false,
                rulesOfEntryDialogPayload: prevState === null || prevState === void 0 ? void 0 : prevState.rulesOfEntryDialogPayload
            };
        });
        setTimeout(function() {
            setDialog(function(prevState) {
                return {
                    wrapper: true,
                    isRulesOfEntryDialog: true,
                    rulesOfEntryDialogPayload: prevState === null || prevState === void 0 ? void 0 : prevState.rulesOfEntryDialogPayload
                };
            });
        }, 500);
    }, [
        setDialog
    ]);
    var openTermsAndConditionsDialog = (0,react.useCallback)(function() {
        setDialog(function(prevState) {
            return {
                wrapper: false,
                rulesOfEntryDialogPayload: prevState === null || prevState === void 0 ? void 0 : prevState.rulesOfEntryDialogPayload
            };
        });
        setTimeout(function() {
            setDialog(function(prevState) {
                return {
                    wrapper: true,
                    isTermsAndConditionsForm: true,
                    termsAndConditionsFormPayload: {
                        handleBackwardClick: handleBackwardClick
                    },
                    rulesOfEntryDialogPayload: prevState === null || prevState === void 0 ? void 0 : prevState.rulesOfEntryDialogPayload
                };
            });
        }, 500);
    }, [
        handleBackwardClick,
        setDialog
    ]);
    var openHouseRulesDialog = (0,react.useCallback)(function() {
        setDialog(function(prevState) {
            return {
                wrapper: false,
                rulesOfEntryDialogPayload: prevState === null || prevState === void 0 ? void 0 : prevState.rulesOfEntryDialogPayload
            };
        });
        setTimeout(function() {
            setDialog(function(prevState) {
                return {
                    wrapper: true,
                    isHouseRulesDialog: true,
                    rulesOfEntryDialogPayload: prevState === null || prevState === void 0 ? void 0 : prevState.rulesOfEntryDialogPayload
                };
            });
        }, 500);
    }, [
        setDialog
    ]);
    var handleAgreeClick = (0,react.useCallback)(function() {
        var ref;
        initOrder.safeMutateAsync({
            data: (0,_object_spread/* default */.Z)({
                sessionId: dialog === null || dialog === void 0 ? void 0 : (ref = dialog.rulesOfEntryDialogPayload) === null || ref === void 0 ? void 0 : ref.sessionId,
                clientDate: luxon/* DateTime.now */.ou.now().toISO()
            }, (dialog === null || dialog === void 0 ? void 0 : dialog.rulesOfEntryDialogPayload.offerId) ? {
                offerId: dialog === null || dialog === void 0 ? void 0 : dialog.rulesOfEntryDialogPayload.offerId
            } : {}, getBankOfferParams(), getUnipalOfferParams())
        }, {
            onSuccess: function(data) {
                var ref, ref1;
                libs/* storage.orderAnalyticsSubmit.set */.tO.orderAnalyticsSubmit.set({
                    id: 0,
                    isSubmitted: false
                });
                var activeExperienceTab = data === null || data === void 0 ? void 0 : data.experiences.findIndex(function(experience) {
                    return experience.id === (data === null || data === void 0 ? void 0 : data.order.experience.id);
                });
                var activeSessions = data === null || data === void 0 ? void 0 : data.experiences.find(function(experience) {
                    return experience.id === (data === null || data === void 0 ? void 0 : data.order.experience.id);
                }).sessions;
                var activeShowTimeTab = data === null || data === void 0 ? void 0 : data.experiences.find(function(experience) {
                    return experience.id === (data === null || data === void 0 ? void 0 : data.order.experience.id);
                }).sessions.findIndex(function(session) {
                    return session.id === (data === null || data === void 0 ? void 0 : data.order.session.id);
                });
                setIsLegalBookingFlow(true);
                setBooking({
                    sessionId: dialog === null || dialog === void 0 ? void 0 : (ref = dialog.rulesOfEntryDialogPayload) === null || ref === void 0 ? void 0 : ref.sessionId,
                    isThreeD: dialog === null || dialog === void 0 ? void 0 : (ref1 = dialog.rulesOfEntryDialogPayload) === null || ref1 === void 0 ? void 0 : ref1.isThreeD,
                    orderId: data === null || data === void 0 ? void 0 : data.order.id,
                    movieId: data === null || data === void 0 ? void 0 : data.order.film.id,
                    movieSlug: data === null || data === void 0 ? void 0 : data.order.film.uniqueName,
                    experiences: data === null || data === void 0 ? void 0 : data.experiences,
                    activeExperienceTab: activeExperienceTab,
                    activeSessions: activeSessions,
                    activeShowTimeTab: activeShowTimeTab,
                    maxSeats: data === null || data === void 0 ? void 0 : data.maxSeats,
                    expireAt: data === null || data === void 0 ? void 0 : data.order.expireAt,
                    paymentGateway: data === null || data === void 0 ? void 0 : data.order.paymentGateway,
                    offer: data === null || data === void 0 ? void 0 : data.offer,
                    cityId: cityId,
                    prevOfferFlowLegalPath: router.pathname === routes/* PATHS.OFFERS_SLUG_SHOWS */.yy.OFFERS_SLUG_SHOWS && !isShowTimesDrawerOpen ? router.asPath : router.pathname === routes/* PATHS.MOVIES_SLUG */.yy.MOVIES_SLUG && router.query.offerId && !isShowTimesDrawerOpen ? "/movies/".concat(router.query.slug, "/?cityId=").concat(cityId) : null
                });
                setDialog({});
                if (router.pathname === routes/* PATHS.MOVIES_SLUG_BOOKING */.yy.MOVIES_SLUG_BOOKING || router.pathname === routes/* PATHS.BOOKINGS_ID_CHECKOUT */.yy.BOOKINGS_ID_CHECKOUT) {
                    router.replace("/movies/".concat(data === null || data === void 0 ? void 0 : data.order.film.uniqueName, "/booking"));
                } else {
                    router.push("/movies/".concat(data === null || data === void 0 ? void 0 : data.order.film.uniqueName, "/booking"));
                }
            },
            onError: function(error) {
                if (axios_default().isAxiosError(error)) {
                    if (error.response.data.code === Film_HAS_BEEN_STARTED_CODE) {
                        var ref;
                        setDialog({});
                        dialog === null || dialog === void 0 ? void 0 : (ref = dialog.rulesOfEntryDialogPayload) === null || ref === void 0 ? void 0 : ref.refetchFunction();
                    }
                }
            }
        });
    }, [
        cityId,
        dialog === null || dialog === void 0 ? void 0 : dialog.rulesOfEntryDialogPayload,
        getBankOfferParams,
        getUnipalOfferParams,
        initOrder,
        isShowTimesDrawerOpen,
        router,
        setBooking,
        setDialog,
        setIsLegalBookingFlow,
        setSnack, 
    ]);
    var handleCloseDialog = function() {
        setDialog({});
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(close_button/* CloseButton */.P, {
                    handleClick: handleCloseDialog
                })
            }),
            isMovieFetching ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                sx: {
                    justifyContent: "center",
                    alignItems: "center",
                    flexGrow: 1
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(customized_circular_progress/* default */.Z, {
                    size: 40,
                    thickness: 4
                })
            }) : isMovieSuccess || isFilmRateAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                        sx: {
                            color: theme.palette.grey[60]
                        },
                        children: [
                            rate && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        component: "div",
                                        sx: {
                                            textAlign: "center",
                                            marginBottom: (0,typography/* pxToRem */.Q)(24),
                                            fontSize: (0,typography/* pxToRem */.Q)(22),
                                            fontFamily: "co-head-line-corp-bold",
                                            color: theme.palette.common.black
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                            id: "booking.rules_of_entry"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                        direction: "row",
                                        spacing: 2,
                                        sx: {
                                            alignItems: "center",
                                            marginBottom: (0,typography/* pxToRem */.Q)(16)
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                                                img: rate === null || rate === void 0 ? void 0 : rate.iconUrl,
                                                title: rate.title,
                                                objectFit: "cover",
                                                sx: {
                                                    minWidth: "54px",
                                                    minHeight: "54px"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                children: rate.description
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                        component: "ul",
                                        spacing: 2,
                                        sx: {
                                            ml: 2
                                        },
                                        children: rate.rules.map(function(rule) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                component: "li",
                                                children: rule.text
                                            }, rule.id);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                        sx: {
                                            marginY: (0,typography/* pxToRem */.Q)(24),
                                            border: "none",
                                            borderTop: "".concat((0,typography/* pxToRem */.Q)(1), " solid ").concat(theme.palette.grey[20])
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                sx: {
                                    alignItems: "center",
                                    fontFamily: "co-head-line-corp-bold",
                                    marginBottom: (0,typography/* pxToRem */.Q)(26)
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        sx: {
                                            marginBottom: (0,typography/* pxToRem */.Q)(8),
                                            color: theme.palette.grey[80]
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                            id: "booking.agree"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        id: "rules-of-entry-terms",
                                        type: "button",
                                        sx: {
                                            fontFamily: theme.palette.typography.font.bold,
                                            marginBottom: (0,typography/* pxToRem */.Q)(3),
                                            color: theme.palette.link.main
                                        },
                                        onClick: openTermsAndConditionsDialog,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                            id: "terms.and.conditions"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        id: "rules-of-entry-house-rules",
                                        type: "button",
                                        sx: {
                                            fontFamily: theme.palette.typography.font.bold,
                                            color: theme.palette.link.main
                                        },
                                        onClick: openHouseRulesDialog,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                            id: "booking.house_rules"
                                        })
                                    })
                                ]
                            }),
                            (dialog === null || dialog === void 0 ? void 0 : (ref5 = dialog.rulesOfEntryDialogPayload) === null || ref5 === void 0 ? void 0 : ref5.isAfterMidnight) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                sx: {
                                    alignItems: "center",
                                    marginBottom: (0,typography/* pxToRem */.Q)(32)
                                },
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                                        img: "/icons/booking/midnight.svg",
                                        title: rate.title,
                                        objectFit: "contain",
                                        sx: {
                                            width: "49px",
                                            height: "54px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        sx: {
                                            fontSize: (0,typography/* pxToRem */.Q)(14),
                                            fontFamily: "co-head-line-corp-bold",
                                            lineHeight: (0,typography/* pxToRem */.Q)(24)
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                            id: "booking.after_midnight"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                id: "order-cancel",
                                type: "button",
                                fullWidth: true,
                                sx: {
                                    fontFamily: theme.palette.typography.font.bold,
                                    color: theme.palette.grey[70]
                                },
                                onClick: handleCloseDialog,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                    id: "global.cancel"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                                id: "order-init",
                                variant: "contained",
                                fullWidth: true,
                                loading: initOrder.isLoading,
                                onClick: handleAgreeClick,
                                sx: {
                                    height: {
                                        tablet: (0,typography/* pxToRem */.Q)(56),
                                        mobile: "56px"
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                    id: "global.agree"
                                })
                            })
                        ]
                    })
                ]
            }) : null
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(34386);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Check.js
var Check = __webpack_require__(27036);
// EXTERNAL MODULE: ./src/components/shared/icon-24.tsx
var icon_24 = __webpack_require__(97946);
;// CONCATENATED MODULE: ./src/components/booking/dialogs/share-seats-plan-dialog.tsx










var ShareWhiteIcon = "/icons/shared/share-white.svg";
var ShareSeatsPlanDialog = function() {
    var ref = (0,react.useState)(false), isLinkCopied = ref[0], setIsLinkedCopied = ref[1];
    var intl = (0,useIntl/* default */.Z)();
    var booking = (0,state/* useBooking */.v4)(function(s) {
        return s.booking;
    }, shallow/* default */.Z);
    var setDialog = (0,state/* useDialog */.Rh)(function(s) {
        return s.setDialog;
    }, shallow/* default */.Z);
    var setSnack = (0,state/* useSnack */.eW)(function(s) {
        return s.setSnack;
    }, shallow/* default */.Z);
    var handleShareSeatsPlanClick = (0,react.useCallback)(function() {
        navigator.clipboard.writeText(booking.seatsPlanImageUrl).then(function() {
            setIsLinkedCopied(true);
            setTimeout(function() {
                return setIsLinkedCopied(false);
            }, 1000);
        }).catch(function() {
            setSnack({
                isOpen: true,
                message: "booking.share_seats_plan.copy_link.fail",
                type: "error"
            });
        });
    }, [
        booking.seatsPlanImageUrl,
        setSnack
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(close_button/* CloseButton */.P, {
                    handleClick: function() {
                        return setDialog({});
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                    img: booking === null || booking === void 0 ? void 0 : booking.seatsPlanImageUrl,
                    title: intl.formatMessage({
                        id: "booking.seats_plan_image"
                    }),
                    objectFit: "contain",
                    sx: {
                        width: "100%",
                        height: "300px"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                sx: {
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                        id: isLinkCopied ? "booking.share_seats_plan.click" : "booking.share_seats_plan.hover"
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        id: "share-seats-plan-dialog-share-btn",
                        variant: "secondary",
                        startIcon: isLinkCopied ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {
                            sx: {
                                fontSize: "24px !important"
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_24/* default */.Z, {
                            icon: ShareWhiteIcon,
                            title: "alt.share_ticket_icon"
                        }),
                        onClick: handleShareSeatsPlanClick,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                            id: "booking.share_seats_plan"
                        })
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/stand-alone/logout-timer-dialog.tsx








var LogoutTimerDialog = function() {
    var theme = (0,useTheme/* default */.Z)();
    var setDialog = (0,state/* useDialog */.Rh)(function(s) {
        return s.setDialog;
    }, shallow/* default */.Z);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    sx: {
                        alignItems: "center",
                        margin: "auto"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                marginBlock: 4
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                                img: "/icons/booking/session-expired-icon.svg",
                                title: "logout",
                                objectFit: "contain",
                                sx: {
                                    width: "108px",
                                    height: "102px"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: theme.palette.grey[90],
                                fontSize: (0,typography/* pxToRem */.Q)(22),
                                fontWeight: 700,
                                lineHeight: "33px",
                                marginBottom: (0,typography/* pxToRem */.Q)(24)
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                id: "global.session_expired"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: theme.palette.grey[70],
                                fontSize: (0,typography/* pxToRem */.Q)(18),
                                fontWeight: 400,
                                lineHeight: "27px",
                                textAlign: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                                id: "logout.timer.desc"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    id: "logout-okay",
                    variant: "contained",
                    fullWidth: true,
                    onClick: function() {
                        setDialog({
                            wrapper: false,
                            isLogoutTimerDialog: false
                        });
                    },
                    sx: {
                        height: {
                            tablet: (0,typography/* pxToRem */.Q)(56),
                            mobile: "56px"
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_message/* default */.Z, {
                        id: "global.okay"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var logout_timer_dialog = (LogoutTimerDialog);

// EXTERNAL MODULE: ./src/logic/hooks/use-check-client-city.ts
var use_check_client_city = __webpack_require__(63802);
// EXTERNAL MODULE: ./src/logic/hooks/use-update-path.ts
var use_update_path = __webpack_require__(63633);
;// CONCATENATED MODULE: ./src/logic/hooks/use-logout-timer.ts








var LOGOUT_TIMEOUT = 15 * 60 * 1000; // 15 minutes in milliseconds
var useLogoutTimer = function() {
    var setDialog = (0,state/* useDialog */.Rh)(function(s) {
        return s.setDialog;
    }, shallow/* default */.Z);
    var ref = (0,react.useState)(false), isPromptVisible = ref[0], setIsPromptVisible = ref[1];
    var ref1 = (0,react.useState)(LOGOUT_TIMEOUT / 1000), remainingTime = ref1[0], setRemainingTime = ref1[1]; // 15 minutes in seconds
    var timeoutIdRef = (0,react.useRef)(null);
    var intervalIdRef = (0,react.useRef)(null);
    var setSideMenu = (0,state/* useSideMenu */.W0)(function(s) {
        return s.setSideMenu;
    }, shallow/* default */.Z);
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,state/* useAuth */.aC)(function(s) {
        return [
            s.user,
            s.setUser
        ];
    }, shallow/* default */.Z), 2), user = ref2[0], setUser = ref2[1];
    var checkGuestCity = (0,use_check_client_city/* useCheckClientCity */.$)().checkGuestCity;
    var updateLogoutPath = (0,use_update_path/* useUpdatePath */.U)().updateLogoutPath;
    var logout = (0,services/* useLogout */.aU)();
    var invalidateAllWallet = (0,use_invalidate_wallet/* useInvalidateWallet */.J)().invalidateAllWallet;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,state/* useOneSignalCustomState */.EC)(function(s) {
        return [
            s.muviDeviceId
        ];
    }, shallow/* default */.Z), 1), deviceId = ref3[0];
    var handleLogoutConfirm = (0,react.useCallback)(function() {
        logout.safeMutateAsync({
            headers: {
                "X-Device-Id": deviceId
            }
        }, {
            onSuccess: function() {
                setUser(null);
                checkGuestCity();
                setSideMenu(false);
                updateLogoutPath();
                setTimeout(function() {
                    invalidateAllWallet();
                    setDialog({
                        wrapper: true,
                        isLogoutTimerDialog: true
                    });
                }, 1000);
                setDialog({
                    wrapper: true,
                    isLogoutTimerDialog: true
                });
            }
        });
    }, [
        checkGuestCity,
        deviceId,
        invalidateAllWallet,
        logout,
        setDialog,
        setSideMenu,
        setUser,
        updateLogoutPath, 
    ]);
    var handleLogout = function() {
        setDialog({
            wrapper: true,
            isLogoutTimerDialog: true
        });
        console.log("Logging out due to inactivity");
        handleLogoutConfirm();
    };
    // const startCountdown = (): void => {
    //   intervalIdRef.current = setInterval(() => {
    //     setRemainingTime(prev => {
    //       if (prev <= 1) {
    //         clearInterval(intervalIdRef.current!);
    //         handleLogout();
    //         return 0;
    //       }
    //       return prev - 1;
    //     });
    //   }, 1000);
    // };
    var resetTimer = function() {
        if (timeoutIdRef.current) {
            clearTimeout(timeoutIdRef.current);
        }
        if (intervalIdRef.current) {
            clearInterval(intervalIdRef.current);
        }
        setIsPromptVisible(false);
        setRemainingTime(LOGOUT_TIMEOUT / 1000);
        timeoutIdRef.current = setTimeout(function() {
            // setIsPromptVisible(true);
            // startCountdown();
            handleLogout();
        }, LOGOUT_TIMEOUT);
    };
    var handleActivity = function() {
        resetTimer();
    };
    (0,react.useEffect)(function() {
        if (!(user === null || user === void 0 ? void 0 : user.token)) return;
        window.addEventListener("mousemove", handleActivity);
        window.addEventListener("keypress", handleActivity);
        resetTimer();
        return function() {
            if (timeoutIdRef.current) {
                clearTimeout(timeoutIdRef.current);
            }
            if (intervalIdRef.current) {
                clearInterval(intervalIdRef.current);
            }
            window.removeEventListener("mousemove", handleActivity);
            window.removeEventListener("keypress", handleActivity);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user
    ]);
    return {
        remainingTime: remainingTime,
        handleLogout: handleLogout,
        isPromptVisible: isPromptVisible
    };
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Push/is-push-supported.js
var is_push_supported = __webpack_require__(47733);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Push/request-push-permission.js
var request_push_permission = __webpack_require__(12261);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Core/initialize.js
var initialize = __webpack_require__(69390);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/ui/automatically-show-in-app-messages.js
var automatically_show_in_app_messages = __webpack_require__(73659);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/index.js + 56 modules
var src = __webpack_require__(65943);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/ContentCards/subscribe-to-content-cards-updates.js
var subscribe_to_content_cards_updates = __webpack_require__(49954);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Core/change-user.js
var change_user = __webpack_require__(34790);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/subscribe-to-in-app-message.js
var subscribe_to_in_app_message = __webpack_require__(30174);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/models/control-message.js
var control_message = __webpack_require__(98376);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/ui/show-in-app-message.js + 6 modules
var show_in_app_message = __webpack_require__(78914);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/InAppMessage/models/in-app-message.js
var in_app_message = __webpack_require__(1792);
// EXTERNAL MODULE: ./node_modules/@braze/web-sdk/src/Core/open-session.js
var open_session = __webpack_require__(45430);
;// CONCATENATED MODULE: ./src/logic/hooks/use-braze.ts







var BrazeApiKey = config_default()().publicRuntimeConfig.brazeApiKey;
var BrazeSdkEndpoint = "sdk.fra-02.braze.eu";
var useBraze = function() {
    var ref = (0,react.useState)(null), _braze = ref[0], setBraze = ref[1];
    var user = (0,state/* useAuth */.aC)(function(s) {
        return s.user;
    }, shallow/* default */.Z);
    (0,react.useEffect)(function() {
        if (!(0,dist/* checkIsBrowser */.SU)()) return;
        // if (!!_braze || !user?.token) return;
        if (!(user === null || user === void 0 ? void 0 : user.token)) return;
        if (is_push_supported/* isPushSupported */.H()) {
            request_push_permission.requestPushPermission();
        }
        initialize/* initialize */.j(BrazeApiKey, {
            baseUrl: BrazeSdkEndpoint,
            serviceWorkerLocation: "/BrazeSDKWorker.js"
        });
        // optionally show all in-app messages without custom handling
        automatically_show_in_app_messages/* automaticallyShowInAppMessages */.f();
        setBraze(src);
        subscribe_to_content_cards_updates/* subscribeToContentCardsUpdates */.x(function(cards) {
        // console.log('cards', cards);
        // cards have been updated
        });
        // optionally set the current user's external ID before starting a new session
        // you can also call `changeUser` later in the session after the user logs in
        change_user.changeUser(user.id.toString());
        // braze.getUser().setCustomUserAttribute('firstName', user.firstName);
        // braze.getUser().setEmail(user.email);
        // braze.getUser().setFirstName(user?.firstName);
        subscribe_to_in_app_message/* subscribeToInAppMessage */.u(function(inAppMessage) {
            // control group messages should always be "shown"
            // this will log an impression and not show a visible message
            if ((0,_instanceof/* default */.Z)(inAppMessage, control_message/* default */.Z)) {
                return show_in_app_message/* showInAppMessage */.g(inAppMessage);
            }
            if ((0,_instanceof/* default */.Z)(inAppMessage, in_app_message/* default */.Z)) {
                var extras = inAppMessage.extras;
                if (extras) {
                    for(var key in extras){
                        console.log("key: " + key + ", value: " + extras[key]);
                    }
                }
            }
            show_in_app_message/* showInAppMessage */.g(inAppMessage);
        });
        // `openSession` should be called last - after `changeUser` and `automaticallyShowInAppMessages`
        open_session/* openSession */.U();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        _braze,
        user
    ]);
    return {};
};

;// CONCATENATED MODULE: ./src/components/layout/umbrella.tsx

















































var MainDialog = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4507).then(__webpack_require__.bind(__webpack_require__, 94507)).then(function(component) {
        return component.MainDialog;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94507)
            ];
        }
    },
    ssr: false
});
var DimmedLayer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9491).then(__webpack_require__.bind(__webpack_require__, 19491)).then(function(component) {
        return component.DimmedLayer;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19491)
            ];
        }
    },
    ssr: false
});
var ShowTimesDrawer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1362), __webpack_require__.e(9464), __webpack_require__.e(5686), __webpack_require__.e(5578)]).then(__webpack_require__.bind(__webpack_require__, 5578)).then(function(component) {
        return component.ShowTimesDrawer;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5578)
            ];
        }
    },
    ssr: false
});
var CompleteProfileForm = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7399).then(__webpack_require__.bind(__webpack_require__, 57399)).then(function(component) {
        return component.CompleteProfileForm;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57399)
            ];
        }
    },
    ssr: false
});
var OldUserChangeEmailForm = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 858).then(__webpack_require__.bind(__webpack_require__, 60858));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60858)
            ];
        }
    },
    ssr: false
});
var OldUserForm = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4434).then(__webpack_require__.bind(__webpack_require__, 41653));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41653)
            ];
        }
    },
    ssr: false
});
var OldUserEmailOtpForm = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1309).then(__webpack_require__.bind(__webpack_require__, 91309));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91309)
            ];
        }
    },
    ssr: false
});
var OldUserChangeEmailOtpForm = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7854).then(__webpack_require__.bind(__webpack_require__, 17854));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17854)
            ];
        }
    },
    ssr: false
});
var OtpEmailForm = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 175).then(__webpack_require__.bind(__webpack_require__, 70175)).then(function(component) {
        return component.OtpEmailForm;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(70175)
            ];
        }
    },
    ssr: false
});
var AvatarsForm = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2895), __webpack_require__.e(5303)]).then(__webpack_require__.bind(__webpack_require__, 35303)).then(function(component) {
        return component.AvatarsForm;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35303)
            ];
        }
    },
    ssr: false
});
var PhoneNumberForm = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4841).then(__webpack_require__.bind(__webpack_require__, 74841)).then(function(component) {
        return component.PhoneNumberForm;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74841)
            ];
        }
    },
    ssr: false
});
var EditProfileForm = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6948).then(__webpack_require__.bind(__webpack_require__, 86948)).then(function(component) {
        return component.EditProfileForm;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86948)
            ];
        }
    },
    ssr: false
});
var ChangeEmailOtpForm = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9525).then(__webpack_require__.bind(__webpack_require__, 59525)).then(function(component) {
        return component.ChangeEmailOtpForm;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59525)
            ];
        }
    },
    ssr: false
});
var ChangeEmailResetCodeForm = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7594).then(__webpack_require__.bind(__webpack_require__, 77594)).then(function(component) {
        return component.ChangeEmailResetCodeForm;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(77594)
            ];
        }
    },
    ssr: false
});
var ChangePhoneNumberOtpForm = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6216).then(__webpack_require__.bind(__webpack_require__, 91264)).then(function(component) {
        return component.ChangePhoneNumberOtpForm;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91264)
            ];
        }
    },
    ssr: false
});
var ChangePhoneNumberResetCodeForm = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2992).then(__webpack_require__.bind(__webpack_require__, 62992)).then(function(component) {
        return component.ChangePhoneNumberResetCodeForm;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62992)
            ];
        }
    },
    ssr: false
});
var NewEmailForm = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5897).then(__webpack_require__.bind(__webpack_require__, 95897)).then(function(component) {
        return component.NewEmailForm;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95897)
            ];
        }
    },
    ssr: false
});
var NewPhoneNumberForm = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2728).then(__webpack_require__.bind(__webpack_require__, 92728)).then(function(component) {
        return component.NewPhoneNumberForm;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92728)
            ];
        }
    },
    ssr: false
});
var ProfileChangeOptionsForm = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1437).then(__webpack_require__.bind(__webpack_require__, 11437)).then(function(component) {
        return component.ProfileChangeOptionsForm;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11437)
            ];
        }
    },
    ssr: false
});
var WalletExpiryDetailsDialog = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8430).then(__webpack_require__.bind(__webpack_require__, 68430)).then(function(component) {
        return component.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68430)
            ];
        }
    },
    ssr: false
});
var AboutWalletDialog = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 787).then(__webpack_require__.bind(__webpack_require__, 10787)).then(function(component) {
        return component.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10787)
            ];
        }
    },
    ssr: false
});
var AboutCashbackDialog = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9557).then(__webpack_require__.bind(__webpack_require__, 29557)).then(function(component) {
        return component.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29557)
            ];
        }
    },
    ssr: false
});
var AddTopUpDialog = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6691), __webpack_require__.e(4253)]).then(__webpack_require__.bind(__webpack_require__, 24253)).then(function(component) {
        return component.AddTopUpDialog;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24253)
            ];
        }
    },
    ssr: false
});
var WalletRemainDialog = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6691), __webpack_require__.e(9715)]).then(__webpack_require__.bind(__webpack_require__, 79715)).then(function(component) {
        return component.WalletRemainDialog;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79715)
            ];
        }
    },
    ssr: false
});
var CashbackRemainDialog = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6691), __webpack_require__.e(3330)]).then(__webpack_require__.bind(__webpack_require__, 83330)).then(function(component) {
        return component.CashbackRemainDialog;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83330)
            ];
        }
    },
    ssr: false
});
var CancelTicketConfirmDialog = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7741).then(__webpack_require__.bind(__webpack_require__, 57741)).then(function(component) {
        return component.CancelTicketConfirmDialog;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57741)
            ];
        }
    },
    ssr: false
});
var WalletOtpEmailForm = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3244).then(__webpack_require__.bind(__webpack_require__, 43244)).then(function(component) {
        return component.WalletOtpEmailForm;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(43244)
            ];
        }
    },
    ssr: false
});
var ChangeEmailConfirmDialog = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5039).then(__webpack_require__.bind(__webpack_require__, 75039)).then(function(component) {
        return component.ChangeEmailConfirmDialog;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75039)
            ];
        }
    },
    ssr: false
});
var StcVerificationCodeModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9794).then(__webpack_require__.bind(__webpack_require__, 79794)).then(function(component) {
        return component.StcVerificationCodeModal;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79794)
            ];
        }
    },
    ssr: false
});
var Umbrella = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,state/* useDialog */.Rh)(function(s) {
        return [
            s.dialog,
            s.setDialog
        ];
    }, shallow/* default */.Z), 2), dialog = ref[0], setDialog = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,state/* useSnack */.eW)(function(s) {
        return [
            s.snack,
            s.setSnack
        ];
    }, shallow/* default */.Z), 2), snack = ref1[0], setSnack = ref1[1];
    var ref2 = (0,react.useState)(false), mounted = ref2[0], setMounted = ref2[1];
    var user = (0,state/* useAuth */.aC)(function(s) {
        return s.user;
    }, shallow/* default */.Z);
    useBraze(); // TODO check later maybe we can move it to layout
    /**
   * It returns a JSX.Element based on the boolean values passed to it
   * @param  - isPhoneNumberForm
   * @returns A JSX.Element
   */ var getDialog = function(param) {
        var isPhoneNumberForm = param.isPhoneNumberForm, isApplyOfferDialog = param.isApplyOfferDialog, isTermsAndConditionsForm = param.isTermsAndConditionsForm, isOtpForm = param.isOtpForm, isCompleteProfileForm = param.isCompleteProfileForm, isEmailOtpForm = param.isEmailOtpForm, isAvatarForm = param.isAvatarForm, isOldUserForm = param.isOldUserForm, isProfileChangeOptionsForm = param.isProfileChangeOptionsForm, isChangeEmailOtpForm = param.isChangeEmailOtpForm, isOldUserChangeEmailForm = param.isOldUserChangeEmailForm, isOldUserEmailOtpForm = param.isOldUserEmailOtpForm, isOldUserChangeEmailOtpForm = param.isOldUserChangeEmailOtpForm, isNewEmailForm = param.isNewEmailForm, isChangeEmailResetCodeForm = param.isChangeEmailResetCodeForm, isChangePhoneNumberResetCodeForm = param.isChangePhoneNumberResetCodeForm, isNewPhoneNumberForm = param.isNewPhoneNumberForm, isChangePhoneNumberOtpForm = param.isChangePhoneNumberOtpForm, isCitiesForm = param.isCitiesForm, isChangeCityConfirmDialog = param.isChangeCityConfirmDialog, isRulesOfEntryDialog = param.isRulesOfEntryDialog, isHouseRulesDialog = param.isHouseRulesDialog, isCancelSeatsSelectionConfirmDialog = param.isCancelSeatsSelectionConfirmDialog, isChangeExperienceConfirmDialog = param.isChangeExperienceConfirmDialog, isChangeShowtimeConfirmDialog = param.isChangeShowtimeConfirmDialog, isWheelChairConfirmDialog = param.isWheelChairConfirmDialog, isCompanionConfirmDialog = param.isCompanionConfirmDialog, isShareSeatsPlanDialog = param.isShareSeatsPlanDialog, isReservedSeatsInfoDialog = param.isReservedSeatsInfoDialog, isSessionExpiredInfoDialog = param.isSessionExpiredInfoDialog, isAllowedToChangeShowTimesDialog = param.isAllowedToChangeShowTimesDialog, isAllowedToClearAllFiltersDialog = param.isAllowedToClearAllFiltersDialog, isEditProfileForm = param.isEditProfileForm, isDeleteCardConfirmationDialog = param.isDeleteCardConfirmationDialog, isDeleteVoucherConfirmDialog = param.isDeleteVoucherConfirmDialog, isApplyMultiVoucherDialog = param.isApplyMultiVoucherDialog, isAddCreditCardForm = param.isAddCreditCardForm, isEditCreditCardForm = param.isEditCreditCardForm, isNotificationPopover = param.isNotificationPopover, isClearHistoryConfirmDialog = param.isClearHistoryConfirmDialog, isNotAvailableOfferInfoDialog = param.isNotAvailableOfferInfoDialog, isLogoutConfirmDialog = param.isLogoutConfirmDialog, isDeleteOfferConfirmDialog = param.isDeleteOfferConfirmDialog, isCardNotSameVerifiedConfirmDialog = param.isCardNotSameVerifiedConfirmDialog, isCardNotSupportedConfirmDialog = param.isCardNotSupportedConfirmDialog, isCardNotSameAppliedConfirmDialog = param.isCardNotSameAppliedConfirmDialog, isOfflineDialog = param.isOfflineDialog, isExperienceInfoDialog = param.isExperienceInfoDialog, isAdBlockDialog = param.isAdBlockDialog, isGuestOtpForm = param.isGuestOtpForm, isOfferLimitInfoDialog = param.isOfferLimitInfoDialog, isOfferLimitConfirmDialog = param.isOfferLimitConfirmDialog, isReportMuviDialog = param.isReportMuviDialog, isWalletExpiryDetailsDialog = param.isWalletExpiryDetailsDialog, isAboutWalletDialog = param.isAboutWalletDialog, isAboutCashbackDialog = param.isAboutCashbackDialog, isAddTopUpDialog = param.isAddTopUpDialog, isWalletRemainDialog = param.isWalletRemainDialog, isCashbackRemainDialog = param.isCashbackRemainDialog, isCancelTicketConfirmDialog = param.isCancelTicketConfirmDialog, isWalletOtpEmailForm = param.isWalletOtpEmailForm, isChangeEmailConfirmDialog = param.isChangeEmailConfirmDialog, isStcVerificationCode = param.isStcVerificationCode, isLogoutTimerDialog = param.isLogoutTimerDialog;
        if (isPhoneNumberForm) return /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneNumberForm, {});
        if (isApplyOfferDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplyOfferDialog, {});
        if (isTermsAndConditionsForm) return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditionsForm, {});
        if (isOtpForm) return /*#__PURE__*/ (0,jsx_runtime.jsx)(OtpForm, {});
        if (isCompleteProfileForm) return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompleteProfileForm, {});
        if (isEmailOtpForm) return /*#__PURE__*/ (0,jsx_runtime.jsx)(OtpEmailForm, {});
        if (isEditProfileForm) return /*#__PURE__*/ (0,jsx_runtime.jsx)(EditProfileForm, {});
        if (isAvatarForm) return /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarsForm, {});
        if (isOldUserForm) return /*#__PURE__*/ (0,jsx_runtime.jsx)(OldUserForm, {});
        if (isProfileChangeOptionsForm) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileChangeOptionsForm, {});
        if (isChangeEmailOtpForm) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeEmailOtpForm, {});
        if (isOldUserChangeEmailForm) return /*#__PURE__*/ (0,jsx_runtime.jsx)(OldUserChangeEmailForm, {});
        if (isOldUserEmailOtpForm) return /*#__PURE__*/ (0,jsx_runtime.jsx)(OldUserEmailOtpForm, {});
        if (isOldUserChangeEmailOtpForm) return /*#__PURE__*/ (0,jsx_runtime.jsx)(OldUserChangeEmailOtpForm, {});
        if (isNewEmailForm) return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewEmailForm, {});
        if (isChangeEmailResetCodeForm) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeEmailResetCodeForm, {});
        if (isChangePhoneNumberResetCodeForm) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangePhoneNumberResetCodeForm, {});
        if (isNewPhoneNumberForm) return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewPhoneNumberForm, {});
        if (isChangePhoneNumberOtpForm) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangePhoneNumberOtpForm, {});
        if (isCitiesForm) return /*#__PURE__*/ (0,jsx_runtime.jsx)(CitiesForm, {});
        if (isChangeCityConfirmDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeCityConfirmDialog, {});
        if (isRulesOfEntryDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(RulesOfEntryDialog, {});
        if (isHouseRulesDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(HouseRules, {});
        if (isCancelSeatsSelectionConfirmDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelSeatsSelectionConfirmDialog, {});
        if (isChangeExperienceConfirmDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeExperienceConfirmDialog, {});
        if (isChangeShowtimeConfirmDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeShowtimeConfirmDialog, {});
        if (isWheelChairConfirmDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(WheelChairConfirmDialog, {});
        if (isCompanionConfirmDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanionConfirmDialog, {});
        if (isShareSeatsPlanDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareSeatsPlanDialog, {});
        if (isReservedSeatsInfoDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReservedSeatsInfoDialog, {});
        if (isSessionExpiredInfoDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(SessionExpiredInfoDialog, {});
        if (isAllowedToChangeShowTimesDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeShowTimesDialog, {});
        if (isAllowedToClearAllFiltersDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClearAllFiltersDialog, {});
        if (isDeleteCardConfirmationDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteCardConfirmationDialog, {});
        if (isDeleteVoucherConfirmDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteVoucherConfirmDialog, {});
        if (isApplyMultiVoucherDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplyMultiVoucherDialog, {});
        if (isAddCreditCardForm) return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddCreditCardForm, {});
        if (isEditCreditCardForm) return /*#__PURE__*/ (0,jsx_runtime.jsx)(EditCreditCardForm, {});
        if (isNotificationPopover) return /*#__PURE__*/ (0,jsx_runtime.jsx)(notifications_popover_content/* default */.Z, {});
        if (isClearHistoryConfirmDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClearHistoryConfirmDialog, {});
        if (isNotAvailableOfferInfoDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotAvailableOfferInfoDialog, {});
        if (isLogoutConfirmDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoutConfirmDialog, {});
        if (isDeleteOfferConfirmDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteOfferConfirmDialog, {});
        if (isCardNotSameVerifiedConfirmDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardNotSameVerifiedConfirmDialog, {});
        if (isCardNotSupportedConfirmDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardNotSupportedConfirmDialog, {});
        if (isCardNotSameAppliedConfirmDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardNotSameAppliedConfirmDialog, {});
        if (isOfflineDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(offline_dialog, {});
        if (isExperienceInfoDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExperienceInfoDialog, {});
        if (isAdBlockDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ad_block_dialog, {});
        if (isGuestOtpForm) return /*#__PURE__*/ (0,jsx_runtime.jsx)(GuestOtpForm, {});
        if (isOfferLimitInfoDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferLimitInfoDialog, {});
        if (isOfferLimitConfirmDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferLimitConfirmDialog, {});
        if (isReportMuviDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(contact_us_dialog, {});
        if (isWalletExpiryDetailsDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(WalletExpiryDetailsDialog, {});
        if (isAboutWalletDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutWalletDialog, {});
        if (isAboutCashbackDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutCashbackDialog, {});
        if (isAddTopUpDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddTopUpDialog, {});
        if (isWalletRemainDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(WalletRemainDialog, {});
        if (isCashbackRemainDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(CashbackRemainDialog, {});
        if (isCancelTicketConfirmDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelTicketConfirmDialog, {});
        if (isWalletOtpEmailForm) return /*#__PURE__*/ (0,jsx_runtime.jsx)(WalletOtpEmailForm, {});
        if (isChangeEmailConfirmDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeEmailConfirmDialog, {});
        if (isStcVerificationCode) return /*#__PURE__*/ (0,jsx_runtime.jsx)(StcVerificationCodeModal, {});
        if (isLogoutTimerDialog) return /*#__PURE__*/ (0,jsx_runtime.jsx)(logout_timer_dialog, {});
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    };
    var handleCloseSnack = (0,react.useCallback)(function() {
        setSnack(function(snack) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, snack), {
                isOpen: false
            });
        });
    }, [
        setSnack
    ]);
    (0,react.useEffect)(function() {
        setMounted(true);
    }, []);
    var isPromptVisible = useLogoutTimer().isPromptVisible;
    (0,react.useEffect)(function() {
        if (!!(user === null || user === void 0 ? void 0 : user.token) && !!isPromptVisible) {
            setDialog({
                wrapper: true,
                isLogoutTimerDialog: true
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mounted,
        user,
        isPromptVisible
    ]);
    return !!mounted && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainDialog, {
                children: getDialog((0,_object_spread/* default */.Z)({}, dialog))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SnackbarPopup, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, snack), {
                closeSnack: function() {
                    return handleCloseSnack();
                }
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowTimesDrawer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DimmedLayer, {})
        ]
    });
};


/***/ }),

/***/ 54087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91057);
/* harmony import */ var _mui_icons_material_ErrorOutline__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32141);



var InputAdornmentComponent = function(param) {
    var errorCondition = param.errorCondition;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        position: "end",
        children: errorCondition ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_ErrorOutline__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            color: "error"
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InputAdornmentComponent);


/***/ }),

/***/ 20569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ CreditCardCvvInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22715);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91057);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86896);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44012);
/* harmony import */ var react_input_mask__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76627);
/* harmony import */ var react_input_mask__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_input_mask__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _image_box_future__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58718);
/* harmony import */ var _components_checkout_checkout_cvv_input_info__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8712);






var CreditCardCvvInput = function(param) {
    var creditCardType = param.creditCardType, creditCardCvv = param.creditCardCvv, isCreditCardCvvValid = param.isCreditCardCvvValid, handleChange = param.handleChange, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_input_mask__WEBPACK_IMPORTED_MODULE_1___default()), {
                mask: creditCardType === "american-express" ? "9999" : "999",
                maskChar: "",
                disabled: isLoading,
                value: creditCardCvv,
                onChange: handleChange,
                children: function() {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        id: "credit-card-cvv",
                        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            id: "my_credit_cards.cvv"
                        }),
                        disabled: isLoading,
                        dir: "ltr",
                        sx: {
                            legend: {
                                width: 0
                            }
                        },
                        InputProps: {
                            sx: {
                                color: theme.palette.grey[80]
                            },
                            endAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                position: "end",
                                sx: {
                                    width: "49px",
                                    height: "39px"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_box_future__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    img: "/icons/credit-cards/cvv-placeholder-card.svg",
                                    title: intl.formatMessage({
                                        id: "alt.credit_card_icon"
                                    }),
                                    objectFit: "contain",
                                    sx: {
                                        width: "100%",
                                        height: "100%"
                                    }
                                })
                            })
                        },
                        InputLabelProps: {
                            sx: {
                                backgroundColor: "white",
                                paddingInline: "6px"
                            },
                            shrink: true
                        },
                        inputProps: {
                            inputMode: "numeric"
                        },
                        error: !isCreditCardCvvValid && Boolean(creditCardCvv),
                        helperText: !isCreditCardCvvValid && Boolean(creditCardCvv) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            id: "my_credit_cards.cvv.invalid"
                        })
                    });
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_checkout_checkout_cvv_input_info__WEBPACK_IMPORTED_MODULE_3__/* .CheckoutCvvInputInfo */ .e, {})
        ]
    });
};


/***/ }),

/***/ 57197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ CreditCardExpiryDateInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94054);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22715);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56815);
/* harmony import */ var _mui_x_date_pickers_DatePicker__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40328);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30120);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44012);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);








var CreditCardExpiryDateInput = function(param) {
    var value = param.value, handleChange = param.handleChange, registerFunc = param.registerFunc, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _isError = param.isError, isError = _isError === void 0 ? false : _isError, _helperText = param.helperText, helperText = _helperText === void 0 ? "" : _helperText;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_x_date_pickers_DatePicker__WEBPACK_IMPORTED_MODULE_4__/* .DatePicker */ .M, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, registerFunc()), {
                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    id: "my_credit_cards.expiry_date"
                }),
                disabled: isLoading,
                value: value,
                inputFormat: "MM/yy",
                views: [
                    "month",
                    "year"
                ],
                renderInput: function(params) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, params), {
                        id: "credit-card-expiry-date",
                        dir: locale === "ar" ? "rtl" : "ltr",
                        sx: isError ? {
                            ".MuiSvgIcon-root": {
                                fill: function(theme) {
                                    return theme.palette.error.main;
                                }
                            }
                        } : {},
                        onKeyDown: function(e) {
                            return e.preventDefault();
                        },
                        error: isError,
                        inputProps: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, params.inputProps), {
                            placeholder: luxon__WEBPACK_IMPORTED_MODULE_1__/* .DateTime.now */ .ou.now().setLocale(locale).toFormat("MM/yy")
                        })
                    }));
                },
                minDate: luxon__WEBPACK_IMPORTED_MODULE_1__/* .DateTime.now */ .ou.now(),
                maxDate: luxon__WEBPACK_IMPORTED_MODULE_1__/* .DateTime.now */ .ou.now().plus({
                    years: 20
                }),
                onChange: handleChange
            })),
            isError ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                error: true,
                children: helperText
            }) : null
        ]
    });
};


/***/ }),

/***/ 24837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ CreditCardHolderInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22715);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44012);




var CreditCardHolderInput = function(param) {
    var registerFunc = param.registerFunc, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _isError = param.isError, isError = _isError === void 0 ? false : _isError, _helperText = param.helperText, helperText = _helperText === void 0 ? "" : _helperText;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        id: "credit-card-holder",
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            id: "my_credit_cards.card_holder"
        }),
        disabled: isLoading,
        InputProps: {
            sx: {
                color: theme.palette.grey[80]
            }
        },
        error: isError,
        helperText: helperText
    }, registerFunc()));
};


/***/ }),

/***/ 45593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ CreditCardNameInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22715);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44012);




var CreditCardNameInput = function(param) {
    var registerFunc = param.registerFunc, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _isAutoFocus = param.isAutoFocus, isAutoFocus = _isAutoFocus === void 0 ? false : _isAutoFocus, _isError = param.isError, isError = _isError === void 0 ? false : _isError, _helperText = param.helperText, helperText = _helperText === void 0 ? "" : _helperText;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        id: "credit-card-name",
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            id: "my_credit_cards.card_name"
        }),
        disabled: isLoading,
        InputProps: {
            sx: {
                color: theme.palette.grey[80]
            }
        },
        autoFocus: isAutoFocus,
        error: isError,
        helperText: helperText
    }, registerFunc()));
};


/***/ }),

/***/ 32353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ CreditCardNumberInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86896);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(44012);
/* harmony import */ var _logic_services__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10029);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(22715);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(91057);
/* harmony import */ var _logic_shared__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(946);
/* harmony import */ var react_input_mask__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76627);
/* harmony import */ var react_input_mask__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_input_mask__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var zustand_shallow__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(60374);
/* harmony import */ var _logic_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42125);
/* harmony import */ var _image_box_future__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58718);












var CreditCardNumberInput = function(param) {
    var creditCardType = param.creditCardType, creditCardNumber = param.creditCardNumber, isCreditCardNumberValid = param.isCreditCardNumberValid, handleChange = param.handleChange, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), madaCardMutationResponse = ref[0], setMadaCardMutationResponse = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), setDebouncedTermState = ref1[1];
    var checkIsMadaCardMutation = (0,_logic_services__WEBPACK_IMPORTED_MODULE_2__/* .useCheckIsMadaCardMutation */ .Of)();
    var setGuestBookingInfo = (0,_logic_state__WEBPACK_IMPORTED_MODULE_5__/* .useOrder */ .Aj)(function(s) {
        return s.setGuestBookingInfo;
    }, zustand_shallow__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z);
    var handleDebounce = function(termState) {
        setDebouncedTermState(function(prev) {
            if (termState.replace(/ /g, "").length >= 8) {
                if ((0,_logic_shared__WEBPACK_IMPORTED_MODULE_3__/* .sliceStringWithoutSpaces */ .HV)(prev) !== (0,_logic_shared__WEBPACK_IMPORTED_MODULE_3__/* .sliceStringWithoutSpaces */ .HV)(termState)) {
                    checkIsMadaCardMutation.safeMutateAsync({
                        data: {
                            bh6: (0,_logic_shared__WEBPACK_IMPORTED_MODULE_3__/* .hashString */ .Wu)((0,_logic_shared__WEBPACK_IMPORTED_MODULE_3__/* .sliceStringWithoutSpaces */ .HV)(termState, 6)),
                            bh8: (0,_logic_shared__WEBPACK_IMPORTED_MODULE_3__/* .hashString */ .Wu)((0,_logic_shared__WEBPACK_IMPORTED_MODULE_3__/* .sliceStringWithoutSpaces */ .HV)(termState))
                        }
                    }, {
                        onSuccess: function(res) {
                            setGuestBookingInfo(function(prevState) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, prevState), {
                                    isMadaCard: res.isMada
                                });
                            });
                            setMadaCardMutationResponse(res);
                        }
                    });
                }
            } else setMadaCardMutationResponse(null);
            return termState;
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_input_mask__WEBPACK_IMPORTED_MODULE_4___default()), {
        mask: creditCardType === "american-express" ? "9999 999999 99999" : "9999 9999 9999 9999",
        maskChar: "",
        disabled: isLoading,
        value: creditCardNumber,
        onChange: function(e) {
            handleChange(e);
            handleDebounce(e.target.value);
        },
        children: function() {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                id: "credit-card-number",
                disabled: isLoading,
                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    id: "my_credit_cards.card_number"
                }),
                dir: "ltr",
                sx: {
                    legend: {
                        width: 0
                    }
                },
                InputLabelProps: {
                    sx: {
                        backgroundColor: "white",
                        paddingInline: "6px"
                    }
                },
                InputProps: {
                    sx: {
                        color: theme.palette.grey[80]
                    },
                    startAdornment: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        position: "start",
                        sx: {
                            width: "25px",
                            height: "25px"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_box_future__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            img: (0,_logic_shared__WEBPACK_IMPORTED_MODULE_3__/* .getInputCreditCardIcon */ .MQ)((madaCardMutationResponse === null || madaCardMutationResponse === void 0 ? void 0 : madaCardMutationResponse.isMada) ? "mada" : creditCardType),
                            title: intl.formatMessage({
                                id: "alt.credit_card_icon"
                            }),
                            objectFit: "contain",
                            sx: {
                                width: "100%",
                                height: "100%"
                            }
                        })
                    })
                },
                inputProps: {
                    inputMode: "numeric"
                },
                error: !isCreditCardNumberValid && Boolean(creditCardNumber),
                helperText: !isCreditCardNumberValid && Boolean(creditCardNumber) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    id: "my_credit_cards.card_number.invalid"
                })
            });
        }
    });
};


/***/ }),

/***/ 97313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ CreditCardSwitchInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53457);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50480);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44012);
/* harmony import */ var _components_shared_ios_switch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27896);
/* harmony import */ var _theme_typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43795);





var CreditCardSwitchInput = function(param) {
    var handleChange = param.handleChange, label = param.label, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _isChecked = param.isChecked, isChecked = _isChecked === void 0 ? false : _isChecked;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        id: "credit-card-mark-default",
        sx: {
            marginTop: {
                mobile: "20px",
                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q)(28)
            },
            alignItems: "flex-start",
            "& .MuiFormControlLabel-label": {
                fontSize: "16px",
                color: theme.palette.grey[80]
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            disabled: isLoading,
            control: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_ios_switch__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                isChecked: isChecked,
                isDisabled: isLoading,
                onChange: handleChange
            }),
            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                id: label
            })
        })
    });
};


/***/ }),

/***/ 58614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ SupportedCreditCards; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16216);
/* harmony import */ var _mui_icons_material_InfoOutlined__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2548);
/* harmony import */ var _dialog_form_dialog_form_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44197);




var SupportedCreditCards = function() {
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        direction: "row",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_InfoOutlined__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                sx: {
                    color: theme.palette.typography.color.muted,
                    marginRight: "8px",
                    marginTop: "4px",
                    width: "24px",
                    height: "24px"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dialog_form_dialog_form_description__WEBPACK_IMPORTED_MODULE_1__/* .DialogFormDescription */ .y, {
                message: "my_credit_cards.supported_cards",
                sx: {
                    textAlign: "left",
                    marginBottom: 0
                }
            })
        ]
    });
};


/***/ }),

/***/ 4997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ CloseButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54799);
/* harmony import */ var _icon_24__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97946);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86896);





var DialogCloseIcon = "/icons/dialog/close.svg";
var CloseButton = function(param) {
    var _icon = param.icon, icon = _icon === void 0 ? DialogCloseIcon : _icon, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, sx = param.sx, handleClick = param.handleClick;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        id: "close-icon",
        "aria-label": intl.formatMessage({
            id: "images.title.close"
        }),
        disabled: disabled,
        onClick: handleClick,
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            position: "absolute",
            top: 12,
            left: 12,
            opacity: disabled ? 0.4 : 1
        }, sx),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_24__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            icon: icon,
            title: "alt.close"
        })
    });
};


/***/ }),

/***/ 1046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ ConfirmDialog; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37645);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6514);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16216);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(31425);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(83321);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86896);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(44012);
/* harmony import */ var _close_button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4997);
/* harmony import */ var _image_box_future__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58718);
/* harmony import */ var _mui_lab__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(31812);
/* harmony import */ var _theme_typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43795);







var ConfirmDialog = function(param) {
    var buttonId = param.buttonId, img = param.img, widthImage = param.widthImage, heightImage = param.heightImage, altImage = param.altImage, title = param.title, description = param.description, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, handleOkayClick = param.handleOkayClick, handleCloseClick = param.handleCloseClick;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_close_button__WEBPACK_IMPORTED_MODULE_1__/* .CloseButton */ .P, {
                    disabled: isLoading,
                    handleClick: handleCloseClick
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    sx: {
                        alignItems: "center",
                        margin: "auto"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            sx: {
                                marginBlock: 4
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_box_future__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                img: img,
                                title: intl.formatMessage({
                                    id: altImage || "alt.icon"
                                }),
                                objectFit: "contain",
                                sx: {
                                    width: widthImage || "100px",
                                    height: heightImage || "100px"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            sx: {
                                color: theme.palette.grey[90],
                                fontSize: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_3__/* .pxToRem */ .Q)(22),
                                fontWeight: 700,
                                lineHeight: "33px",
                                marginBottom: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_3__/* .pxToRem */ .Q)(24)
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                id: title
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            sx: {
                                color: theme.palette.grey[70],
                                fontSize: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_3__/* .pxToRem */ .Q)(18),
                                fontWeight: 400,
                                lineHeight: "27px",
                                textAlign: "center"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                id: description
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        id: "".concat(buttonId, "-cancel"),
                        type: "button",
                        disabled: isLoading,
                        fullWidth: true,
                        sx: {
                            fontFamily: theme.palette.typography.font.bold,
                            color: theme.palette.grey[70]
                        },
                        onClick: handleCloseClick,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            id: "global.cancel"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_lab__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        id: "".concat(buttonId, "-yes"),
                        variant: "contained",
                        fullWidth: true,
                        loading: isLoading,
                        onClick: handleOkayClick,
                        sx: {
                            height: {
                                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_3__/* .pxToRem */ .Q)(56),
                                mobile: "56px"
                            }
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            id: "global.yes"
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 27708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ DialogFormButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44012);
/* harmony import */ var _mui_lab__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31812);
/* harmony import */ var _theme_typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43795);





var DialogFormButton = function(param) {
    var handleSave = param.handleSave, label = param.label, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _isDisabled = param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled, customSx = param.customSx, customComponent = param.customComponent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_lab__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        id: "credit-card-save",
        variant: "contained",
        fullWidth: true,
        disabled: isDisabled,
        loading: isLoading,
        onClick: handleSave,
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            height: {
                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_1__/* .pxToRem */ .Q)(56),
                mobile: "56px"
            }
        }, customSx),
        children: [
            customComponent === null || customComponent === void 0 ? void 0 : customComponent(),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                id: label
            })
        ]
    });
};


/***/ }),

/***/ 44197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ DialogFormDescription; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15861);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44012);
/* harmony import */ var _theme_typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43795);





var DialogFormDescription = function(param) {
    var message = param.message, sx = param.sx;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        component: "span",
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            fontSize: "16px",
            color: theme.palette.typography.color.muted,
            marginBottom: {
                mobile: "32px",
                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_1__/* .pxToRem */ .Q)(28)
            }
        }, sx),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            id: message
        })
    });
};


/***/ }),

/***/ 49742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ DialogFormTitle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15861);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44012);
/* harmony import */ var _theme_typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43795);





var DialogFormTitle = function(param) {
    var message = param.message, sx = param.sx;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        component: "span",
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            display: "block",
            marginBottom: {
                mobile: "36px",
                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_1__/* .pxToRem */ .Q)(48)
            },
            fontSize: {
                mobile: "18px",
                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_1__/* .pxToRem */ .Q)(22)
            },
            fontFamily: theme.palette.typography.font.bold,
            letterSpacing: {
                mobile: "0.1px",
                tablet: "normal"
            },
            color: theme.palette.grey[90]
        }, sx),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            id: message
        })
    });
};


/***/ }),

/***/ 27896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45843);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2734);



var CustomSwitch = (0,_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        focusVisibleClassName: ".Mui-focusVisible",
        disableRipple: true
    }, props));
})(function() {
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    return {
        width: "42px",
        height: "20px",
        marginLeft: "12px",
        marginRight: "16px",
        padding: 0,
        "& .MuiSwitch-switchBase": {
            padding: 0,
            margin: "3px 4px",
            transitionDuration: "0.3s",
            "&.Mui-checked": {
                transform: "translateX(20px)",
                color: "#fff",
                "& + .MuiSwitch-track": {
                    backgroundColor: theme.palette.primary.main,
                    opacity: 1,
                    border: 0
                },
                "&.Mui-disabled + .MuiSwitch-track": {
                    opacity: 0.5
                }
            },
            "&.Mui-focusVisible .MuiSwitch-thumb": {
                color: "#33cf4d",
                border: "6px solid #fff"
            },
            "&.Mui-disabled .MuiSwitch-thumb": {
                color: theme.palette.grey[100]
            },
            "&.Mui-disabled + .MuiSwitch-track": {
                opacity: 0.7
            }
        },
        "& .MuiSwitch-thumb": {
            boxSizing: "border-box",
            width: "14px",
            height: "14px"
        },
        "& .MuiSwitch-track": {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.grey[30],
            opacity: 1,
            transition: theme.transitions.create([
                "background-color"
            ], {
                duration: 500
            })
        }
    };
});
var IOSSwitch = function(param) {
    var sx = param.sx, isChecked = param.isChecked, _isDisabled = param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled, onChange = param.onChange;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomSwitch, {
        sx: sx,
        checked: isChecked,
        disabled: isDisabled,
        onChange: onChange
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (IOSSwitch);


/***/ }),

/***/ 32468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ VerificationCodeForm; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74231);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(37645);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(6514);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(36822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(94054);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(56815);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(16216);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(31425);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86896);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(44012);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_shared_customized_circular_progress__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75491);
/* harmony import */ var react_otp_input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71470);
/* harmony import */ var _theme_typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43795);
/* harmony import */ var zustand_shallow__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(60374);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(87536);
/* harmony import */ var _logic_state__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42125);
/* harmony import */ var react_timer_hook__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3751);
/* harmony import */ var react_timer_hook__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react_timer_hook__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(47533);
/* harmony import */ var _backward_button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7969);
/* harmony import */ var _close_button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4997);
/* harmony import */ var _image_box_future__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(58718);



















var VerificationCodeForm = function(param) {
    var title = param.title, subtitle = param.subtitle, description = param.description, isVerifyCodeLoading = param.isVerifyCodeLoading, error = param.error, isBackwardEnabled = param.isBackwardEnabled, handleFormClose = param.handleFormClose, handleFormSubmit = param.handleFormSubmit, handleCodeResend = param.handleCodeResend, value = param.value, actionComponent = param.actionComponent, isSendOtpLoading = param.isSendOtpLoading, errorMessage = param.errorMessage;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)();
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_logic_state__WEBPACK_IMPORTED_MODULE_6__/* .useOtpTimer */ .lT)(function(s) {
        return [
            s.otpTimer,
            s.setOtpTimer
        ];
    }, zustand_shallow__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z), 2), otpTimer = ref[0], setOtpTimer = ref[1];
    var ref1 = (0,react_timer_hook__WEBPACK_IMPORTED_MODULE_7__.useTimer)({
        expiryTimestamp: new Date(),
        autoStart: true
    }), seconds = ref1.seconds, minutes = ref1.minutes, restart = ref1.restart, isRunning = ref1.isRunning;
    var schema = yup__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry({
        code: yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_().required().max(4).min(4)
    });
    var ref2 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_15__/* .useForm */ .cI)({
        resolver: (0,_hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_16__/* .yupResolver */ .X)(schema),
        mode: "onSubmit"
    }), register = ref2.register, setValue = ref2.setValue, handleSubmit = ref2.handleSubmit, trigger = ref2.trigger, getValues = ref2.getValues, _formState = ref2.formState, errors = _formState.errors, isSubmitted = _formState.isSubmitted, dirtyFields = _formState.dirtyFields;
    var onSubmit = handleSubmit(handleFormSubmit);
    var startTime = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var time = new Date();
        if ((otpTimer === null || otpTimer === void 0 ? void 0 : otpTimer.timerVal) > 0) {
            time.setSeconds(time.getSeconds() + (otpTimer === null || otpTimer === void 0 ? void 0 : otpTimer.timerVal));
            restart(time);
        }
    }, [
        restart,
        otpTimer === null || otpTimer === void 0 ? void 0 : otpTimer.timerVal
    ]);
    var resendVerificationCode = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        handleCodeResend();
        var otpInput = document.querySelector(".otp-input");
        if (otpInput) {
            otpInput === null || otpInput === void 0 ? void 0 : otpInput.focus();
        }
        startTime();
    }, [
        handleCodeResend,
        startTime
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (error) {
            setValue("code", "");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        error
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (otpTimer === null || otpTimer === void 0 ? void 0 : otpTimer.timerVal) startTime();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        otpTimer === null || otpTimer === void 0 ? void 0 : otpTimer.timerVal
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if ((otpTimer === null || otpTimer === void 0 ? void 0 : otpTimer.timerVal) > 0) {
            setOtpTimer({
                timerVal: otpTimer === null || otpTimer === void 0 ? void 0 : otpTimer.timerVal,
                isRunning: isRunning
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isRunning
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                children: isBackwardEnabled ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_backward_button__WEBPACK_IMPORTED_MODULE_8__/* .BackwardButton */ .e, {
                    handleClick: handleFormClose
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_close_button__WEBPACK_IMPORTED_MODULE_9__/* .CloseButton */ .P, {
                    handleClick: handleFormClose
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        sx: {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            width: "90%",
                            margin: "auto"
                        },
                        children: [
                            title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                component: "div",
                                variant: "h4",
                                sx: {
                                    textAlign: "center",
                                    fontFamily: "co-head-line-corp-bold",
                                    lineHeight: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(18),
                                    color: theme.palette.primary.main
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                    id: title
                                })
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_box_future__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                img: "/icons/logos/muvi-logo.svg",
                                title: intl.formatMessage({
                                    id: "images.logo"
                                }),
                                objectFit: "contain",
                                sx: {
                                    width: "152px",
                                    height: "97px",
                                    alignSelf: "center"
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                component: "div",
                                variant: "h4",
                                sx: {
                                    marginTop: "24px",
                                    textAlign: "center",
                                    fontWeight: 700
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                    id: subtitle
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                component: "div",
                                variant: "h6",
                                sx: {
                                    direction: "rtl",
                                    textAlign: "center",
                                    mt: "5px",
                                    color: theme.palette.typography.color.muted
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                    id: description,
                                    values: {
                                        value: value
                                    }
                                })
                            })
                        ]
                    }),
                    isVerifyCodeLoading || isSendOtpLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "auto",
                            marginBlock: 3
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_customized_circular_progress__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            size: 40,
                            thickness: 4
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        sx: {
                            mt: 7
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                            variant: "standard",
                            id: "otp-input",
                            sx: {
                                display: "flex",
                                justifyContent: "center",
                                "& .otp-input": {
                                    width: "64px !important",
                                    height: "64px",
                                    borderRadius: "16px",
                                    backgroundColor: theme.palette.layout.backgroundColor,
                                    border: "none",
                                    outline: "none",
                                    fontSize: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(28),
                                    fontWeight: 900,
                                    color: theme.palette.typography.color.muted
                                }
                            },
                            children: [
                                !isVerifyCodeLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_otp_input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)({}, register("code")), {
                                    value: getValues().code,
                                    onChange: function(value) {
                                        setValue("code", value);
                                        trigger();
                                        if (value.length === 4) onSubmit();
                                    },
                                    isInputNum: true,
                                    shouldAutoFocus: true,
                                    separator: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                        sx: {
                                            marginInline: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(20)
                                        }
                                    }),
                                    containerStyle: {
                                        margin: "auto",
                                        direction: "ltr"
                                    },
                                    inputStyle: "otp-input",
                                    focusStyle: {
                                        border: "3px solid ".concat(theme.palette.primary.main)
                                    },
                                    errorStyle: {
                                        border: "3px solid #E14851"
                                    },
                                    hasErrored: error && Boolean(dirtyFields) && isSubmitted
                                })),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z, {
                                    id: "otp-error-message",
                                    error: true,
                                    sx: {
                                        mt: 1,
                                        ml: 3
                                    },
                                    children: (errors.code || error) && isSubmitted && (errorMessage !== null && errorMessage !== void 0 ? errorMessage : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                        id: "verification.code.not.valid"
                                    }))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
                        direction: "row",
                        sx: {
                            mt: 4,
                            justifyContent: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                component: "div",
                                variant: "h6",
                                sx: {
                                    textAlign: "center",
                                    color: theme.palette.typography.color.muted,
                                    fontSize: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(16)
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                    id: "did_not.receive.otp"
                                })
                            }),
                            isRunning && !isSendOtpLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                component: "div",
                                variant: "h6",
                                sx: {
                                    textAlign: "center",
                                    color: theme.palette.primary.main,
                                    fontSize: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(16)
                                },
                                children: [
                                    "\xa0",
                                    minutes < 10 ? "0".concat(minutes) : minutes,
                                    ":",
                                    seconds < 10 ? "0".concat(seconds) : seconds
                                ]
                            }),
                            !isRunning && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                id: "resend-otp",
                                component: "div",
                                variant: "h6",
                                onClick: function() {
                                    return resendVerificationCode();
                                },
                                sx: {
                                    textAlign: "center",
                                    color: theme.palette.primary.main,
                                    fontSize: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_5__/* .pxToRem */ .Q)(16),
                                    cursor: "pointer",
                                    "&:hover": {
                                        color: theme.palette.primary.main
                                    }
                                },
                                children: [
                                    "\xa0",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                        id: "resend.otp"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            actionComponent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                children: actionComponent
            })
        ]
    });
};


/***/ }),

/***/ 28216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ AUTH_FLOW; }
/* harmony export */ });
var AUTH_FLOW = {
    HOME: "HOME",
    OLD: "OLD",
    COMPLETE_PROFILE: "COMPLETE_PROFILE",
    EMAIL_ERROR: 17
};


/***/ }),

/***/ 6825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kb": function() { return /* binding */ COMPLAINT; },
/* harmony export */   "WA": function() { return /* binding */ complaintSubCategoryList; },
/* harmony export */   "ac": function() { return /* binding */ ONLINE_BOOKING; },
/* harmony export */   "ap": function() { return /* binding */ I_CAN_NOT_BOOK_A_TICKET; },
/* harmony export */   "df": function() { return /* binding */ onlineSubCategoryList; },
/* harmony export */   "wA": function() { return /* binding */ categoryList; }
/* harmony export */ });
/* unused harmony exports MOVIES_INQUIRY, GENERAL_INQUIRY */
var COMPLAINT = "COMPLAINT";
var ONLINE_BOOKING = "ONLINE_BOOKING";
var MOVIES_INQUIRY = "MOVIES_INQUIRY";
var GENERAL_INQUIRY = "GENERAL_INQUIRY";
var I_CAN_NOT_BOOK_A_TICKET = "I_CAN_NOT_BOOK_A_TICKET";
var categoryList = [
    ONLINE_BOOKING,
    COMPLAINT,
    MOVIES_INQUIRY,
    GENERAL_INQUIRY
];
var complaintSubCategoryList = [
    "I_AM_NOT_HAPPY_WITH_THE_CLEANLINESS_OF_THE_CINEMA",
    "I_HAVE_WAITED_TOO_LONG_IN_THE_QUEUE",
    "I_AM_NOT_SATISFIED_WITH_THE_FOOD_AND_BEVERAGES_SERVED",
    "I_AM_UNHAPPY_ABOUT_THE_SERVICE_OF_STAFF",
    "I_AM_UNHAPPY_WITH_THE_TEMPERATURE_OF_THE_CINEMA",
    "I_AM_UNHAPPY_WITH_THE_QUALITY_OF_THE_MOVIE_SHOWN",
    "OTHERS", 
];
var onlineSubCategoryList = [
    "I_DID_NOT_RECEIVE_MY_TICKET",
    "I_BOOKED_THE_WRONG_TICKET",
    "MY_PAYMENT_IS_UNSUCCESSFUL",
    "I_RECEIVED_ERROR_MESSAGE",
    "I_CAN_NOT_BOOK_A_TICKET", 
];


/***/ }),

/***/ 49135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ag": function() { return /* binding */ WALLET; },
/* harmony export */   "Bo": function() { return /* binding */ CASHBACK_WALLET; },
/* harmony export */   "FQ": function() { return /* binding */ STC_PAY; },
/* harmony export */   "Hn": function() { return /* binding */ NONE; },
/* harmony export */   "TU": function() { return /* binding */ CARD; },
/* harmony export */   "_O": function() { return /* binding */ PAYFORT; },
/* harmony export */   "gE": function() { return /* binding */ HYPER_PAY; },
/* harmony export */   "iK": function() { return /* binding */ CHECKOUT; },
/* harmony export */   "o3": function() { return /* binding */ TOKEN; }
/* harmony export */ });
/* unused harmony export APPLE_PAY */
//Payment Strategy
var TOKEN = "TOKEN";
var CHECKOUT = "CHECKOUT";
var HYPER_PAY = "HYPER_PAY";
var PAYFORT = "PAYFORT";
var CARD = "CARD";
var WALLET = "E_WALLET";
var CASHBACK_WALLET = "CASHBACK_WALLET";
var APPLE_PAY = "APPLE_PAY";
var NONE = "NONE";
var STC_PAY = "STC_PAY";


/***/ }),

/***/ 22010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ excludedCountriesList; }
/* harmony export */ });
var excludedCountriesList = [
    "il",
    "ca",
    "us",
    "kz",
    "do",
    "pr"
];


/***/ }),

/***/ 90867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useInvalidateWallet; }
/* harmony export */ });
/* harmony import */ var _services_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65362);
/* harmony import */ var _constants_wallet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45163);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85945);
/* harmony import */ var _services_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37013);




var useInvalidateWallet = function() {
    var queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQueryClient */ .NL)();
    var invalidateBalance = function() {
        _constants_wallet__WEBPACK_IMPORTED_MODULE_2__/* .isWalletFeatureEnabled */ .jG && queryClient.invalidateQueries([
            {
                method: "get",
                url: "".concat(_services_config__WEBPACK_IMPORTED_MODULE_3__/* .walletUrl */ .BT, "/balance")
            }, 
        ]);
    };
    var invalidateTransactions = function() {
        _constants_wallet__WEBPACK_IMPORTED_MODULE_2__/* .isWalletFeatureEnabled */ .jG && queryClient.invalidateQueries([
            {
                method: "get",
                url: _services_config__WEBPACK_IMPORTED_MODULE_3__/* .walletUrl */ .BT,
                params: {
                    page: 1,
                    limit: 10
                }
            }, 
        ]);
    };
    var invalidateExpiredTransactions = function() {
        _constants_wallet__WEBPACK_IMPORTED_MODULE_2__/* .isWalletFeatureEnabled */ .jG && queryClient.invalidateQueries([
            {
                method: "get",
                url: "".concat(_services_config__WEBPACK_IMPORTED_MODULE_3__/* .walletUrl */ .BT, "/expired"),
                params: {
                    page: 1,
                    limit: 10,
                    walletType: _services_types__WEBPACK_IMPORTED_MODULE_0__/* .E_WALLET */ .aM
                }
            }, 
        ]);
    };
    var invalidateAllWallet = function() {
        invalidateBalance();
        invalidateTransactions();
        invalidateExpiredTransactions();
    };
    return {
        invalidateBalance: invalidateBalance,
        invalidateTransactions: invalidateTransactions,
        invalidateExpiredTransactions: invalidateExpiredTransactions,
        invalidateAllWallet: invalidateAllWallet
    };
};


/***/ }),

/***/ 34658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ formatPrice; }
/* harmony export */ });
/* harmony import */ var lodash_isNumber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81763);
/* harmony import */ var lodash_isNumber__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isNumber__WEBPACK_IMPORTED_MODULE_0__);

/**
 * It takes a number and an IntlShape object and returns a string
 * @param {number} price - The price to be formatted.
 * @param {IntlShape} intl - IntlShape
 * @returns A function that takes two arguments, price and intl, and returns a string.
 */ function formatPrice(price, intl) {
    if (!lodash_isNumber__WEBPACK_IMPORTED_MODULE_0___default()(price)) return "";
    return "".concat(price, " ").concat(intl.formatMessage({
        id: "currency.SAR"
    }));
}


/***/ }),

/***/ 72947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* reexport */ useSendOtp; },
  "G": function() { return /* reexport */ useVerifyOtp; }
});

// EXTERNAL MODULE: ./src/logic/libs/index.ts
var libs = __webpack_require__(81900);
;// CONCATENATED MODULE: ./src/logic/services/otp/services.ts

var url = "auth/";
var useSendOtp = (0,libs/* createMutation */.cL)({
    method: "post",
    url: "".concat(url, "send-otp")
});
var useVerifyOtp = (0,libs/* createMutation */.cL)({
    method: "post",
    url: "".concat(url, "verify-otp")
});

;// CONCATENATED MODULE: ./src/logic/services/otp/index.ts




/***/ }),

/***/ 946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wE": function() { return /* binding */ aN2eN; },
  "AN": function() { return /* binding */ acceptOnlyNumberOnSafari; },
  "_5": function() { return /* binding */ checkIfPhoneNumberIsValid; },
  "P6": function() { return /* binding */ getBrowserHeight; },
  "wi": function() { return /* binding */ getBrowserWidth; },
  "pg": function() { return /* binding */ getCreditCardIcon; },
  "lC": function() { return /* binding */ getDeviceTimeZone; },
  "CA": function() { return /* binding */ getDialCodeFromPhoneNumber; },
  "MQ": function() { return /* binding */ getInputCreditCardIcon; },
  "ij": function() { return /* binding */ getUserAgent; },
  "Wu": function() { return /* binding */ hashString; },
  "wO": function() { return /* binding */ muviPhoneNumberTrimmer; },
  "HV": function() { return /* binding */ sliceStringWithoutSpaces; }
});

// UNUSED EXPORTS: handleError, is500

// EXTERNAL MODULE: ./node_modules/libphonenumber-js/min/exports/parsePhoneNumberFromString.js + 36 modules
var parsePhoneNumberFromString = __webpack_require__(32260);
;// CONCATENATED MODULE: ./public/icons/credit-cards/amex.png
/* harmony default export */ var amex = ({"src":"/_next/static/media/amex.00effc3f.png","height":128,"width":128,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAwUlEQVR42mMgDCpPs+m3nFNw7rqgaNNxXtEaiJ2AbK3mcwoMFafZGPjqz2YDFf1nKD31k6Hs1G8QBrOrzvwXBMkxFJ+qzJh97f/krff/9m66979z/V0wO2bqlf8MRacqGRjrzlZqNJ/737Xh7t+F+x//n7Hz4f8FB578rVx26z9D4clKBs46oDHVZ/4DrfkJxL+B9v4G8n8y1J75zw6SA3LYZBrOKsg1nFVUbTqrqNt8TlGw7owiQ80ZBaAiNoKeBACMMWWpr/OjkgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./src/logic/services/credit-cards/models.ts
var models = __webpack_require__(77364);
;// CONCATENATED MODULE: ./public/icons/credit-cards/mada.png
/* harmony default export */ var mada = ({"src":"/_next/static/media/mada.b028ab3c.png","height":17,"width":48,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAbUlEQVR4nGPknHHnFQPD////mFg4+V4/7BCtdrjzx8hOlPH7+9cMDAyqjEkrF80BKWBkYuL49u7D8jXpue/ULax+/v74SYSBgfEvY8cO/lf/GRj/MzH/5XzzmK+nO0nkq67JX/5fXxkZgSbwAgCTrCrIooH8/AAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./public/icons/credit-cards/mastercard.png
/* harmony default export */ var mastercard = ({"src":"/_next/static/media/mastercard.f9f00a76.png","height":128,"width":128,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAbFBMVEU+PUc9OUcoOUgoNUgAPUwAO0kAFksAAE4bOUgZMUhCP0dCOUcAQUsAOkkAKEoAJ0oAAE46O0c5OUc6PEc6OUdEP0ZEOUdjUkRiUkRhNEXPkizLKzfwkRvvkBvtRSntRCkqOkglO0gqNkgkMkgH+QZ5AAAAHHRSTlMAAAAAAAAAAAYGICAhISEhIWtreXn5+fv7+/39pt2N7gAAAD1JREFUeNpjYGJkZWFnY2Bm4ODm5RHg4+JkEFIQkxQXVRJkEFGUlpORUhYGMeRlgQywlARQCqKYH6gYph0AlfQEK6333cQAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/crypto-js/index.js
var crypto_js = __webpack_require__(81354);
;// CONCATENATED MODULE: ./public/icons/credit-cards/visa.png
/* harmony default export */ var visa = ({"src":"/_next/static/media/visa.4d3207ef.png","height":128,"width":128,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAy0lEQVR42mMgCNT9d7GLeOxUdE/cp+iesE/RLGy3ogeQrem/S1HMcyc7g6LPzhw1v13/Gcy2/WSw2vabwWnHbwbTbT9lvHb+V/HblcPAYLC1Mirv0P/12+783bbn3v+VG2+C2Y6xe/8zOO6oZOBx21FpGLL7/4599/+u3nzr/+6DD/8fOvHkr3/afpCplQwqvrty5H12/gcZC9Txm8EFiI23/QSJKQPlGCSBDgG6QdEzaZ+iaehuRaOQ3Yq+KfsVlXx3Ksp772Qn6EsAFvFdgKeUO/IAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/logic/shared/index.ts







var EmptyUpComing = "/icons/my-booking/emptyUpComing.svg";
var PlaceholderCardIcon = "/icons/credit-cards/placeholder-card.svg";
/**
 * This TypeScript function returns the image source of a credit card icon based on its type.
 * @param {CreditCardType} type - Credit card type, which is an enum with possible values of Visa,
 * MasterCard, and Amex.
 * @returns A string representing the source of the icon for a given credit card type. If the type is
 * not recognized, a default icon source is returned.
 */ var getCreditCardIcon = function(type) {
    if (type === models/* CreditCardType.Visa */.O.Visa) return visa.src;
    else if (type === models/* CreditCardType.MasterCard */.O.MasterCard) return mastercard.src;
    else if (type === models/* CreditCardType.Amex */.O.Amex) return amex.src;
    else if (type === models/* CreditCardType.Mada */.O.Mada) return mada.src;
    else return EmptyUpComing;
};
/**
 * This TypeScript function returns a credit card icon based on the type of credit card entered.
 * @param {ValidationCreditCardType} type - ValidationCreditCardType, which is a string representing
 * the type of credit card (e.g. 'visa', 'mastercard', 'american-express').
 * @returns The function `getInputCreditCardIcon` returns a string which is the icon of the credit card
 * type passed as an argument. If the argument is not one of the supported credit card types, it
 * returns a placeholder card icon.
 */ var getInputCreditCardIcon = function(type) {
    if (type === "visa") return getCreditCardIcon(models/* CreditCardType.Visa */.O.Visa);
    else if (type === "mastercard") return getCreditCardIcon(models/* CreditCardType.MasterCard */.O.MasterCard);
    else if (type === "american-express") return getCreditCardIcon(models/* CreditCardType.Amex */.O.Amex);
    else if (type === "mada") return getCreditCardIcon(models/* CreditCardType.Mada */.O.Mada);
    else return PlaceholderCardIcon;
};
/**
 * It takes a phone number and a dial code, checks if the first number is equal to '0' and removes it,
 * removes all non-digits chars, and returns the phone number with the dial code.
 * @param {string} phoneNumber - string - the phone number that you want to trim
 * @param {string} dialCode - "+91"
 * @returns A function that takes two parameters, phoneNumber and dialCode.
 */ var muviPhoneNumberTrimmer = function(phoneNumber, dialCode) {
    /* Removing the dial code from the phone number. */ phoneNumber = phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.substring(dialCode.length + 1);
    /* Checking if the first number is equal to '0' and removing it. */ if (phoneNumber.charAt(0) === "0") {
        phoneNumber = phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.substring(1);
    }
    /* Removing all non-digits chars. */ phoneNumber = phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.replace(/\D/g, "");
    /* Concatenating the dialCode and the phoneNumber. */ phoneNumber = "+".concat(dialCode).concat(phoneNumber);
    return phoneNumber;
};
var getDialCodeFromPhoneNumber = function(phoneNumber) {
    // Parse the phone number
    var parsedNumber = (0,parsePhoneNumberFromString/* parsePhoneNumberFromString */._)(phoneNumber);
    // Extract the dial code
    var dialCode = parsedNumber.countryCallingCode;
    return dialCode;
};
var is500 = function(error) {
    var ref, ref1;
    return ((ref = error.response) === null || ref === void 0 ? void 0 : ref.status) >= 500 && ((ref1 = error.response) === null || ref1 === void 0 ? void 0 : ref1.status) !== 503;
};
var handleError = function(error) {
    var ref;
    if ((error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.status) >= 500) return {
        redirect: {
            destination: "500",
            permanent: false
        }
    };
};
var getUserAgent = function() {
    return window.navigator.userAgent;
};
var getDeviceTimeZone = function() {
    return new Date().getTimezoneOffset();
};
var getBrowserWidth = function() {
    return Math.max(document.body.scrollWidth, document.documentElement.scrollWidth, document.body.offsetWidth, document.documentElement.offsetWidth, document.documentElement.clientWidth);
};
var getBrowserHeight = function() {
    return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.documentElement.clientHeight);
};
var checkIfPhoneNumberIsValid = function(phoneNumber, countryCode) {
    var _phoneNumber = (0,parsePhoneNumberFromString/* parsePhoneNumberFromString */._)(phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.toString(), countryCode);
    return (_phoneNumber === null || _phoneNumber === void 0 ? void 0 : _phoneNumber.isValid()) === true;
};
/**
 * It replaces each Arabic digit in the input string with its equivalent in the string '٠١٢٣٤٥٦٧٨٩'
 */ var aN2eN = function(s) {
    return s.replace(/[٠-٩]/g, function(d) {
        return "٠١٢٣٤٥٦٧٨٩".indexOf(d);
    });
};
var hashString = function(inputString) {
    return (0,crypto_js.SHA512)(inputString).toString();
};
var sliceStringWithoutSpaces = function(str, number) {
    return str.replace(/ /g, "").substring(0, number || 8);
};
var acceptOnlyNumberOnSafari = function(e) {
    if (e && !/[0-9]/.test(e.key) && // Allow only numbers
    e.key !== "Backspace" && // Allow backspace
    e.key !== "Tab" && // Allow tab
    e.key !== "ArrowLeft" && // Allow left arrow
    e.key !== "ArrowRight" && // Allow right arrow
    e.key !== "Delete" && // Allow delete
    e.key !== "Enter" && // Allow enter
    e.key !== "Escape" // Allow escape
    ) {
        e.preventDefault();
    }
};


/***/ }),

/***/ 12264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useContactUs; }
/* harmony export */ });
/* harmony import */ var _alpha_apps_react_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46080);

var initState = {
    contactUs: {
        isDisableReportBtn: false,
        reportDescriptionMessage: ""
    }
};
var useContactUs = (0,_alpha_apps_react_common__WEBPACK_IMPORTED_MODULE_0__/* .createStore */ .MT)({
    name: "contactUs",
    devtools: true,
    persist: false
})(initState, function(set) {
    var handler = (0,_alpha_apps_react_common__WEBPACK_IMPORTED_MODULE_0__/* .stateSetterHandler */ .Al)(set);
    return {
        setContactUs: handler("contactUs")
    };
});


/***/ }),

/***/ 42480:
/***/ (function() {

/* (ignored) */

/***/ })

}]);